<template> 
  <div>
    <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
      {{ $t('botWarning2') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center tf_loading">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else class="mb-5">
      <v-container grid-list-lg>
        <v-layout row wrap justify-space-between>
          <!-- SELECTION DU SITE -->
          <v-flex xs6 sm4 md4 >
            <wz-select-one-site-bot
            @update:site="updateSite"
            ></wz-select-one-site-bot>
          </v-flex>

          <!-- BOTS -->
          <v-flex xs6 sm4 md4 v-if="(!isLevelFaq())">
            <!--
            <wz-select-bots
              :bots.sync="bot"
              :botsInit="$store.state._User.bots"
              :min="1"
              @reInitBots="reInitBots"
            ></wz-select-bots>
            -->
            <!--
            <wz-select-bots
              v-if="$store.state._Sites.siteSelected.DSK_BOT_ONOFF == '1'"
              :bot.sync="bot"
              :listeBots="$store.state._User.bots"
              :openFromExt="openListeChatbot"
              @closeListe="closeListe"
              @reInitBots="reInitBots"
            ></wz-select-bots>
            -->
            <div
              v-if="$store.state._Sites.siteSelected.DSK_BOT_ONOFF == '1'"
            >
            <wz-avatar 
              :username=JSON.parse($store.state._Sites.siteSelected.DSK_BOT_USER).user_name
              :src="`${domaine}/public/media/user/small/${JSON.parse($store.state._Sites.siteSelected.DSK_BOT_USER).user_id}_avatar.jpg`"
              size="35px"
            ></wz-avatar>
            {{ JSON.parse($store.state._Sites.siteSelected.DSK_BOT_USER).user_name }}
          </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-expansion-panel v-model="mainOpenAIConfigPanel">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{ $t('AIPromptSys') }}{{ prompt_name ? `: ${prompt_name}` : '' }}</div>
          </template>
          <v-card flat>
            <v-card-text class="pa-0">
      <!-- PROMPS (toujours visible) -->
      <div class="mb-2 prompt-system-section">
          <v-card>
            <v-card-text class="pb-0">
              <div class="text-xs-right">
                <v-tooltip bottom>
                  <template slot="activator">
                    <v-btn icon small :ripple="false" class="prompt-top-icon-btn" @click="enhance('personality')">
                      <v-icon small>auto_fix_high</v-icon>
                    </v-btn>
                  </template>
                  <span>Améliorer par l'IA</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template slot="activator">
                    <v-btn icon small :ripple="false" class="prompt-top-icon-btn" @click="version('personality')">
                      <v-icon small>history</v-icon>
                    </v-btn>
                  </template>
                  <span>*Consulter l'historique des prompts</span>
                </v-tooltip>
              </div></v-card-text>
            <div v-if="loadingPrompt" class="text-xs-center tf_loading">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
            </div>
            <v-card-text v-else>
              <v-container>
                <v-expansion-panel
                  v-model="promptSystemOpenPanels"
                  expand
                  class="prompt-subpanels"
                >
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="prompt-subpanel-header">
                        <div class="prompt-subpanel-title">{{ $t('AIPersonnality') }}<span v-if="isPromptSectionDraft('prompt_personality')" class="prompt-subpanel-draft-inline"><v-icon small class="prompt-subpanel-draft-icon">edit</v-icon><span class="prompt-subpanel-draft-text">brouillon</span><button type="button" class="prompt-subpanel-draft-cancel" @click.stop.prevent="cancelPromptSectionDraft('prompt_personality')">annuler</button></span><v-icon v-else-if="hasPromptSectionContent(prompt_personality)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                        <div class="prompt-subpanel-subtitle">{{ $t('AIPersonnalityDesc') }}</div>
                      </div>
                    </template>
                    <v-card flat>
                      <v-card-text>
                        <v-textarea
                          v-model="prompt_personality"
                          append-outer-icon="auto_fix_high"
                          @click:append-outer="enhance('personality')"
                          counter
                          maxlength="10000"
                        ></v-textarea>
                        <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_personality) }} {{ $t('prompt_tokenestimated') }}</div></v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="prompt-subpanel-header">
                        <div class="prompt-subpanel-title">{{ $t('AIEnviron') }}<span v-if="isPromptSectionDraft('prompt_environment')" class="prompt-subpanel-draft-inline"><v-icon small class="prompt-subpanel-draft-icon">edit</v-icon><span class="prompt-subpanel-draft-text">brouillon</span><button type="button" class="prompt-subpanel-draft-cancel" @click.stop.prevent="cancelPromptSectionDraft('prompt_environment')">annuler</button></span><v-icon v-else-if="hasPromptSectionContent(prompt_environment)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                        <div class="prompt-subpanel-subtitle">{{ $t('AIEnvironDesc') }}</div>
                      </div>
                    </template>
                    <v-card flat>
                      <v-card-text>
                        <v-textarea
                          v-model="prompt_environment"
                          append-outer-icon="auto_fix_high"
                          @click:append-outer="enhance('environment')"
                          counter
                          maxlength="10000"
                        ></v-textarea>
                        <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_environment) }} {{ $t('prompt_tokenestimated') }}</div></v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="prompt-subpanel-header">
                        <div class="prompt-subpanel-title">{{ $t('AIObjective') }}<span v-if="isPromptSectionDraft('prompt_objectif')" class="prompt-subpanel-draft-inline"><v-icon small class="prompt-subpanel-draft-icon">edit</v-icon><span class="prompt-subpanel-draft-text">brouillon</span><button type="button" class="prompt-subpanel-draft-cancel" @click.stop.prevent="cancelPromptSectionDraft('prompt_objectif')">annuler</button></span><v-icon v-else-if="hasPromptSectionContent(prompt_objectif)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                        <div class="prompt-subpanel-subtitle">{{ $t('AIObjectiveDesc') }}</div>
                      </div>
                    </template>
                    <v-card flat>
                      <v-card-text>
                        <v-textarea
                          v-model="prompt_objectif"
                          append-outer-icon="auto_fix_high"
                          @click:append-outer="enhance('objectif')"
                          counter
                          maxlength="10000"
                        ></v-textarea>
                        <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_objectif) }} {{ $t('prompt_tokenestimated') }}</div></v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="prompt-subpanel-header">
                        <div class="prompt-subpanel-title">{{ $t('AICommunication') }}<span v-if="isPromptSectionDraft('prompt_communication')" class="prompt-subpanel-draft-inline"><v-icon small class="prompt-subpanel-draft-icon">edit</v-icon><span class="prompt-subpanel-draft-text">brouillon</span><button type="button" class="prompt-subpanel-draft-cancel" @click.stop.prevent="cancelPromptSectionDraft('prompt_communication')">annuler</button></span><v-icon v-else-if="hasPromptSectionContent(prompt_communication)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                        <div class="prompt-subpanel-subtitle">{{ $t('AICommunicationDesc') }}</div>
                      </div>
                    </template>
                    <v-card flat>
                      <v-card-text>
                        <v-textarea
                          v-model="prompt_communication"
                          append-outer-icon="auto_fix_high"
                          @click:append-outer="enhance('communication')"
                          counter
                          maxlength="10000"
                        ></v-textarea>
                        <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_communication) }} {{ $t('prompt_tokenestimated') }}</div></v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="prompt-subpanel-header">
                        <div class="prompt-subpanel-title">{{ $t('AIQuestion') }}<span v-if="isPromptSectionDraft('prompt_questions')" class="prompt-subpanel-draft-inline"><v-icon small class="prompt-subpanel-draft-icon">edit</v-icon><span class="prompt-subpanel-draft-text">brouillon</span><button type="button" class="prompt-subpanel-draft-cancel" @click.stop.prevent="cancelPromptSectionDraft('prompt_questions')">annuler</button></span><v-icon v-else-if="hasPromptSectionContent(prompt_questions)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                        <div class="prompt-subpanel-subtitle">{{ $t('AIQuestionDesc') }}</div>
                      </div>
                    </template>
                    <v-card flat>
                      <v-card-text>
                        <v-textarea
                          v-model="prompt_questions"
                          append-outer-icon="auto_fix_high"
                          @click:append-outer="enhance('questions')"
                          counter
                          maxlength="10000"
                        ></v-textarea>
                        <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_questions) }} {{ $t('prompt_tokenestimated') }}</div></v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="prompt-subpanel-header">
                        <div class="prompt-subpanel-title">{{ $t('AIRules') }}<span v-if="isPromptSectionDraft('prompt_rules')" class="prompt-subpanel-draft-inline"><v-icon small class="prompt-subpanel-draft-icon">edit</v-icon><span class="prompt-subpanel-draft-text">brouillon</span><button type="button" class="prompt-subpanel-draft-cancel" @click.stop.prevent="cancelPromptSectionDraft('prompt_rules')">annuler</button></span><v-icon v-else-if="hasPromptSectionContent(prompt_rules)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                        <div class="prompt-subpanel-subtitle">{{ $t('AIRulesDesc') }}</div>
                      </div>
                    </template>
                    <v-card flat>
                      <v-card-text>
                        <v-textarea
                          v-model="prompt_rules"
                          append-outer-icon="auto_fix_high"
                          @click:append-outer="enhance('rules')"
                          counter
                          maxlength="10000"
                        ></v-textarea>
                        <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_rules) }} {{ $t('prompt_tokenestimated') }}</div></v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="prompt-subpanel-header">
                        <div class="prompt-subpanel-title">{{ $t('AITools') }}<span v-if="isPromptSectionDraft('prompt_tools')" class="prompt-subpanel-draft-inline"><v-icon small class="prompt-subpanel-draft-icon">edit</v-icon><span class="prompt-subpanel-draft-text">brouillon</span><button type="button" class="prompt-subpanel-draft-cancel" @click.stop.prevent="cancelPromptSectionDraft('prompt_tools')">annuler</button></span><v-icon v-else-if="hasPromptSectionContent(prompt_tools)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                        <div class="prompt-subpanel-subtitle">{{ $t('AIToolsDesc') }}</div>
                      </div>
                    </template>
                    <v-card flat>
                      <v-card-text>
                        <v-textarea
                          v-model="prompt_tools"
                          append-outer-icon="auto_fix_high"
                          @click:append-outer="enhance('tools')"
                          counter
                          maxlength="10000"
                        ></v-textarea>
                        <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_tools) }} {{ $t('prompt_tokenestimated') }}</div></v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="prompt-subpanel-header">
                        <div class="prompt-subpanel-title">{{ $t('AICustom') }}<span v-if="isPromptSectionDraft('prompt_custom')" class="prompt-subpanel-draft-inline"><v-icon small class="prompt-subpanel-draft-icon">edit</v-icon><span class="prompt-subpanel-draft-text">brouillon</span><button type="button" class="prompt-subpanel-draft-cancel" @click.stop.prevent="cancelPromptSectionDraft('prompt_custom')">annuler</button></span><v-icon v-else-if="hasPromptSectionContent(prompt_custom)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                        <div class="prompt-subpanel-subtitle">{{ $t('AICustomDesc') }}</div>
                      </div>
                    </template>
                    <v-card flat>
                      <v-card-text>
                        <v-textarea
                          class="prompt-custom-textarea"
                          v-model="prompt_custom"
                          append-outer-icon="auto_fix_high"
                          @click:append-outer="enhance('custom')"
                          counter
                          maxlength="10000"
                          rows="5"
                          auto-grow
                        ></v-textarea>
                        <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_custom) }} {{ $t('prompt_tokenestimated') }}</div></v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <div class="prompt-llm-block">
                  <v-layout row wrap>
                    <v-flex md4 xs12>
                      <v-select
                        v-model="modelSelect"
                        :items="modelListObject"
                        item-text="name"
                        item-value="tokens"
                        :label="this.$t('AIModele')"
                        persistent-hint
                        return-object
                        @change="changeMethod"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </div>
                <v-layout row wrap v-if="(!isLevelFaq())">
                  <v-flex xs12>
                    <v-subheader class="pl-0 prompt-slider-label">{{ $t('AINumResSearch').toUpperCase() }} : {{ sliderSearchResponse }}</v-subheader>
                    <v-slider
                      class="prompt-slider-tight"
                      v-model="sliderSearchResponse"
                      thumb-label
                      step="1"
                      ticks="always"
                      :max="20"
                      :min="1"
                    ></v-slider>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="(!isLevelFaq())">
                  <v-flex xs12>
                    <v-subheader class="pl-0 prompt-subheader-tight">{{ $t('prompt_elementhtml') }}</v-subheader>
                    <v-text-field
                      v-model="parseElement"
                      :hint="$t('prompt_selector')"
                      persistent-hint
                      placeholder=".className, main, article p"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="(!isLevelFaq())" class="prompt-block-spaced prompt-block-spaced-xl">
                  <v-flex xs12>
                    <v-expansion-panel
                      v-model="promptResumeOpenPanels"
                      expand
                      class="prompt-subpanels"
                    >
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div class="prompt-subpanel-header">
                            <div class="prompt-subpanel-title">{{ $t('prompt_resume') }}</div>
                            <div class="prompt-subpanel-subtitle">{{ $t('preompt_promptresume') }}</div>
                          </div>
                        </template>
                        <v-card flat>
                          <v-card-text class="prompt-panel-body-tight">
                            <v-textarea
                              v-model="promptResume"
                              placeholder="You are preparing content for a Retrieval-Augmented Generation (RAG) system used by a chatbot.

Your task is to analyze the content of a webpage and produce a structured summary optimized for semantic retrieval.

The goal is NOT to shorten the text for humans, but to create a representation that helps the retrieval system determine when this page is relevant to a user question.

Instructions:

1. Identify the main purpose of the page.
2. Extract the key topics covered.
3. List the important entities (product names, features, tools, concepts).
4. Capture the types of questions this page can answer.
5. Keep important keywords and terminology from the original content.
6. Do not include navigation text, cookie notices, or unrelated UI elements.
7. Write in clear, neutral language.
8. Do not hallucinate information not present in the page.

Return the result in the following structure:

PAGE SUMMARY
Short explanation of what this page is about (3-5 sentences).

MAIN TOPICS
- topic 1
- topic 2
- topic 3

KEY ENTITIES
- product names
- features
- tools
- important concepts

QUESTIONS THIS PAGE CAN ANSWER
- question example 1
- question example 2
- question example 3
- question example 4

KEYWORDS
List the most important search keywords from the page.

CONTENT SUMMARY
Provide a concise but information-rich summary preserving the most important facts, explanations, and instructions from the page."
                              counter
                              maxlength="5000"
                            ></v-textarea>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="(!isLevelFaq())" v-show="false" class="prompt-block-spaced">
                  <v-flex xs12>
                    <v-expansion-panel
                      v-model="promptCriteriaOpenPanels"
                      expand
                      class="prompt-subpanels"
                    >
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div class="prompt-subpanel-header">
                            <div class="prompt-subpanel-title">{{ $t('prompt_criteria') }}</div>
                            <div class="prompt-subpanel-subtitle">{{ $t('prompt_define') }}</div>
                          </div>
                        </template>
                        <v-card flat>
                          <v-card-text class="prompt-criteria-body">
                            <v-layout row wrap class="prompt-criteria-grid">
                              <v-flex xs12 md6 class="prompt-criteria-col prompt-criteria-col--left">
                                <div class="prompt-subpanel-title prompt-inner-title">{{ $t('prompt_critaextract') }}</div>
                                <div class="prompt-subpanel-subtitle prompt-inner-subtitle">{{ $t('prompt_examples') }}</div>
                                <v-layout row wrap align-end class="prompt-criteria-input-row">
                                  <v-flex xs12 md10>
                                    <v-text-field
                                      class="prompt-criteria-input"
                                      v-model="liveCriteriaInput"
                                      :placeholder="$t('prompt_addcrit')"
                                      @keyup.enter="addLiveCriterion"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 md2 class="text-xs-right">
                                    <v-btn
                                      class="prompt-criteria-add-btn"
                                      @click="addLiveCriterion"
                                    >
                                      +
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                                <div v-if="liveCriteriaList.length" class="prompt-criteria-chip-list">
                                  <v-chip
                                    v-for="(criterion, idx) in liveCriteriaList"
                                    :key="`live-criterion-${idx}`"
                                    small
                                    class="mr-2 mb-2 prompt-criteria-chip"
                                  >
                                    {{ criterion }}
                                  </v-chip>
                                </div>
                              </v-flex>
                              <v-flex xs12 md6 class="prompt-criteria-col prompt-criteria-col--right">
                                <div class="prompt-criteria-live-card">
                                <div class="prompt-subpanel-title prompt-inner-title prompt-live-title">{{ $t('prompt_livetest') }}</div>
                                <div class="prompt-subpanel-subtitle prompt-inner-subtitle">{{ $t('prompt_quicktest') }}</div>
                                <v-layout row wrap align-end class="prompt-live-input-row">
                                  <v-flex xs12 md8>
                                    <v-text-field
                                      class="prompt-live-input"
                                      v-model="liveTestUrl"
                                      placeholder="https://www.exemple.fr/product/..."
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 md4 class="text-xs-right">
                                    <v-btn
                                      class="prompt-live-test-btn"
                                      @click="openLiveTestUrl"
                                    >
                                      <v-icon left small>play_arrow</v-icon>
                                      {{ $t('prompt_test') }}
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="(!isLevelFaq())" class="prompt-tools-block">
                  <v-flex xs12>
                    <v-subheader class="pl-0 prompt-subheader-tight">{{ $t('prompt_tools') }}</v-subheader>
                    <v-btn
                      small
                      outline
                      class="prompt-tool-add-btn"
                      @click="showToolPicker = !showToolPicker"
                    >
                      {{ $t('prompt_addtool') }}
                    </v-btn>
                    <v-card
                      v-if="showToolPicker"
                      flat
                      class="mt-2 prompt-tool-picker"
                    >
                      <div class="prompt-tool-picker__header">
                        <div class="prompt-tool-picker__title">{{ $t('prompt_choosetool') }}</div>
                        <v-btn
                          icon
                          small
                          class="prompt-tool-picker__close"
                          @click="showToolPicker = false"
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </div>
                      <div class="prompt-tool-picker__body">
                      <div class="prompt-tool-picker__section-title">{{ $t('prompt_systool') }}</div>
                      <v-list dense class="py-0 prompt-tool-picker__list">
                        <v-list-tile
                          v-for="item in functionToolOptionsByGroup('system')"
                          :key="item.value"
                          class="prompt-tool-picker__item"
                          :class="{ 'tool-option-selected': selectedFunctionTools.includes(item.value) }"
                          @click="toggleFunctionTool(item)"
                        >
                          <v-list-tile-action class="prompt-tool-picker__item-icon">
                            <v-icon color="#98a2b3">{{ functionToolIcon(item.value) }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ item.text }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-icon v-if="selectedFunctionTools.includes(item.value)" color="#4f46e5">check</v-icon>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                      <div class="prompt-tool-picker__section-title">{{ $t('prompt_integration') }}</div>
                      <v-list dense class="py-0 prompt-tool-picker__list">
                        <v-list-tile
                          v-for="item in functionToolOptionsByGroup('integration')"
                          :key="item.value"
                          class="prompt-tool-picker__item"
                          :class="{ 'tool-option-selected': selectedFunctionTools.includes(item.value) }"
                          @click="toggleFunctionTool(item)"
                        >
                          <v-list-tile-action class="prompt-tool-picker__item-icon">
                            <v-icon color="#98a2b3">{{ functionToolIcon(item.value) }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ item.text }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-icon v-if="selectedFunctionTools.includes(item.value)" color="#4f46e5">check</v-icon>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                      </div>
                    </v-card>
                    <div v-if="selectedFunctionTools.length" class="mt-2">
                      <v-chip
                        v-for="value in selectedFunctionTools"
                        :key="`tool-${value}`"
                        small
                        class="mr-2 mb-2"
                      >
                        {{ functionToolLabel(value) }}
                      </v-chip>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="prompt-version-meta-block">
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="prompt_name"
                      :label="$t('prompt_nameversion')"
                      maxlength="255"
                      counter
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-text-field
                      v-model="prompt_comment"
                      :label="$t('prompt_whatchange')"
                      :hint="$t('prompt_describe')"
                      persistent-hint
                      maxlength="255"
                      counter
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <!--- prompt global -->
                <v-layout row wrap v-if="0">
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AiPromptGlobal') }}</h3>
                    <v-textarea
                      v-model="prompt"
                      :label="$t('AiPromptGlobalDesc')"
                      counter
					  disabled
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
      </div>
		
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Prompt CSAT{{ prompt_csat_name ? `: ${prompt_csat_name}` : '' }}</div>
          </template>
          <v-card flat>
            <v-card-text class="pa-0">
              <div class="mb-2 prompt-system-section">
                <v-card>
                  <v-card-text class="pb-0">
                    <div class="text-xs-right">
                      <v-tooltip bottom>
                        <template slot="activator">
                          <v-btn icon small :ripple="false" class="prompt-top-icon-btn" @click="enhanceCsat('personality')">
                            <v-icon small>auto_fix_high</v-icon>
                          </v-btn>
                        </template>
                        <span>Ameliorer par l'IA</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template slot="activator">
                          <v-btn icon small :ripple="false" class="prompt-top-icon-btn" @click="versionCsat('personality')">
                            <v-icon small>history</v-icon>
                          </v-btn>
                        </template>
                        <span>Consulter l'historique des prompts ({{ promptCsatVersionCount }})</span>
                      </v-tooltip>
                    </div>
                  </v-card-text>
                  <div v-if="loadingPromptCsat" class="text-xs-center tf_loading">
                    <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
                  </div>
                  <v-card-text v-else>
                    <v-container>
                      <v-expansion-panel v-model="promptCsatOpenPanels" expand class="prompt-subpanels">
                        <v-expansion-panel-content>
                          <template v-slot:header>
                            <div class="prompt-subpanel-header">
                              <div class="prompt-subpanel-title">Contexte et objectif<v-icon v-if="hasPromptSectionContent(prompt_csat_personality)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                              <div class="prompt-subpanel-subtitle">Contexte et objectifs de l evaluateur CSAT</div>
                            </div>
                          </template>
                          <v-card flat><v-card-text>
                            <v-textarea v-model="prompt_csat_personality" append-outer-icon="auto_fix_high" @click:append-outer="enhanceCsat('personality')" counter maxlength="10000"></v-textarea>
                            <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_csat_personality) }} {{ $t('prompt_tokenestimated') }}</div>
                          </v-card-text></v-card>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                          <template v-slot:header>
                            <div class="prompt-subpanel-header">
                              <div class="prompt-subpanel-title">Definition du CSAT<v-icon v-if="hasPromptSectionContent(prompt_csat_mission)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                              <div class="prompt-subpanel-subtitle">Definition du CSAT pour l analyse</div>
                            </div>
                          </template>
                          <v-card flat><v-card-text>
                            <v-textarea v-model="prompt_csat_mission" append-outer-icon="auto_fix_high" @click:append-outer="enhanceCsat('environment')" counter maxlength="10000"></v-textarea>
                            <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_csat_mission) }} {{ $t('prompt_tokenestimated') }}</div>
                          </v-card-text></v-card>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                          <template v-slot:header>
                            <div class="prompt-subpanel-header">
                              <div class="prompt-subpanel-title">Regles de traitement<v-icon v-if="hasPromptSectionContent(prompt_csat_rules)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                              <div class="prompt-subpanel-subtitle">Regles de traitement et d evaluation du score</div>
                            </div>
                          </template>
                          <v-card flat><v-card-text>
                            <v-textarea v-model="prompt_csat_rules" append-outer-icon="auto_fix_high" @click:append-outer="enhanceCsat('objectif')" counter maxlength="10000"></v-textarea>
                            <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_csat_rules) }} {{ $t('prompt_tokenestimated') }}</div>
                          </v-card-text></v-card>
                        </v-expansion-panel-content>
                        <v-expansion-panel-content>
                          <template v-slot:header>
                            <div class="prompt-subpanel-header">
                              <div class="prompt-subpanel-title">Format de sortie attendu<v-icon v-if="hasPromptSectionContent(prompt_csat_block4)" small class="prompt-subpanel-check-icon">check</v-icon></div>
                              <div class="prompt-subpanel-subtitle">Consignes et format de sortie attendu</div>
                            </div>
                          </template>
                          <v-card flat><v-card-text>
                            <v-textarea v-model="prompt_csat_block4" append-outer-icon="auto_fix_high" @click:append-outer="enhanceCsat('communication')" counter maxlength="10000"></v-textarea>
                            <div class="prompt-token-hint">{{ estimatePromptTokens(prompt_csat_block4) }} {{ $t('prompt_tokenestimated') }}</div>
                          </v-card-text></v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-layout row wrap class="mt-3">
                        <v-flex xs12 md6>
                          <v-text-field v-model="prompt_csat_name" label="Nom du prompt CSAT"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field v-model="prompt_csat_comment" label="Commentaire de version"></v-text-field>
                        </v-flex>
                        <v-flex xs12 v-show="false">
                          <v-textarea :value="buildPromptCsatPreview()" label="Preview concatenee" readonly auto-grow rows="8" outline></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{  $t('AIAccueilBot') }}</div>
          </template>
          <v-card flat>
            <v-card-text class="pa-0">

          <template v-slot:header>
            <div></div>
          </template>
          <v-card>
            <div v-if="loadingPrompt" class="text-xs-center tf_loading">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
            </div>
            <v-card-text v-else>
              <v-container>
                <!--- message d'accueil du chatbot -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="messageAccueil"
                      :label="$t('ADMessAcc')"
                      :placeholder="$t('ADMessAccExem')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>


                <!--- Question 1 -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="questionAuto1"
                      :label="$t('AIQuestion1')"
                      :placeholder="$t('AIQuestion1Sample')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!--- Question 2 -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="questionAuto2"
                      :label="$t('AIQuestion2')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!--- Question 3 -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="questionAuto3"
                      :label="$t('AIQuestion3')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!--- Question 4 -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="questionAuto4"
                      :label="$t('AIQuestion4')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap >
                  <!--- envoyer directement le message, ou non -->
                  <v-flex xs12>
                    <v-switch 
                      :label="comportment ? $t('AIQuestionClickChoicesSend'): $t('AIQuestionClickChoicesDisplay')"
                      light
                      v-model="comportment"
                      color="primary"
                      @change="switchComportment()"
                    ></v-switch>
                  </v-flex>
                </v-layout>
				
                <v-layout row wrap >
                  <!--- afficher la petite phrase au dessus -->
                  <v-flex xs12>
                    <v-switch 
                      :label="showEx ? $t('AIExempleShow') + ' ON' : $t('AIExempleShow') + ' OFF'"
                      light
                      v-model="showEx"
                      color="primary"
                      @change="switchExemple()"
                    ></v-switch>
                  </v-flex>
                </v-layout>

                <!--- exemple de dialogue utilisé dans le prompt de chat -->
                <!---<v-flex xs12 v-if="(!isLevelFaq())">
                  <h3 class="headline mb-0">{{ $t('AIExempChat')}}</h3>
                  <v-textarea
                    v-model="dialog"
                    :label="$t('AIExempChatTxt')"
                    :placeholder="$t('AIExempChatPH')"
                    counter
                    maxlength="1500"
                  ></v-textarea>
                </v-flex>-->
              </v-container>
            </v-card-text>
          </v-card>

            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{ $t('prompt_kb') }}</div>
          </template>
          <v-card flat>
            <v-card-text class="pa-0">
              <v-expansion-panel class="knowledge-nested-panels">
        <!-- Urls utilisées pour le bot -->
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{ $t('AIURLTitle')}} ({{ totalUrl }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout >
                <!-- Actions pour la selection -->
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderUrl[0]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-3">
                  <v-range-slider
                    v-model="rangeSliderUrl"
                    :max="totalUrl"
                    :min="minSliderUrl"
                  ></v-range-slider>
                </v-flex>
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderUrl[1]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex x12 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingData"
                      @click.native="loadUrlsClient('actif')"
                    >
                      {{ $t('AIBtnReload') }}
                    </v-btn>
                  </div>
                </v-flex>
                </v-layout>
                <!-- Actions pour la selection -->
                <v-layout row wrap justify-space-between>
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionUrl"
                    :items="computedActionUrl"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedUrls.length"
                    :label="$t('actions')"
                    @change="actionsUrl()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm3>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    :label="$t('search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingCheckSitemap"
                      @click.native="checkUrls"
                    >
                      {{ $t('searchUrl') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingStartEmbedding"
                      :disabled="!modifKeywords"
                      @click.native="startEmbedding"
                    >
                      {{ $t('startEmbedding') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedUrls"
                    :headers="headers"
                    :items="urls"
                    :search="search"
                    item-key="url"
                    select-all
                    :loading="loadingData"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200, 500, 1000]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td v-if="props.item && props.item.new" class="text-xs-left">{{ props.item.url }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogUpdateKeyword(props.item)">{{ props.item.url }}</td>

                      <td v-if="props.item && props.item.timestamp" class="text-xs-left">{{ props.item.timestamp }}</td>
                      <td v-else class="text-xs-left"> -- </td>

                      <td v-if="props.item && props.item.error" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="red darken-2" dark >error</v-icon>
                          </template>
                          <span>{{$t('AIErrorSave')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="green darken-2" dark >add_circle</v-icon>
                          </template>
                          <span>{{$t('AINewAddURL')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.updated" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="orange darken-2" dark >update</v-icon>
                          </template>
                          <span>{{$t('AIModifKeys')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="grey lighten-1" dark>info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyNotDispo')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateKeyword(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyEdit')}}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <a :href=props.item.url target="blank"><v-icon class="infos" color="black lighten-1" dark>remove_red_eye</v-icon></a>
                          </template>
                          <span>{{$t('AIseePage')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-if="props.item && props.item.locked" class="text-xs-center">
                        <!-- verrouiller -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon small class="infos" color="black lighten-1" dark>lock</v-icon>
                          </template>
                          <span>{{$t('AIlockURL')}}</span>
                        </v-tooltip>
                      </td>

                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- Urls non utilisées -->
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{ $t('AINoURLTitle')}} ({{ totalUrlInactif }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <!-- Actions pour la selection -->
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionSuppUrl"
                    :items="computedActionSuppUrl"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedSuppUrls.length"
                    :label="$t('actions')"
                    @change="actionsSuppUrl()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs2>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm4>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      :label="$t('search')"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedSuppUrls"
                    :headers="headersSupp"
                    :items="listeAllDelUrl"
                    :search="search"
                    item-key="url"
                    select-all
                    :loading="loadingDataInactif"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="text-xs-left">{{ props.item.url }}</td>
                      <td class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <a :href=props.item.url target="blank"><v-icon class="infos" color="black lighten-1" dark>remove_red_eye</v-icon></a>
                          </template>
                          <span>{{$t('AIseePage')}}</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- Documents utilisés pour le bot -->
        <v-expansion-panel-content >
          <template v-slot:header>
            <div>{{  $t('AIDocTitle') }}</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <!-- Actions pour la selection -->
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionFile"
                    :items="computedActionFile"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedFiles.length"
                    :label="$t('actions')"
                    @change="actionsFile()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs2 sm1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm5>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    :label="$t('search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      @click.native="importFile"
                    >
                      {{ $t('importDoc') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs1 sm1>
                  <v-spacer></v-spacer>
                </v-flex>

                <v-flex xs12>
                  <v-data-table
                    v-model="selectedFiles"
                    :headers="headersFile"
                    :items="files"
                    :search="search"
                    item-key="file"
                    select-all
                    :loading="loadingDataFiles"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200]"
                  >
                    <template v-slot:progress><v-progress-linear height="2" color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td v-if="props.item.numChunk" class="text-xs-left" @click.stop="openDialogChunkFile(props.item)">{{ props.item.file }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogFile(props.item)">{{ props.item.file }}</td>

                      <td v-if="props.item.numChunk" class="text-xs-left" @click.stop="openDialogChunkFile(props.item)">{{ props.item.numChunk }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogFile(props.item)">résumé</td>
                      <td class="text-xs-center px-2">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogChunkFile(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('affSegDoc')}}</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- FAQ -->
        <v-expansion-panel-content >
          <template v-slot:header>
            <div>FAQ ({{ faqs.length }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <!-- Actions pour la selection -->
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionFAQ"
                    :items="computedActionFAQ"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedFaqs.length"
                    :label="$t('actions')"
                    @change="actionsFAQ()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs1 sm1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les FAQ -->
                <v-flex xs6 sm5>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      :label="$t('search')"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      @click.native="newFAQ"
                    >
                      {{ $t('addFaq')}}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs1 sm1>
                  <v-spacer></v-spacer>
                </v-flex>

                <v-flex xs12>
                  <v-data-table
                    v-model="selectedFaqs"
                    :headers="headersFAQ"
                    :items="faqs"
                    :search="search"
                    item-key="index"
                    select-all
                    :loading="loadingData"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <tr>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="props.selected"
                            primary
                            hide-details
                          ></v-checkbox>
                        </td>
                        <td class="text-xs-right" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.index }}</td>
                        <td class="text-xs-left" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.question }}</td>
                        <td class="text-xs-left"  @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.reponse }}</td>
                        <td class="text-xs-right">
                          <!-- Editer -->
                          <v-tooltip left >
                            <template slot="activator">
                              <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateFAQ(props.item)" >edit</v-icon>
                            </template>
                            <span>{{$t('editFAQ')}}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{$t('prompt_advanced')}}</div>
          </template>
          <v-card flat>
            <v-card-text class="pa-0">
              <v-expansion-panel class="knowledge-nested-panels">
        <!-- Description/Parametres -->
        <v-expansion-panel-content >
          <template v-slot:header>
            <div>{{  $t('AIDescTitle') }}</div>
          </template>
          <v-card>
            <div v-if="loadingPrompt" class="text-xs-center tf_loading">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
            </div>
            <v-card-text v-else>
              <v-container>
                <!--- url du site à parser -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="parseUrl"
                      :label="$t('AIScanUrl')"
                      placeholder="www.website.com"
                    ></v-text-field>
                  </v-flex>
                </v-layout>


                <v-layout row wrap v-if="(!isLevelFaq())">
                  <!--- instruction du prompt de recherche -->
                  <v-flex xs12 v-if="(!isLevelFaq())">
                    <h3 class="headline mb-0">{{ $t('AIPromptResSearch') }}</h3>
                    <v-textarea
                      v-model="promptSearch"
                      :label="$t('AIPromptResSearchTxt')"
                      counter
                      maxlength="5000"
                    ></v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout row wrap v-if="(!isLevelFaq())">
                  <!--- selectionne automatiquement le premier produit du carrousel -->
                  <v-flex xs12>
                    <v-switch
                      v-model="productSelectAuto"
                      :label="$t('AIProdSelect')"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="(!isLevelFaq())">
                  <v-flex md4 xs12
                    v-if="isGptModel"
                  >
                    <v-select
                      v-model="APISelect"
                      :items="APIListObject"
                      item-text="name"
                      :label="this.$t('APIModele')"
                      persistent-hint
                      return-object
                      @change="changeMethod"
                    ></v-select>
                  </v-flex>
                  <v-flex md3 xs12>
                    <v-switch
                      v-model="botStream"
                      :label="this.$t('AILLMStream')"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="(!isLevelFaq()) && showTempAndTokenInputs">
                  <v-flex md6 xs12>
                    <v-subheader class="pl-0 prompt-slider-label">{{ $t('AILLMTemp') }} {{ sliderTemp }}</v-subheader>
                    <v-slider
                      class="prompt-slider-tight"
                      v-model="sliderTemp"
                      thumb-label
                      step="0.01"
                      ticks="always"
                      :max="maxTemp"
                      :min="minTemp"
                    ></v-slider>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-subheader class="pl-0 prompt-slider-label">max token {{ sliderTokenResponse }}</v-subheader>
                    <v-slider
                      class="prompt-slider-tight"
                      v-model="sliderTokenResponse"
                      thumb-label
                      step="10"
                      ticks="always"
                      :max="maxToken"
                      :min="minToken"
                    ></v-slider>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- parsing Selectif -->
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{ $t('AIParsPageTitle') }} ({{ parsingSelectif.length }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-container>
                <!--- element pour le parsing du contenu html -->
                <v-layout row wrap>
                  <!--- JSON pour les function_call -->
                  <v-flex xs12>
                    {{ $t('AIParsPageTxt') }}
                    <v-expansion-panel>
                      <v-expansion-panel-content
                        v-for="(parsing, i) in parsingSelectif"
                        :key="i"
                      >
                        <template v-slot:header>
                          <div><strong>{{parsing.name}}</strong></div>
                        </template>
                        <!--- element pour le parsing du contenu html -->
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex md3 xs6>
                                <v-text-field
                                  v-if="!parsing.default"
                                  v-model="parsing.name"
                                  :label="$t('AIParsPageUrl')"
                                  :placeholder="$t('AIParsPageUrl')"

                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="parsing.name"
                                  :label="$t('AIParsPageDefaut')"
                                  disabled
                                ></v-text-field>
                              </v-flex>

                              <v-flex md3 xs6>
                                <v-select
                                  v-model="parsing.methode"
                                  :items="methodList"
                                  :label="$t('AIParsPageMethode')"

                                ></v-select>
                              </v-flex>
                              <v-flex md5 xs11>
                                <v-textarea
                                  v-model="parsing.elements"
                                  :label="$t('AIScanHtml')"
                                  :hint="$t('AIParsPageExem')"
                                  persistent-hint
                                  box
                                >
                                </v-textarea>
                              </v-flex>
                              <v-flex md1 xs1
                                v-if="!parsing.default"
                              >
                                <v-tooltip left >
                                  <template slot="activator">
                                    <v-btn
                                      flat
                                      icon
                                      color="red lighten-2"
                                      @click.native="delParsing(parsing)"
                                    >
                                      <v-icon>delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{$t('AISuppParse')}}</span>
                                </v-tooltip>
                              </v-flex>

                              
                            </v-layout>
                          </v-card-text>
                        </v-card>
                        
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    
                    <div >
                      <v-btn flat icon color="primary"
                        @click.native="addParsing"
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                      {{  $t('AIAddParse') }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- Appel de fonction -->
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{  $t('AIFunctionTitle') }} ({{ fonctionsNum }}/9)</div>
          </template>
          <v-card>
            <v-card-text>
              <v-container>
                <!--- element pour le parsing du contenu html -->
                <v-layout row wrap>
                  <!--- JSON pour les function_call -->
                  <v-flex xs12>
                    {{  $t('AIFunctionContent') }}
                    <v-expansion-panel>
                      <v-expansion-panel-content
                        v-for="(fonction, i) in fonctions"
                        :key="i"
                      >
                        <template v-slot:header>
                          <div
                            :style="functionCallOnOff[i] ? 'opacity: 1' : 'opacity: 0.5'"
                          ><strong>{{fonction.name ? fonction.name : fonction.type}}</strong> : ({{ fonction.description }})</div>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-switch
                              v-model="functionCallOnOff[i]"
                              :label="`Tool ${i}: ${(functionCallOnOff[i] ? 'ON' : 'OFF')}`"
                            ></v-switch>
                            <v-textarea
                              v-if="i === 0"
                              v-model="function0"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 1"
                              v-model="function1"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 2"
                              v-model="function2"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 3"
                              v-model="function3"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 4"
                              v-model="function4"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 5"
                              v-model="function5"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 6"
                              v-model="function6"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 7"
                              v-model="function7"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 8"
                              v-model="function8"
                            ></v-textarea>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-card v-if="addFonctionsNum === 1 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function0"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 2 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function1"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 3 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function2"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 4 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function3"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 5 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function4"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 6 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function5"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 7 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function6"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 8 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function7"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 9 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function8"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>

                    <div v-if="(addFonctionsNum - fonctionsNum) === 0 && fonctionsNum < 8 && addFonctionsNum < 8">
                      <v-btn flat icon color="primary"
                        @click.native="addFunction"
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                      {{ $t('AIAddFunction')}}
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- produits utilisés pour le bot (API)-->
        <v-expansion-panel-content
          :class="[ getPermissions ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AIResumeTitle')}}</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout row wrap justify-space-between>

                <v-flex xs2 v-if="products.length">
                  <v-btn
                    color="primary"
                    :loading="loadingResumePromptAPI"
                    :disabled="loadingResumePromptAPI || !selectedProduct.length"
                    @click.native="testPromptResumeAPI"
                  >
                    {{ $t('Test') }} api
                  </v-btn>
                </v-flex>

                <v-flex xs8 v-if="products.length">
                  <v-select
                    v-model="selectedProduct"
                    :items="products"
                    item-text="product"
                    item-value="product"
                    :hint="selectedProduct.product"
                    :label="this.$t('AIResumeApiID')"
                  ></v-select>
                </v-flex>
                <v-flex xs2 v-if="products.length"></v-flex>

                <v-flex xs2 v-if="urls.length">
                  <v-btn
                    color="primary"
                    :loading="loadingResumePrompt"
                    :disabled="loadingResumePrompt || !selectedUrl.length"
                    @click.native="testPromptResume"
                  >
                    {{ $t('Test') }} url
                  </v-btn>
                </v-flex>
                <v-flex xs8  v-if="urls.length">
                  <v-select
                    v-model="selectedUrl"
                    :items="urls"
                    item-text="url"
                    item-value="url"
                    :hint="selectedUrl.url"
                    :label="this.$t('AIResumeURL')"
                  ></v-select>

                  <br />

                  <div v-if="loadingResumePrompt || loadingResumePromptAPI" class="text-xs-center tf_loadingResume">
                    <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
                  </div>
                  <div v-else>
                    <p>{{ $t('AIResume') }} <br><strong>{{ contentResume }}</strong></p>

                    <v-textarea
                      name="contentResumeKeys"
                      :label="this.$t('AIResumCritere')"
                      auto-grow
                      :value='contentResumeKeys'
                      readonly
                    >
                    </v-textarea>
                  </div> 
                </v-flex>
                <v-flex xs2></v-flex>

              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- produits utilisés pour le bot (API)-->
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{  $t('AIProdTitle') }} ({{ totalProduct }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout >
                <!-- Actions pour la selection -->
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderProduct[0]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-3">
                  <v-range-slider
                    v-model="rangeSliderProduct"
                    :max="totalProduct"
                    :min="minSliderProduct"
                  ></v-range-slider>
                </v-flex>
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderProduct[1]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex x12 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingData"
                      @click.native="loadProductsClient"
                    >
                      {{ $t('AIBtnReload') }}
                    </v-btn>
                  </div>
                </v-flex>
                </v-layout>
                <!-- Actions pour la selection -->
                <v-layout row wrap justify-space-between>
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionProduct"
                    :items="computedActionProduct"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedProducts.length"
                    :label="$t('actions')"
                    @change="actionsProduct()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm3>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      :label="$t('search')"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingCheckSitemap"
                      @click.native="checkProduct"
                    >
                      {{ $t('searchUrl') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingStartEmbedding"
                      :disabled="!modifKeywordsProduct"
                      @click.native="startEmbeddingAPI"
                    >
                      {{ $t('startEmbedding') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedProducts"
                    :headers="headersProduct"
                    :items="products"
                    :search="search"
                    item-key="product"
                    select-all
                    :loading="loadingData"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200, 500, 1000]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td v-if="props.item && props.item.new" class="text-xs-left">{{ props.item.product }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogUpdateKeywordProduct(props.item)">{{ props.item.product }}</td>

                      <td v-if="props.item && props.item.timestamp" class="text-xs-left">{{ props.item.timestamp }}</td>
                      <td v-else class="text-xs-left"> -- </td>

                      <td v-if="props.item && props.item.error" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="red darken-2" dark >error</v-icon>
                          </template>
                          <span>{{$t('AIErrorSave')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="green darken-2" dark >add_circle</v-icon>
                          </template>
                          <span>{{$t('AINewAddURL')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.updated" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="orange darken-2" dark >update</v-icon>
                          </template>
                          <span>{{$t('AIModifKeys')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="grey lighten-1" dark>info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyNotDispo')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateKeywordProduct(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyEdit')}}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <a :href=props.item.url target="blank"><v-icon class="infos" color="black lighten-1" dark>remove_red_eye</v-icon></a>
                          </template>
                          <span>{{$t('AIseePage')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-if="props.item && props.item.locked" class="text-xs-center">
                        <!-- verrouiller -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon small class="infos" color="black lighten-1" dark>lock</v-icon>
                          </template>
                          <span>{{$t('AIlockURL')}}</span>
                        </v-tooltip>
                      </td>

                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- produits utilisés pour le bot (URL)-->
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{  $t('AIProdURLTitle') }} ({{ totalURLProduct }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout >
                <!-- Actions pour la selection -->
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderURLProduct[0]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-3">
                  <v-range-slider
                    v-model="rangeSliderURLProduct"
                    :max="totalURLProduct"
                    :min="minSliderURLProduct"
                  ></v-range-slider>
                </v-flex>
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderURLProduct[1]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex x12 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingData"
                      @click.native="loadURLProductsClient"
                    >
                      {{ $t('AIBtnReload') }}
                    </v-btn>
                  </div>
                </v-flex>
                </v-layout>
                <!-- Actions pour la selection -->
                <v-layout row wrap justify-space-between>
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionURLProduct"
                    :items="computedActionUrl"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedURLProducts.length"
                    :label="$t('actions')"
                    @change="actionsURLProduct()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm3>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      :label="$t('search')"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingCheckSitemap"
                      @click.native="checkURLProduct"
                    >
                      {{ $t('searchUrl') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingStartEmbedding"
                      :disabled="!modifKeywordsURLProduct"
                      @click.native="startEmbeddingURLProduct"
                    >
                      {{ $t('startEmbedding') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedURLProducts"
                    :headers="headers"
                    :items="URLProducts"
                    :search="search"
                    item-key="url"
                    select-all
                    :loading="loadingData"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200, 500, 1000]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td v-if="props.item && props.item.new" class="text-xs-left">{{ props.item.url }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogUpdateKeywordURLProduct(props.item)">{{ props.item.url }}</td>

                      <td v-if="props.item && props.item.timestamp" class="text-xs-left">{{ props.item.timestamp }}</td>
                      <td v-else class="text-xs-left"> -- </td>

                      <td v-if="props.item && props.item.error" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="red darken-2" dark >error</v-icon>
                          </template>
                          <span>{{$t('AIErrorSave')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="green darken-2" dark >add_circle</v-icon>
                          </template>
                          <span>{{$t('AINewAddURL')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.updated" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="orange darken-2" dark >update</v-icon>
                          </template>
                          <span>{{$t('AIModifKeys')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="grey lighten-1" dark>info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyNotDispo')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateKeywordURLProduct(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyEdit')}}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <a :href=props.item.url target="blank"><v-icon class="infos" color="black lighten-1" dark>remove_red_eye</v-icon></a>
                          </template>
                          <span>{{$t('AIseePage')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-if="props.item && props.item.locked" class="text-xs-center">
                        <!-- verrouiller -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon small class="infos" color="black lighten-1" dark>lock</v-icon>
                          </template>
                          <span>{{$t('AIlockURL')}}</span>
                        </v-tooltip>
                      </td>

                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- Analyse de la conversation -->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AIAnalysTitle')}}</div>
          </template>
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="body-2 pl-3" v-html ="this.$t('AIAnalysExemple')">
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <!-- Actions pour la selection -->
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionAnalyseChat"
                    :items="computedActionAnalyseChat"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedAnalyseChat.length"
                    :label="$t('actions')"
                    @change="actionsAnalyseChat()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs2>
                  <v-spacer></v-spacer>
                </v-flex>
                <v-flex xs6 sm3>
                </v-flex>
                <v-flex xs6 sm2>
                  <v-btn
                    outline
                    color="primary"
                    @click.native="addAnalyseChat"
                  >
                    {{ $t('AIAnalysAdd') }}
                  </v-btn>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedAnalyseChat"
                    :headers="headersAnalyseChat"
                    :items="analyseChat"
                    item-key="q"
                    select-all
                    class="elevation-1"
                  >
                    <template v-slot:progress><v-progress-linear height="2" color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="text-xs-left" @click.stop="openDialogModifAnalyseChat(props.item)">{{ props.item.q }}</td>
                      <td class="text-xs-left" @click.stop="openDialogModifAnalyseChat(props.item)">{{ props.item.a }}</td>
                      <td class="text-xs-center px-2">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogModifAnalyseChat(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('affSegDoc')}}</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- Statistiques -->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AIStatTitle')}}</div>
          </template>
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="body-2 pl-3">
                  {{ $t('AIStatContent')}}
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <v-flex xs12 >
                  <v-layout row wrap>
                    <v-flex xs12 md4>

                      <v-select 
                        dense
                        :items="periods" 
                        v-model="period"
                        :label="$t('period') | cap"
                        prepend-icon="date_range"
                      ></v-select>
                    </v-flex>
                    <v-flex md2>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-dialog
                        v-model="modalStart"
                        lazy
                        full-width
                        width="290px"
                        :disabled="period != 0"
                      >
                        <v-text-field
                          slot="activator"
                          :label="$t('startDate') | cap"
                          v-model="dateStartDisplayed"
                          @blur="dateStartPicker = parseDate(dateStartDisplayed)"
                          prepend-icon="event"
                          readonly
                          :disabled="period != 0"
                        ></v-text-field>
                        <v-date-picker
                          v-model="dateStartPicker"
                          @input="dateStartDisplayed = formatDate($event); modalStart = false"
                          :first-day-of-week="1"
                          :min="allowedDatesStart.min"
                          :max="allowedDatesStart.max"
                          :locale="$i18n.locale"
                          scrollable
                          color="primary"
                        >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-dialog
                        v-model="modalEnd"
                        lazy
                        full-width
                        width="290px"
                        :disabled="period != 0"
                      >
                        <v-text-field
                          slot="activator"
                          :label="$t('endDate') | cap"
                          v-model="dateEndDisplayed"
                          @blur="dateEndPicker = parseDate(dateEndDisplayed)"
                          prepend-icon="event"
                          readonly
                          :disabled="period != 0"
                        ></v-text-field>
                        <v-date-picker
                          v-model="dateEndPicker"
                          @input="dateEndDisplayed = formatDate($event); modalEnd = false"
                          :first-day-of-week="1"
                          :min="allowedDatesEnd.min"
                          :max="allowedDatesEnd.max"
                          :locale="$i18n.locale"
                          scrollable
                          color="primary"
                        >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 sm3 md2>
                  <div class="grey--text text--darken-2">{{ $t('AIStatsTP') | cap }}</div>
                  <div class="headline teal--text">{{ nbPrompt }}</div>
                </v-flex>
                <v-flex xs6 sm3 md2>
                  <div class="grey--text text--darken-2">{{ $t('AIStatTC') | cap }}</div>
                  <div class="headline blue--text">{{ nbCompletion }}</div>
                </v-flex>
                <v-flex xs6 sm3 md2>
                  <div class="grey--text text--darken-2">{{ $t('AIStatTT') | cap }}</div>
                  <div class="headline pink--text">{{ nbTotal }}</div>
                </v-flex>
                <v-flex xs6 sm6 md2>
                  <v-select 
                    :label="$t('dataInterval') | cap"
                    :items="intervals" 
                    v-model="interval" 
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm6 md2>
                  <v-select 
                    :label="$t('AIStatT') | cap"
                    :items="utilisations" 
                    v-model="utilisation" 
                    return-object
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs6 sm3 md2>
                  <div class="grey--text text--darken-2">{{ $t('conversationRate') | cap }}</div>
                  <div class="headline primary--text">{{ conversation }} %</div>
                </v-flex> -->
              </v-layout>
              <highcharts :options="options"></highcharts>
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <div><v-icon>info</v-icon> {{ $t('AIStatDetail')}}</div>
                  </template>
                  <v-card>
                    <v-card-title>
                    </v-card-title>
                    <v-card-text>
                      <v-layout row wrap>
                        <!--- liste de toutes les stats de la période -->
                        <v-flex xs6 sm3>
                            <v-text-field
                              v-model="searchTokens"
                              append-icon="search"
                              :label="this.$t('search')"
                              single-line
                              hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-data-table
                            :headers="headersTokens"
                            :items="tokens"
                            :search="searchTokens"
                            item-key="timestamp"
                            :loading="loadingStatsToken"
                            class="elevation-1"
                            :rows-per-page-items="[10, 25, 50, 100, 200]"
                          >
                            <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                            <template v-slot:items="props">
                              <td class="text-xs-left">{{ afficheDate(props.item.timestamp) }}</td>
                              <td class="text-xs-left">{{ props.item.session_chat }}</td>
                              <td class="text-xs-left">{{ props.item.description }}</td>
                              <td class="text-xs-left">{{ props.item.model }}</td>
                              <td class="text-xs-left">{{ props.item.tokens_prompt }}</td>
                              <td class="text-xs-left">{{ props.item.tokens_completion }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- Traitement automatique des données. -->
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>{{ $t('AIDataAutoTitle') }}</div>
          </template>
          <v-card>
            <div v-if="loadingPrompt" class="text-xs-center tf_loading">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
            </div>
            <v-card-text v-else>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <strong>{{ $t('AIDataSitemap')}}</strong>
                  </v-flex>
                  <v-flex xs12 lg6>
                    <!--- instruction du prompt de chat -->
                    <v-layout row wrap>
                      <v-flex xs12>
                        <div v-html="this.$t('AIDataExempl')"></div>
                      </v-flex>

                      <v-flex xs12>
                        <v-text-field
                          :label="this.$t('AIDataScann')"
                          v-model="pageScanne"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-flex xs12>
                          {{$t('AIDataPeriod')}}
                        </v-flex>
                        <v-slider
                          v-model="timeSelected"
                          :tick-labels="timeLabels"
                          :max="3"
                          step="1"
                          ticks="always"
                          tick-size="2"
                        ></v-slider>
                      </v-flex>

                      <!--- mise à jour auto par tache cron -->
                      <v-flex xs12 md6>
                        <v-switch
                          v-model="majCronTab"
                          :label="this.$t('AIDataMAJ')"
                        ></v-switch>
                      </v-flex>

                      <v-flex xs12 md6>
                        <v-switch
                          :disabled=!majCronTab
                          v-model="majUrlAuto"
                          :label="this.$t('AIDataSave')"
                        ></v-switch>
                      </v-flex>

                      <v-flex xs8 v-if="afficheStatusCron">
                        <v-alert
                          v-if="statusSaveCron"
                          :value="true"
                          color="success"
                          icon="check_circle"
                          outline
                        >
                        {{ infoCron }}
                        </v-alert>
                        <v-alert
                          v-else
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                        >
                        {{ infoCron }}
                        </v-alert>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div class="save-prompt-actions">
        <v-btn
          block
          class="save-prompt-btn"
          :class="modifPrompt ? 'save-prompt-btn--ready' : 'save-prompt-btn--idle'"
          :loading="loadingSavePrompt"
          :disabled="loadingSavePrompt || !modifPrompt"
          @click.native="savePrompt"
        >
          <v-icon left>save</v-icon>
          {{ $t('prompt_save') }}
        </v-btn>
      </div>
    </div>

    <!-- Document Delete confirmation analyse chat -->
    <v-dialog
      v-model="showDialogDeleteParsing"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('suppPars')"
        :contentDialogConfirm="SelectedParsingSupp.name"
        :showDialogConfirmation="false"
        @closeDialogConfirm="justCloseDialogConfirmParsing"
        @justCloseDialogConfirm="justCloseDialogConfirmParsing"
        @submitDialogConfirm="submitDeleteParsing"
      ></wz-dialog-confirm>
    </v-dialog> 
    <!-- Document Delete confirmation parsing -->
    <v-dialog
      v-model="showDialogDeleteAnalyseChat"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedAnalyseChat.length > 1 ? $t('suppAnalysChat-s') : $t('suppAnalysChat')"
        :contentDialogConfirm="listeSelectedAnalyseChat"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifAnalyseChat"
        @closeDialogConfirm="justCloseDialogConfirmAnalyseChat"
        @justCloseDialogConfirm="justCloseDialogConfirmAnalyseChat"
        @submitDialogConfirm="submitDeleteAnalyseChatConfirm"
      ></wz-dialog-confirm>
    </v-dialog> 
    <!-- Document Delete confirmation -->
    <v-dialog
      v-model="showDialogDeleteFile"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedFiles.length > 1 ? $t('suppFile-s') : $t('suppFile')"
        :contentDialogConfirm="listeSelectedFile"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifFile"
        @closeDialogConfirm="justCloseDialogConfirmFile"
        @justCloseDialogConfirm="justCloseDialogConfirmFile"
        @submitDialogConfirm="submitDeleteFileConfirm"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- URL actives locked confirmation -->
    <v-dialog
      v-model="showDialogLock"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedUrls.length > 1 ? $t('lockURL-s') : $t('lockURL')"
        :contentDialogConfirm="listeSelectedUrl"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogLock"
        @justCloseDialogConfirm="justCloseDialogLock"
        @submitDialogConfirm="submitLockConfirm"
      ></wz-dialog-confirm>
    </v-dialog>

    <!-- URL produits actives locked confirmation -->
    <v-dialog
      v-model="showDialogLockURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedURLProducts.length > 1 ? $t('lockURL-s') : $t('lockURL')"
        :contentDialogConfirm="listeSelectedURLProduct"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogLock"
        @justCloseDialogConfirm="justCloseDialogLock"
        @submitDialogConfirm="submitLockConfirmURLProduct"
      ></wz-dialog-confirm>
    </v-dialog>

    <!-- produit actives locked confirmation -->
    <v-dialog
      v-model="showDialogLockProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedProducts.length > 1 ? $t('lockProd-s') : $t('lockProd')"
        :contentDialogConfirm="listeSelectedProduct"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogLock"
        @justCloseDialogConfirm="justCloseDialogLock"
        @submitDialogConfirm="submitLockConfirmProduct"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- FAQs Delete confirmation -->
    <v-dialog
      v-model="showDialogDeletesFAQ"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedFaqs.length > 1 ? $t('suppFAQ-s') : $t('suppFAQ')"
        :contentDialogConfirm="listeSelectedFAQ"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirmFAQ"
        @justCloseDialogConfirm="justCloseDialogConfirmFAQ"
        @submitDialogConfirm="submitDeleteConfirmFAQ"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- URL actives Delete confirmation -->
    <v-dialog
      v-model="showDialogDelete"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedUrls.length > 1 ? $t('suppURL-s') : $t('suppURL')"
        :contentDialogConfirm="listeSelectedUrl"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitDeleteConfirm"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- Produit actives Delete confirmation -->
    <v-dialog
      v-model="showDialogDeleteProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedProducts.length > 1 ? $t('suppProd-s') : $t('suppProd')"
        :contentDialogConfirm="listeSelectedProduct"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitDeleteConfirmProduct"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- Produit actives Delete confirmation -->
    <v-dialog
      v-model="showDialogDeleteURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedURLProducts.length > 1 ? $t('suppProd-s') : $t('suppProd')"
        :contentDialogConfirm="listeSelectedURLProduct"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitDeleteConfirmURLProduct"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- URL inactives Delete confirmation -->
    <v-dialog
      v-model="showDialogDeleteSupp"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedSuppUrls.length > 1 ? $t('suppURL-s') : $t('suppURL')"
        :contentDialogConfirm="listeSelectedSuppUrl"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirmSupp"
        @justCloseDialogConfirm="justCloseDialogConfirmSupp"
        @submitDialogConfirm="submitDeleteConfirmSupp"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- Embedding confirmation -->
    <v-dialog
      v-model="showDialogEmbedding"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('startEmbedding')"
        :contentDialogConfirm="$t('startEmbeddingText') + '<strong>' + siteSelected.LIC_KEY + '</strong>'" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingEmbeddingUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogEmdedding"
        @justCloseDialogConfirm="justCloseDialogEmdedding"
        @submitDialogConfirm="submitEmbeddingConfirm"
      ></wz-dialog-confirm>
    </v-dialog>

    <!-- Embedding confirmation urls product -->
    <v-dialog
      v-model="showDialogEmbeddingURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('startEmbedding')"
        :contentDialogConfirm="$t('startEmbeddingText') + '<strong>' + siteSelected.LIC_KEY + '</strong>'" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingEmbeddingUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogEmdeddingURLProduct"
        @justCloseDialogConfirm="justCloseDialogEmdeddingURLProduct"
        @submitDialogConfirm="submitEmbeddingURLProductConfirm"
      ></wz-dialog-confirm>
    </v-dialog>


    <!-- Embedding confirmation API -->
    <v-dialog
      v-model="showDialogEmbeddingAPI"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('startEmbeddingAPI')"
        :contentDialogConfirm="$t('startEmbeddingAPIText') + '<strong>' + siteSelected.LIC_KEY + '</strong>'" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingEmbeddingUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogEmdeddingAPI"
        @justCloseDialogConfirm="justCloseDialogEmdeddingAPI"
        @submitDialogConfirm="submitEmbeddingAPIConfirm"
      ></wz-dialog-confirm>
    </v-dialog>

    <!-- dialog modif keyword -->
    <v-dialog
      v-model="showDialogModifKeyword"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-openai-keyword
        :type="'url'"
        :titleDialog="$t('modifKeywords')"
        :afficheDialog="showDialogModifKeyword"
        :dataDialog="keywordUrl"
        @closeDialog="justCloseDialogKeyword"
        @justCloseDialog="justCloseDialogKeyword"
        @majData="majData"
      ></wz-dialog-openai-keyword>
    </v-dialog>

    <!-- dialog modif keyword urls product-->
    <v-dialog
      v-model="showDialogModifKeywordURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-openai-keyword
        :type="'urlProduct'"
        :titleDialog="$t('modifKeywords')"
        :afficheDialog="showDialogModifKeywordURLProduct"
        :dataDialog="keywordUrl"
        @closeDialog="justCloseDialogKeywordURLProduct"
        @justCloseDialog="justCloseDialogKeywordURLProduct"
        @majData="majDataURLProduct"
      ></wz-dialog-openai-keyword>
    </v-dialog>

    <!-- dialog modif keyword product -->
    <v-dialog
      v-model="showDialogModifKeywordProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-openai-keyword-product
        :titleDialog="$t('modifKeywords')"
        :afficheDialog="showDialogModifKeywordProduct"
        :dataDialog="keywordProduct"
        @closeDialog="justCloseDialogKeywordProduct"
        @justCloseDialog="justCloseDialogKeywordProduct"
        @majData="majDataProduct"
      ></wz-dialog-openai-keyword-product>
    </v-dialog>

    <!-- dialog modif faq -->
    <v-dialog
      v-model="showDialogModifFAQ"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-openai-faq
        :titleDialog="addFAQ ? $t('addNewFAQ') : $t('modifFAQ')"
        :afficheDialog="showDialogModifFAQ"
        :dataDialog="addFAQ ? {} : questAnsw"
        :numFAQ=this.numFAQ
        :addFAQ=this.addFAQ
        @closeDialog="justCloseDialogFAQ"
        @justCloseDialog="justCloseDialogFAQ"
        @majFAQ="majFAQ"
      ></wz-dialog-openai-faq>
    </v-dialog>

    <!-- ajoute des mots clés à la selection d'url -->
    <v-dialog
      v-model="showDialogAddKeyword"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedUrls.length > 1 ? $t('addKnow-s') : $t('addKnow')"
        :contentDialogConfirm="messageKeywords"
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitAddKeywords"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- ajoute des mots clés à la selection api produits -->
    <v-dialog
      v-model="showDialogAddKeywordProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedProducts.length > 1 ? $t('addKnow-s') : $t('addKnow')"
        :contentDialogConfirm="messageKeywords"
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitAddKeywordsProducts"
      ></wz-dialog-confirm>
    </v-dialog> 

     <!-- ajoute des mots clés à la selection d'urls produit -->
     <v-dialog
      v-model="showDialogAddKeywordURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedURLProducts.length > 1 ? $t('addKnow-s') : $t('addKnow')"
        :contentDialogConfirm="messageKeywords"
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitAddKeywordsURLProducts"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- dialog import pdf -->
    <v-dialog
      v-model="showDialogImportPDF"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-import-pdf
        :titleDialog="$t('importDoc')"
        :afficheDialog="showDialogImportPDF"
        @addFile="addFile"
        @justCloseDialog="justCloseDialogImportPDF"
      ></wz-dialog-import-pdf>
    </v-dialog>
    <!-- dialog segments pdf -->
    <v-dialog
      v-model="showDialogChunkPDF"
      scrollable
      max-width="80%"
    >
      <wz-dialog-file-chunk
        :titleDialog="$t('segPDF')"
        :afficheDialog="showDialogChunkPDF"
        :licKey=this.siteSelected.LIC_KEY
        :dataDialog="selectedFileChunk"
        @justCloseDialog="justCloseDialogChunkPDF"
      ></wz-dialog-file-chunk>
    </v-dialog>
    <!-- dialog resume image/pdf -->
    <v-dialog
      v-model="showDialogResume"
      scrollable
      max-width="80%"
    >
      <wz-dialog-file-resume
        :titleDialog="$t('AIResume')"
        :afficheDialog="showDialogResume"
        :licKey=this.siteSelected.LIC_KEY
        :dataDialog="selectedFileChunk"
        @justCloseDialog="justCloseDialogResume"
      ></wz-dialog-file-resume>
    </v-dialog>
    <!-- dialog add analyse chat -->
    <v-dialog
      v-model="showDialogAddAnalyseChat"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-analyse-chat
        :titleDialog="titleAnalyseChat"
        :modifDialog="modifDialog"
        :afficheDialog="showDialogAddAnalyseChat"
        :dataDialog="selectedModifAnalyseChat"
        @addAnalyse="saveAnalyseChat"
        @modifAnalyse="modifAnalyseChat"
        @justCloseDialog="justCloseDialogAnalyseChat"
      ></wz-dialog-analyse-chat>
    </v-dialog>
    <!-- dialog add url -->
    <v-dialog
      v-model="showDialogAddUrls"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-add-urls
        :titleDialogConfirm="$t('searchUrl')"
        :contentDialogConfirm="$t('searchUrlTxt') + '<br>' + $t('AIMLicence') + ' <strong>' + siteSelected.LIC_KEY + '</strong>'" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingSearchUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogAddUrls"
        @justCloseDialogConfirm="justCloseDialogAddUrls"
        @submitDialogConfirm="submitCheckUrls"
      ></wz-dialog-add-urls>
    </v-dialog>
	<!-- dialog ameliorer prompt avec IA -->
    <v-dialog
      v-model="showDialogEnhancePrompt"
      scrollable
      max-width="80%"
    >
      <wz-dialog-enhance-prompt
        :titleDialogConfirm="$t('prompt_ameliorer')"
        :contentDialogConfirm="$t('prompt_utiliser')"
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :preselectedSection="selectedEnhanceSection"
        :currentPromptData="{ preview: prompt, personality: prompt_personality, environment: prompt_environment, objectif: prompt_objectif, communication: prompt_communication, questions: prompt_questions, rules: prompt_rules, tools: prompt_tools, custom: prompt_custom, llm: modelSelect.name, temperature: sliderTemp, name: prompt_name, comment: prompt_comment || prompt_name }"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @applyEnhancedPromptSection="applyEnhancedPromptSection"
        @closeDialogConfirm="justCloseDialogEnhancePrompt"
        @justCloseDialogConfirm="justCloseDialogEnhancePrompt"
        @submitDialogConfirm="submitEnhancePrompt"
      ></wz-dialog-enhance-prompt>
    </v-dialog>
	<!-- dialog versionner le  prompt -->
    <v-dialog
      v-model="showDialogVersionPrompt"
      max-width="80%"
    >
      <wz-dialog-version-prompt
        :titleDialogConfirm="$t('prompt_restaurer')"
        :contentDialogConfirm="$t('prompt_choisissez')"
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        :currentPromptData="{ preview: prompt, personality: prompt_personality, environment: prompt_environment, objectif: prompt_objectif, communication: prompt_communication, questions: prompt_questions, rules: prompt_rules, tools: prompt_tools, custom: prompt_custom, llm: modelSelect.name, temperature: sliderTemp, name: prompt_name, comment: prompt_comment || prompt_name }"
        @restorePromptSection="restorePromptSectionFromHistory"
        @restoreAllPromptSections="restoreAllPromptSectionsFromHistory"
        @closeDialogConfirm="justCloseDialogVersionPrompt"
        @justCloseDialogConfirm="justCloseDialogVersionPrompt"
        @submitDialogConfirm="submitVersionPrompt"
      ></wz-dialog-version-prompt>
    </v-dialog>

    <v-dialog
      v-model="showDialogEnhancePromptCsat"
      scrollable
      max-width="80%"
    >
      <wz-dialog-enhance-prompt
        :titleDialogConfirm="'Ameliorer le prompt CSAT'"
        :contentDialogConfirm="$t('prompt_utiliser')"
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :preselectedSection="selectedEnhanceCsatSection"
        :sectionOptions="csatSectionOptions"
        :currentPromptData="{ personality: prompt_csat_personality, environment: prompt_csat_mission, objectif: prompt_csat_rules, communication: prompt_csat_block4, llm: '-', temperature: '-', name: prompt_csat_name, comment: prompt_csat_comment || prompt_csat_name }"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @applyEnhancedPromptSection="applyEnhancedPromptSectionCsat"
        @closeDialogConfirm="justCloseDialogEnhancePromptCsat"
        @justCloseDialogConfirm="justCloseDialogEnhancePromptCsat"
      ></wz-dialog-enhance-prompt>
    </v-dialog>

    <v-dialog
      v-model="showDialogVersionPromptCsat"
      max-width="80%"
    >
      <wz-dialog-version-prompt-csat
        :titleDialogConfirm="'Historique prompt CSAT'"
        :currentPromptData="{ personality: prompt_csat_personality, environment: prompt_csat_mission, objectif: prompt_csat_rules, communication: prompt_csat_block4, name: prompt_csat_name, comment: prompt_csat_comment || prompt_csat_name }"
        :siteKey="siteSelected ? siteSelected.LIC_KEY : ''"
        :sectionOptions="csatSectionOptions"
        @restorePromptSection="restorePromptCsatSectionFromHistory"
        @restoreAllPromptSections="restoreAllPromptCsatSectionsFromHistory"
        @justCloseDialogConfirm="justCloseDialogVersionPromptCsat"
      ></wz-dialog-version-prompt-csat>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { DOMAINE } from '../../constants'
import { mapGetters, mapState } from 'vuex'
import permission from '../../mixins/permissions'
import WzDialogVersionPromptCsat from '../watcheezy/WzDialogVersionPromptCsat'
export default {
  components: {
    WzDialogVersionPromptCsat
  },
  mixins: [permission],
  data () {
    return {
      domaine: DOMAINE,
      loading: false,
      /**
       * chargement
       * @type {Boolean}
       */
      botUserId: 0,
      userJob: '',
      userName: '',
      promptSystemOpenPanels: [false, false, false, false, false, false, false, false],
      promptCsatOpenPanels: [false, false, false, false],
      mainOpenAIConfigPanel: 0,
      promptResumeOpenPanels: [false],
      promptCriteriaOpenPanels: [false],
      selectedEnhanceSection: 'personality',
      selectedEnhanceCsatSection: 'personality',
      closeDialogUniquement: false,
      showDialogAddUrls: false,
      showDialogLock: false,
      showDialogLockProduct: false,
      showDialogLockURLProduct: false,
      showDialogDeleteSupp: false,
      showDialogChunkPDF: false,
      showDialogResume: false,
      showDialogImportPDF: false,
      showDialogAddAnalyseChat: false,
      showDialogDeleteAnalyseChat: false,
      showDialogModifKeyword: false,
      showDialogModifKeywordURLProduct: false,
      showDialogModifKeywordProduct: false,
      showDialogModifFAQ: false,
      showDialogDeletesFAQ: false,
      showDialogDelete: false,
      showDialogDeleteProduct: false,
      showDialogDeleteURLProduct: false,
      showDialogAddKeywordURLProduct: false,
      showDialogDeleteFile: false,
      showDialogDeleteParsing: false,
      showDialogEmbedding: false,
      showDialogEmbeddingAPI: false,
      showDialogEmbeddingURLProduct: false,
      showDialogEnhancePrompt: false,
      showDialogVersionPrompt: false,
      showDialogEnhancePromptCsat: false,
      showDialogVersionPromptCsat: false,
      loadingResumePrompt: false,
      loadingResumePromptAPI: false,
      loadingStartEmbedding: false,
      loadingEmbeddingUrl: false,
      loadingRes: false,
      loadingSearchUrl: false,
      showDialogAddKeyword: false,
      showDialogAddKeywordProduct: false,
      loadingModifFile: false,
      loadingModifUrl: false,
      loadingModifAnalyseChat: false,
      loadingModifSuppFAQ: false,
      loadingPrompt: false,
      openListeChatbot: false,
      loadingSavePrompt: false,
      loadingData: true,
      loadingDataInactif: true,
      loadingDataFiles: true,
      loadingStatsToken: true,
      loadingCheckSitemap: false,
      botStream: false,
      botStreamRef: false,
      majCronTab: false,
      majCronTabRef: false,
      majUrlAuto: false,
      majUrlAutoRef: false,
      pageScanne: '',
      pageScanneRef: '',
      // majCronTabPage: false,
      // majCronTabPageRef: false,
      // majUrlAutoPage: false,
      // majUrlAutoPageRef: false,
      // parseElement: '',
      // parseElementRef: '',
      messageAccueil: '',
      messageAccueilRef: '',
      questionAuto1: '',
      questionAuto2: '',
      questionAuto3: '',
      questionAuto4: '',
      questionAuto1Ref: '',
      questionAuto2Ref: '',
      questionAuto3Ref: '',
      questionAuto4Ref: '',
      comportment: true,
      showEx: true,
      parseUrl: '',
      parseUrlRef: '',
      prompt: '',
      prompt_personality: '',
      prompt_environment: '',
      prompt_objectif: '',
      prompt_communication: '',
      prompt_questions: '',
      prompt_rules: '',
      prompt_tools: '',
      prompt_custom: '',
      prompt_name: '',
      prompt_comment: '',
      promptVersionCount: 0,
      prompt_csat_personality: '',
      prompt_csat_mission: '',
      prompt_csat_rules: '',
      prompt_csat_block4: '',
      prompt_csat_name: '',
      prompt_csat_comment: '',
      promptCsatVersionCount: 0,
      loadingPromptCsat: false,
      promptRef: '',
      prompt_personalityRef: '',
      prompt_environmentRef: '',
      prompt_objectifRef: '',
      prompt_communicationRef: '',
      prompt_questionsRef: '',
      prompt_rulesRef: '',
      prompt_toolsRef: '',
      prompt_customRef: '',
      promptSectionDraftSaveTimer: null,
      isHydratingPromptSections: false,
      promptSectionDraftData: {},
      prompt_nameRef: '',
      prompt_commentRef: '',
      prompt_csat_personalityRef: '',
      prompt_csat_missionRef: '',
      prompt_csat_rulesRef: '',
      prompt_csat_block4Ref: '',
      prompt_csat_nameRef: '',
      prompt_csat_commentRef: '',
      promptResume: '',
      promptResumeRef: '',
      liveCriteriaInput: '',
      liveCriteriaList: [],
      liveTestUrl: '',
      showToolPicker: false,
      selectedFunctionTools: [],
      csatSectionOptions: [
        { text: 'Contexte et objectif', id: 'personality' },
        { text: 'Definition du CSAT', id: 'environment' },
        { text: 'Regles de traitement', id: 'objectif' },
        { text: 'Format de sortie attendu', id: 'communication' }
      ],
      functionToolOptions: [
        { text: this.$t('prompt_transfert'), value: 'transfer_number', group: 'system' },
        { text: this.$t('prompt_sendmail'), value: 'send_email', group: 'system' },
        { text: this.$t('prompt_endcall'), value: 'end_call', group: 'system' },
        { text: 'Freshdesk', value: 'freshdesk', group: 'integration' },
        { text: 'Freshservice', value: 'freshservice', group: 'integration' }
      ],
      promptSearch: '',
      promptSearchRef: '',
      productSelectAuto: true,
      productSelectAutoRef: true,
      functionCallOnOff: [
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      functionCallOnOffRef: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      functionCall: '',
      // functionCallRef: '',
      function0: '',
      function1: '',
      function2: '',
      function3: '',
      function4: '',
      function5: '',
      function6: '',
      function7: '',
      function8: '',
      function0Ref: '',
      function1Ref: '',
      function2Ref: '',
      function3Ref: '',
      function4Ref: '',
      function5Ref: '',
      function6Ref: '',
      function7Ref: '',
      function8Ref: '',
      addFonctionsNum: 0,
      fonctionsNum: '',
      parsingSelectif: [{name: this.$t('prompt_parsingoblig'), methode: '', elements: '', default: true}],
      parsingSelectifRef: [],
      parsingsNum: '',
      SelectedParsingSupp: {},
      addParsingsNum: 0,
      dialog: '',
      dialogRef: '',
      contentResume: '',
      contentResumeKeys: '',
      infoCronPage: '',
      afficheStatusCronPage: false,
      statusSaveCronPage: 1,
      infoCron: '',
      afficheStatusCron: false,
      statusSaveCron: 1,
      APISelect: {name: 'chatCompletion'},
      APISelectRef: {name: 'chatCompletion'},
      APIListObject: [
        {name: 'response'},
        {name: 'chatCompletion'}
      ],
      modelSelect: {name: 'gpt-4o-mini', tokens: '127950'},
      modelSelectRef: {name: 'gpt-4o-mini', tokens: '127950'},
      modelListObject: [
        {name: 'gpt-3.5-turbo-0613', tokens: '4091'},
        {name: 'gpt-3.5-turbo', tokens: '16380'},
        {name: 'gpt-5.4', tokens: '127899'},
        {name: 'gpt-5.4-mini', tokens: '127898'},
        {name: 'gpt-5.4-nano', tokens: '127897'},
        {name: 'gpt-5.2', tokens: '127896'},
        {name: 'gpt-4-turbo', tokens: '127900'},
        {name: 'gpt-4', tokens: '8150'},
        {name: 'gpt-4o', tokens: '128000'},
        {name: 'gpt-4o-mini', tokens: '127950'},
        {name: 'mistral-small-latest', tokens: '127930'},
        {name: 'mistral-large-latest', tokens: '127931'},
        {name: 'open-mistral-nemo', tokens: '127932'},
        // {name: 'llama2'},
        // {name: 'llama2:13b'},
        {name: 'llama31-8b', tokens: '127940'},
        {name: 'gemini-1.5-pro', tokens: '127910'},
        {name: 'gemini-1.5-flash', tokens: '127911'},
        {name: 'gemini-1.5-flash-lite', tokens: '127912'},
        {name: 'gemini-2.0-flash', tokens: '127913'},
        {name: 'gemini-2.5-pro-preview-06-05', tokens: '127914'},
        {name: 'gemini-2.5-flash-preview-05-20', tokens: '127915'}
      ],
      timeLabels: [
        this.$t('prompt_daily'),
        this.$t('prompt_weekly'),
        this.$t('prompt_monthly'),
        this.$t('prompt_annualy')
      ],
      timeSelected: 1,
      timeSelectedRef: 1,
      // methodSelect: 'querySelector',
      // methodSelectRef: 'querySelector',
      keywordUrl: '',
      keywordProduct: '',
      questAnsw: {},
      methodList: [
        'querySelector',
        'querySelectorAll',
        'getElementById',
        'getElementsByTagName'
      ],
      tokens: [],
      // produts API
      selectedProduct: {},
      selectedProducts: [],
      totalProduct: 0,
      totalProductInactif: 0,
      rangeSliderProduct: [0, 200],
      minSliderProduct: 0,
      maxSliderProduct: this.totalProduct,
      products: [],
      productsSupp: [],
      // produts URL
      selectedURLProduct: {},
      selectedURLProducts: [],
      totalURLProduct: 0,
      totalURLProductInactif: 0,
      rangeSliderURLProduct: [0, 200],
      minSliderURLProduct: 0,
      maxSliderURLProduct: this.totalURLProduct,
      URLProducts: [],
      URLProductsSupp: [],
      // url standard
      selectedUrl: {},
      totalUrl: 0,
      rangeSliderUrl: [0, 200],
      minSliderUrl: 0,
      maxSliderUrl: this.totalUrl,
      urls: [],
      urlsSupp: [],
      faqs: [],
      numFAQ: 0,
      addFAQ: false,
      selectedUrls: [],
      selectedFaqs: [],
      selectedSuppUrls: [],
      selectActionUrl: [],
      selectActionProduct: [],
      selectActionURLProduct: [],
      selectActionSuppUrl: [],
      selectActionFAQ: [],
      selectActionPrompt: [],
      files: [],
      analyseChat: [],
      analyseChatRef: [],
      selectedFiles: [],
      selectActionFile: [],
      selectedAnalyseChat: [],
      selectedModifAnalyseChat: {},
      selectActionAnalyseChat: [],
      headersTokens: [
        { text: this.$t('AIData'), align: 'left', value: 'timestamp' },
        { text: this.$t('AISessionChat'), align: 'left', value: 'session_chat' },
        { text: this.$t('description'), align: 'left', value: 'description' },
        { text: this.$t('AIModele'), align: 'let', value: 'model' },
        { text: 'token prompt', align: 'left', value: 'tokens_prompt' },
        { text: 'token completion', align: 'left', value: 'tokens_completion' }
      ],
      headers: [
        { text: 'url', align: 'left', value: 'url' },
        { text: this.$t('AIDate'), align: 'left', value: 'date' },
        { text: 'error', align: 'center', value: 'error' },
        { text: 'new', align: 'center', value: 'new' },
        { text: 'update', align: 'center', value: 'updated' },
        { text: 'info', align: 'center', value: 'info' },
        { text: this.$t('AIVoir'), align: 'center', value: 'show' },
        { text: 'locked', align: 'center', value: 'locked' }
      ],
      headersProduct: [
        { text: this.$t('AIProduct'), align: 'left', value: 'product' },
        { text: this.$t('AIDate'), align: 'left', value: 'date' },
        { text: 'error', align: 'center', value: 'error' },
        { text: 'new', align: 'center', value: 'new' },
        { text: 'update', align: 'center', value: 'updated' },
        { text: 'info', align: 'center', value: 'info' },
        { text: this.$t('AIVoir'), align: 'center', value: 'show' },
        { text: 'locked', align: 'center', value: 'locked' }
      ],
      headersFAQ: [
        { text: 'index', align: 'right', value: 'index' },
        { text: this.$t('exportQuestion'), align: 'left', value: 'question' },
        { text: this.$t('reply'), align: 'left', value: 'reponse' },
        { text: 'update', align: 'right', value: 'update' }
      ],
      headersSupp: [
        { text: 'url', align: 'left', value: 'url' },
        { text: this.$t('AIVoir'), align: 'center', value: 'show' }
      ],
      headersFile: [
        { text: this.$t('AIDoc'), align: 'left', value: 'file' },
        { text: this.$t('AISeg'), align: 'left', value: 'chunk' }
      ],
      headersAnalyseChat: [
        { text: this.$t('exportQuestion'), align: 'left', value: 'q' },
        { text: this.$t('reply'), align: 'left', value: 'a' }
      ],
      search: '',
      alert: false,
      searchTokens: '',
      bot: [], // liste des bots choisis
      selectedFileChunk: {},
      maxSearch: 10,
      minSearch: 1,
      maxToken: 2000,
      minToken: 50,
      maxTemp: 1,
      minTemp: 0,
      sliderTemp: 0.5,
      sliderTempRef: 0.5,
      sliderTokenResponse: 250,
      sliderTokenResponseRef: 250,
      sliderSearchResponse: 1,
      sliderSearchResponseRef: 1,
      modifDialog: false,
      titleAnalyseChat: this.$t('addAnalyseChat'),
      messageResDialog: '',
      startLoading: 0,
      endLoading: 0,
      MajTTL: 604800,
      MajSitemap: true,
      dateStartPicker: null,
      dateEndPicker: null,
      dateStartDisplayed: null,
      dateEndDisplayed: null,
      timestampStart: null,
      timestampEnd: null,
      modalStart: false,
      modalEnd: false,
      stats: null,
      periods: [],
      period: {},
      intervals: [
         { text: _.upperFirst(this.$t('per')) + ' ' + this.$tc('days', 1, {count: ''}), value: 1 },
         { text: _.upperFirst(this.$t('per')) + ' ' + this.$tc('months', 1, {count: ''}), value: 2 }
      ],
      interval: null,
      utilisations: [
         { text: _.upperFirst(this.$t('AIConsom')), value: 1 },
         { text: _.upperFirst(this.$t('AICost')), value: 2 }
      ],
      utilisation: {value: 1},
      options: {
        colors: [
          '#F44336', // red
          '#3F51B5', // indigo
          '#009688', // teal
          '#E91E63', // pink
          '#607D8B', // blue-grey
          '#9C27B0', // purple
          '#2196F3', // blue
          '#FF5722', // deep-orange
          '#795548', // brown
          '#4CAF50', // green
          '#8BC34A', // light-green
          '#673AB7', // deep-purple
          '#CDDC39', // lime
          '#03A9F4', // light-blue
          '#FFC107', // amber
          '#FF9800', // orange
          '#FFEB3B', // yellow
          '#00BCD4', // cyan
          '#9E9E9E'  // grey
        ],
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 // center
        },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // à remplir par l'appel ajax
        },
        yAxis: [
          {
            allowDecimals: false,
            title: { text: '' },
            opposite: false
          },
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                // color: 'rgba(233, 30, 99, 1)'
              }
            },
            title: {
              text: 'tokens',
              style: {
                // color: 'rgba(233, 30, 99, 1)'
              }
            },
            opposite: true
          }
        ],
        series: [
          {
            name: 'tokens prompt (chat)',
            type: 'area',
            // color: 'rgba(0, 150, 136, 0.8)', // teal
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens completion (chat)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens prompt (analyze)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens completion (analyze)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens prompt (tokenize)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens completion (tokenize)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens prompt (embedding)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens completion (embedding)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          }
          // {
          //   name: _.upperFirst(this.$tc('chats', 2, { count: '' })),
          //   type: 'column',
          //   color: 'rgba(233, 30, 99, 0.8)', // pink
          //   marker: {symbol: 'circle', enabled: false},
          //   visible: true,
          //   yAxis: 1,
          //   data: [] // à remplir par l'appel ajax
          // }
        ],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },
      responseToken: [
        {tokensPrompt: 400},
        {tokensCompletion: 200},
        {tokensTotal: 600}
      ]
    }
  },
  computed: {
    ...mapGetters('_User', [ 'user' ]),
    ...mapState('_Sites', ['sites', 'siteSelected']),
    ...mapGetters('_Stats', ['tokenParams']),

    timestampStartPicker () {
      let date = moment(this.dateStartPicker, 'YYYY-MM-DD')
      // console.log(date.format('DD/MM/YYYY')); // affiche '22/12/2022'
      return date.format('x')
    },
    timestampEndPicker () {
      let date = moment(this.dateEndPicker, 'YYYY-MM-DD')
      // ajoute 23h59 pour aller en fin de journée
      return Math.floor(date.format('x')) + 86359999
    },
    isGptModel () {
      return this.modelSelect &&
      typeof this.modelSelect.name === 'string' &&
      this.modelSelect.name.toLowerCase().includes('gpt')
    },
    showTempAndTokenInputs () {
      const modelName = this.modelSelect && typeof this.modelSelect.name === 'string'
        ? this.modelSelect.name.toLowerCase()
        : ''
      const apiName = this.APISelect && typeof this.APISelect.name === 'string'
        ? this.APISelect.name.toLowerCase()
        : ''

      const isMistralModel = modelName.includes('mistral')
      if (isMistralModel) return true

      const isOpenAIOrChatgptModel =
        modelName.includes('gpt') ||
        modelName.includes('chatgpt') ||
        modelName.includes('openai')

      if (!isOpenAIOrChatgptModel) return false

      return apiName.includes('chatcompletion')
    },
    nbPrompt () {
      // console.log('nbPrompt', this.utilisation.value)
      if (this.utilisation.value === 2) { // cout de token
        let cout = _.sumBy(this.responseToken, 'tokensPrompt')
        return '$' + cout.toFixed(3)
      } else {
        return _.sumBy(this.responseToken, 'tokensPrompt')
      }
    },
    nbCompletion () {
      if (this.utilisation.value === 2) { // cout de token
        let cout = _.sumBy(this.responseToken, 'tokensCompletion')
        return '$' + cout.toFixed(3)
      } else {
        return _.sumBy(this.responseToken, 'tokensCompletion')
      }
    },
    nbTotal () {
      if (this.utilisation.value === 2) { // cout de token
        let cout = _.sumBy(this.responseToken, 'tokensTotal')
        return '$' + cout.toFixed(3)
      } else {
        return _.sumBy(this.responseToken, 'tokensTotal')
      }
    },
    // maxDatesStart: () => this.parseDate(this.dateEndPicker),
    // minDatesStart: () => this.parseDate(this.formatDate(new Date(moment().subtract(1, 'month')))),
    allowedDatesStart () {
      return {
        max: this.parseDate(this.dateEndPicker),
        min: this.parseDate(this.formatDate(new Date(moment().subtract(1, 'month'))))
      }
    },
    // maxDatesEnd: () => this.parseDate(this.formatDate(new Date(moment().local().endOf('day')))),
    // minDatesEnd: () => this.parseDate(this.dateStartPicker),
    allowedDatesEnd () {
      return {
        max: this.parseDate(this.formatDate(new Date(moment().local().endOf('day')))),
        min: this.parseDate(this.dateStartPicker)
      }
    },
    nbDays () {
      return moment(this.dateEndPicker, 'YYYY[-]MM[-]DD').diff(moment(this.dateStartPicker), 'days') + 1
    },
    modifPrompt () {
      // console.log('this.parsingSelectifRef :', this.parsingSelectifRef)
      // console.log('this.parsingSelectif :', this.parsingSelectif)
      if (
        this.APISelectRef.name !== this.APISelect.name ||
        this.modelSelectRef.name !== this.modelSelect.name ||
        this.promptRef !== this.prompt ||
        this.prompt_personalityRef !== this.prompt_personality ||
        this.prompt_environmentRef !== this.prompt_environment ||
        this.prompt_objectifRef !== this.prompt_objectif ||
        this.prompt_communicationRef !== this.prompt_communication ||
        this.prompt_questionsRef !== this.prompt_questions ||
        this.prompt_rulesRef !== this.prompt_rules ||
        this.prompt_toolsRef !== this.prompt_tools ||
        this.prompt_customRef !== this.prompt_custom ||
        this.prompt_nameRef !== this.prompt_name ||
        this.prompt_commentRef !== this.prompt_comment ||
        this.prompt_csat_personalityRef !== this.prompt_csat_personality ||
        this.prompt_csat_missionRef !== this.prompt_csat_mission ||
        this.prompt_csat_rulesRef !== this.prompt_csat_rules ||
        this.prompt_csat_block4Ref !== this.prompt_csat_block4 ||
        this.prompt_csat_nameRef !== this.prompt_csat_name ||
        this.prompt_csat_commentRef !== this.prompt_csat_comment ||
        this.promptResumeRef !== this.promptResume ||
        this.promptSearchRef !== this.promptSearch ||
        this.productSelectAutoRef !== this.productSelectAuto ||
        // this.functionCallRef !== this.functionCall ||
        JSON.stringify(this.parsingSelectifRef) !== JSON.stringify(this.parsingSelectif) ||
        this.dialogRef !== this.dialog ||
        // this.parseElementRef !== this.parseElement ||
        this.parseUrlRef !== this.parseUrl ||
        this.messageAccueilRef !== this.messageAccueil ||
        this.questionAuto1Ref !== this.questionAuto1 ||
        this.questionAuto2Ref !== this.questionAuto2 ||
        this.questionAuto3Ref !== this.questionAuto3 ||
        this.questionAuto4Ref !== this.questionAuto4 ||
        this.sliderSearchResponseRef !== this.sliderSearchResponse ||
        this.sliderTokenResponseRef !== this.sliderTokenResponse ||
        this.sliderTempRef !== this.sliderTemp ||
        this.majUrlAutoRef !== this.majUrlAuto ||
        this.function0Ref !== this.function0 ||
        this.function1Ref !== this.function1 ||
        this.function2Ref !== this.function2 ||
        this.function3Ref !== this.function3 ||
        this.function4Ref !== this.function4 ||
        this.function5Ref !== this.function5 ||
        this.function6Ref !== this.function6 ||
        this.function7Ref !== this.function7 ||
        this.function8Ref !== this.function8 ||
        JSON.stringify(this.functionCallOnOffRef) !== JSON.stringify(this.functionCallOnOff) ||
        this.majCronTabRef !== this.majCronTab ||
        this.timeSelectedRef !== this.timeSelected ||
        // this.majCronTabPageRef !== this.majCronTabPage ||
        this.pageScanne !== this.pageScanneRef ||
        this.botStreamRef !== this.botStream
      ) {
        return true
      } else {
        return false
      }
    },
    // affiche le bouton embedding uniquement si des mots clés ont été modifés
    modifKeywords () {
      let update = 0
      // console.log('modif update url', this.urls)
      for (const index in this.urls) {
        // console.log('modif update url', this.urls[index])
        // console.log('updated', this.urls[index].updated)
        if (this.urls[index].updated) {
          update++
        }
      }
      if (update) {
        return true
      } else {
        return false
      }
    },

    /**
     * Checks if any products have been updated.
     *
     * Iterates over the products array and increments the update counter
     * if a product's 'updated' property is true.
     *
     * Returns true if there are any updates, otherwise returns false.
     *
     * @returns {boolean} - True if there are any updates, otherwise false.
     */
    modifKeywordsProduct () {
      let update = 0
      // console.log('modif update url', this.products)
      for (const index in this.products) {
        // console.log('modif update url', this.products[index])
        // console.log('updated', this.products[index].updated)
        if (this.products[index].updated) {
          update++
        }
      }
      // return true if there are any updates, otherwise return false
      return update > 0
    },

    /**
     * Checks if any products have been updated.
     *
     * Iterates over the products array and increments the update counter
     * if a url product's 'updated' property is true.
     *
     * Returns true if there are any updates, otherwise returns false.
     *
     * @returns {boolean} - True if there are any updates, otherwise false.
     */
    modifKeywordsURLProduct () {
      let update = 0
      // console.log('modif update url', this.products)
      for (const index in this.URLProducts) {
        // console.log('modif update url', this.products[index])
        // console.log('updated', this.products[index].updated)
        if (this.URLProducts[index].updated) {
          update++
        }
      }
      // return true if there are any updates, otherwise return false
      return update > 0
    },

    computedActionUrl () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'},
        {text: this.$t('AILockSelect'), id: 'lock'},
        {text: this.$t('AIAddKnow'), id: 'keywords'}
      ]
      return actions
    },
    computedActionProduct () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'},
        {text: this.$t('AILockSelect'), id: 'lock'},
        {text: this.$t('AIAddKnow'), id: 'keywords'}
      ]
      return actions
    },
    computedActionFAQ () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'}
      ]
      return actions
    },
    computedActionSuppUrl () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'}
      ]
      return actions
    },
    // text du contenue de la fenetre de dialog de confirmation de delete url actives
    listeSelectedUrl () {
      let messageDelUrl = this.$t('supFAQ2')
      if (this.selectedUrls.length) {
        messageDelUrl += '<p><ol>'
        this.selectedUrls.forEach(res => {
          messageDelUrl += '<li>' + res.url + '</li>'
        })
        messageDelUrl += '</ol></p>'
      }
      return messageDelUrl
    },

    // liste de toutes les urls supprimées
    listeAllDelUrl () {
      let allDelUrls = []
      if (this.urlsSupp.length) {
        this.urlsSupp.forEach(res => {
          allDelUrls.push(res)
        })
      }
      if (this.URLProductsSupp.length) {
        this.URLProductsSupp.forEach(res => {
          allDelUrls.push(res)
        })
      }
      return allDelUrls
    },
    totalUrlInactif () {
      return this.urlsSupp.length + this.URLProductsSupp.length
    },

    // text du contenue de la fenetre de dialog de confirmation de delete api products
    listeSelectedProduct () {
      let messageDelProduct = this.$t('supFAQ2')
      if (this.selectedProducts.length) {
        messageDelProduct += '<p><ol>'
        this.selectedProducts.forEach(res => {
          messageDelProduct += '<li>' + res.product + '</li>'
        })
        messageDelProduct += '</ol></p>'
      }
      return messageDelProduct
    },

    listeSelectedURLProduct () {
      let messageDelProduct = this.$t('supFAQ2')
      if (this.selectedURLProducts.length) {
        messageDelProduct += '<p><ol>'
        this.selectedURLProducts.forEach(res => {
          messageDelProduct += '<li>' + res.url + '</li>'
        })
        messageDelProduct += '</ol></p>'
      }
      return messageDelProduct
    },

    // text du contenue de la fenetre de dialog de confirmation de delete url actives
    listeSelectedFAQ () {
      let messageDelFAQ = this.$t('supFAQ2')
      if (this.selectedFaqs.length) {
        messageDelFAQ += '<p><ol>'
        this.selectedFaqs.forEach(res => {
          messageDelFAQ += '<li>' + res.question + '</li>'
        })
        messageDelFAQ += '</ol></p>'
      }
      return messageDelFAQ
    },

    // text du contenue de la fenetre de dialog de confirmation de delete url actives
    messageKeywords () {
      let messageDelUrl = this.$t('knowInfo')
      if (this.selectedUrls.length) {
        messageDelUrl += '<p><ol>'
        this.selectedUrls.forEach(res => {
          messageDelUrl += '<li>' + res.url + '</li>'
        })
        messageDelUrl += '</ol></p>'
      }
      return messageDelUrl
    },
    // text du contenue de la fenetre de dialog de confirmation de delete url inactives
    listeSelectedSuppUrl () {
      let messageDelUrl = this.$t('supFAQ2')
      if (this.selectedSuppUrls.length) {
        messageDelUrl += '<p><ol>'
        this.selectedSuppUrls.forEach(res => {
          messageDelUrl += '<li>' + res.url + '</li>'
        })
        messageDelUrl += '</ol></p>'
      }
      return messageDelUrl
    },
    computedActionFile () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'}
      ]
      // console.log('actions', actions)
      return actions
    },
    computedActionAnalyseChat () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'}
      ]
      // console.log('actions', actions)
      return actions
    },
    // text du contenue de la fenetre de dialog de confirmation de delete url
    listeSelectedFile () {
      let messageDelFile = this.$t('supFAQ2')
      if (this.selectedFiles.length) {
        messageDelFile += '<p><ol>'
        this.selectedFiles.forEach(res => {
          messageDelFile += '<li>' + res.file + '</li>'
        })
        messageDelFile += '</ol></p>'
      }
      return messageDelFile
    },

    // text du contenue de la fenetre de dialog de confirmation de delete analyse chat
    listeSelectedAnalyseChat () {
      let messageDelFile = this.$t('supFAQ2')
      if (this.selectedAnalyseChat.length) {
        messageDelFile += '<p><ol>'
        this.selectedAnalyseChat.forEach(res => {
          messageDelFile += '<li>' + res.q + '</li>'
        })
        messageDelFile += '</ol></p>'
      }
      return messageDelFile
    },
    // url du bon serveur (prod / dev)
    serveurAI () {
      if (window.location.origin.indexOf('localhost') > -1) {
        return 'https://lb-sw-generator-dev-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice-preprod') > -1) {
        return 'https://lb-sw-generator-preprod-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice') > -1) {
        return 'https://lb-sw-generator.watcheebox.net/'
      } else {
        return 'https://lb-sw-generator.watcheebox.net/'
      }
    },
    fonctions () {
      if (this.functionCall) {
        // console.log('JSON.parse(this.functionCall)', JSON.parse(this.functionCall))
        const functions = JSON.parse(this.functionCall)
        for (var index in functions) {
          // console.log('index', index)
          if (index === '0') {
            // console.log('index 2', index)
            this.function0 = JSON.stringify(functions[index], null, '\t')
            this.function0Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '1') {
            this.function1 = JSON.stringify(functions[index], null, '\t')
            this.function1Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '2') {
            this.function2 = JSON.stringify(functions[index], null, '\t')
            this.function2Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '3') {
            this.function3 = JSON.stringify(functions[index], null, '\t')
            this.function3Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '4') {
            this.function4 = JSON.stringify(functions[index], null, '\t')
            this.function4Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '5') {
            this.function5 = JSON.stringify(functions[index], null, '\t')
            this.function5Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '6') {
            this.function6 = JSON.stringify(functions[index], null, '\t')
            this.function6Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '7') {
            this.function7 = JSON.stringify(functions[index], null, '\t')
            this.function7Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '8') {
            this.function8 = JSON.stringify(functions[index], null, '\t')
            this.function8Ref = JSON.stringify(functions[index], null, '\t')
          }
        }
        this.addFonctionsNum = functions.length
        this.fonctionsNum = functions.length
        // console.log('functions', functions)
        return functions
      } else {
        return []
      }
    },

    // methode par defaut
    methodSelect () {
      for (const parsing of this.parsingSelectif) {
        if (parsing.default) {
          return parsing.methode
        }
      }
    },
    // elements à scanner par defaut
    parseElement: {
      get () {
        for (const parsing of this.parsingSelectif) {
          if (parsing.default) {
            return parsing.elements
          }
        }
        return ''
      },
      set (value) {
        for (const parsing of this.parsingSelectif) {
          if (parsing.default) {
            parsing.elements = value
            return
          }
        }
        if (this.parsingSelectif.length) {
          this.parsingSelectif[0].elements = value
        }
      }
    }
    // selectedUrl () {
    //   return {url: this.urls[0].url}
    // }
     // si la tache cron est activé pour cette licence
    // tacheCron () {
    //   if (window.location.origin.indexOf('localhost') > -1) {
    //     return 'https://openai-generator-dev.watcheebox.net/'
    //   } else if (window.location.origin.indexOf('beta') > -1) {
    //     return 'https://openai-generator-ppr.watcheebox.net/'
    //   } else {
    //     return 'https://openai-generator.watcheebox.net/'
    //   }
    // }
  },
  mounted () {
    // définition de l'intervalle à afficher dans le graphique
    this.interval = this.intervals[0]
    // définition de l'utilisation des tokens
    this.utilisation = this.utilisations[0]
    this.loadPromptVersionCount(this.$store.state._Sites.siteSelected.LIC_KEY)
    this.applyRouteFocusPanel()
  },
  created () {
    if (localStorage.getItem('startListUrl')) {
      this.rangeSliderUrl[0] = localStorage.getItem('startListUrl')
    }

    if (localStorage.getItem('endListUrl')) {
      this.rangeSliderUrl[1] = localStorage.getItem('endListUrl')
    }

    if (localStorage.getItem('startListProduct')) {
      this.rangeSliderProduct[0] = localStorage.getItem('startListProduct')
    }

    if (localStorage.getItem('endListProduct')) {
      this.rangeSliderProduct[1] = localStorage.getItem('endListProduct')
    }

    this.selectBot()

    // recupère la liste des urls du client dans redis
    this.loadUrlsClient('actif')
    // recupère la liste des produits du client dans redis
    this.loadProductsClient('actif')
    // recupère la liste des url produits du client dans redis
    this.loadURLProductsClient('actif')
    // recupère la liste des documents du client dans redis
    this.loadFilesClient(this.siteSelected.LIC_KEY)
    // recupère la liste des FAQ du client dans redis
    this.loadFaqsClient()

    // recupère la liste des urls supprimées du client dans redis
    this.loadUrlsClient('inactif')
    this.loadProductsClient('inactif') // liste produit api
    this.loadURLProductsClient('inactif') // liste produit url
    this.initPeriod()
    this.periods = [
      { text: _.upperFirst(this.$tc('custom', 2)), value: 0 },
      { text: _.upperFirst(this.$t('yesterday')), value: 1 },
      { text: _.upperFirst(this.$t('thisWeek')), value: 2 },
      { text: _.upperFirst(this.$t('thisMonth')), value: 3 },
      { text: _.upperFirst(this.$t('last7Days')), value: 4 },
      { text: _.upperFirst(this.$t('last30Days')), value: 5 },
      { text: _.upperFirst(this.$t('lastWeek')), value: 6 }
    ]
    this.getStatsOpenAI()
  },
  beforeDestroy () {
    if (this.promptSectionDraftSaveTimer) {
      clearTimeout(this.promptSectionDraftSaveTimer)
      this.promptSectionDraftSaveTimer = null
    }
  },
  methods: {
    estimatePromptTokens (text) {
      const value = (text || '').toString().trim()
      if (!value.length) return 0
      const normalized = value.replace(/\s+/g, ' ').trim()
      const charCount = normalized.length
      const words = normalized.match(/[A-Za-z0-9_\u00C0-\u017F]+/g) || []
      const punct = normalized.match(/[^\w\s]/g) || []
      const estimateByChars = Math.ceil(charCount / 4)
      const estimateByWordMix = Math.ceil((words.length * 1.3) + (punct.length * 0.2))
      return Math.max(estimateByChars, estimateByWordMix, 1)
    },
    addLiveCriterion () {
      const value = (this.liveCriteriaInput || '').toString().trim()
      if (!value) return
      this.liveCriteriaList.push(value)
      this.liveCriteriaInput = ''
    },
    openLiveTestUrl () {
      const value = (this.liveTestUrl || '').toString().trim()
      if (!value) return
      try {
        const parsed = new URL(value)
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
          window.open(parsed.href, '_blank')
        }
      } catch (e) {}
    },
    normalizeNullableText (value) {
      if (value === null || typeof value === 'undefined') return ''
      if (typeof value === 'string' && value.trim().toLowerCase() === 'null') return ''
      return value
    },
    hasPromptSectionContent (value) {
      return typeof this.normalizeNullableText(value) === 'string'
        ? this.normalizeNullableText(value).trim().length > 0
        : !!this.normalizeNullableText(value)
    },
    getPromptSectionDraftStorageKey (licKey) {
      const key = licKey || (this.siteSelected && this.siteSelected.LIC_KEY) || ''
      if (!key) return ''
      return 'openai_prompt_sections_draft_' + key
    },
    getPromptSectionFields () {
      return [
        'prompt_personality',
        'prompt_environment',
        'prompt_objectif',
        'prompt_communication',
        'prompt_questions',
        'prompt_rules',
        'prompt_tools',
        'prompt_custom'
      ]
    },
    getPromptSectionDraftPayload () {
      return {
        prompt_personality: this.prompt_personality || '',
        prompt_environment: this.prompt_environment || '',
        prompt_objectif: this.prompt_objectif || '',
        prompt_communication: this.prompt_communication || '',
        prompt_questions: this.prompt_questions || '',
        prompt_rules: this.prompt_rules || '',
        prompt_tools: this.prompt_tools || '',
        prompt_custom: this.prompt_custom || '',
        updated_at: Date.now()
      }
    },
    persistPromptSectionDraftNow () {
      if (this.isHydratingPromptSections) return
      const storageKey = this.getPromptSectionDraftStorageKey()
      if (!storageKey) return
      const payload = this.getPromptSectionDraftPayload()
      try {
        localStorage.setItem(storageKey, JSON.stringify(payload))
      } catch (e) {}
      this.promptSectionDraftData = payload
    },
    persistPromptSectionDraftDebounced () {
      if (this.isHydratingPromptSections) return
      if (this.promptSectionDraftSaveTimer) {
        clearTimeout(this.promptSectionDraftSaveTimer)
      }
      this.promptSectionDraftSaveTimer = setTimeout(() => {
        this.persistPromptSectionDraftNow()
      }, 400)
    },
    applyPromptSectionDraftFromLocalStorage (licKey) {
      const storageKey = this.getPromptSectionDraftStorageKey(licKey)
      if (!storageKey) return
      let payload = null
      try {
        payload = JSON.parse(localStorage.getItem(storageKey) || 'null')
      } catch (e) {
        payload = null
      }
      if (!payload || typeof payload !== 'object') {
        this.promptSectionDraftData = {}
        return
      }

      if (typeof payload.prompt_personality === 'string') this.prompt_personality = payload.prompt_personality
      if (typeof payload.prompt_environment === 'string') this.prompt_environment = payload.prompt_environment
      if (typeof payload.prompt_objectif === 'string') this.prompt_objectif = payload.prompt_objectif
      if (typeof payload.prompt_communication === 'string') this.prompt_communication = payload.prompt_communication
      if (typeof payload.prompt_questions === 'string') this.prompt_questions = payload.prompt_questions
      if (typeof payload.prompt_rules === 'string') this.prompt_rules = payload.prompt_rules
      if (typeof payload.prompt_tools === 'string') this.prompt_tools = payload.prompt_tools
      if (typeof payload.prompt_custom === 'string') this.prompt_custom = payload.prompt_custom
      this.promptSectionDraftData = payload
    },
    clearPromptSectionDraftFromLocalStorage (licKey) {
      const storageKey = this.getPromptSectionDraftStorageKey(licKey)
      if (!storageKey) return
      try {
        localStorage.removeItem(storageKey)
      } catch (e) {}
      if (this.promptSectionDraftSaveTimer) {
        clearTimeout(this.promptSectionDraftSaveTimer)
        this.promptSectionDraftSaveTimer = null
      }
      this.promptSectionDraftData = {}
    },
    isPromptSectionDraft (fieldName) {
      if (!fieldName || typeof fieldName !== 'string') return false
      const payload = this.promptSectionDraftData || {}
      if (!Object.prototype.hasOwnProperty.call(payload, fieldName)) return false
      const draftValue = this.normalizeNullableText(payload[fieldName]).toString()
      const refField = fieldName + 'Ref'
      const refValue = this.normalizeNullableText(this[refField]).toString()
      return draftValue !== refValue
    },
    hasAnyPromptSectionDraft () {
      const fields = this.getPromptSectionFields()
      for (let i = 0; i < fields.length; i++) {
        if (this.isPromptSectionDraft(fields[i])) return true
      }
      return false
    },
    cancelPromptSectionDraft (fieldName) {
      if (!fieldName || typeof fieldName !== 'string') return
      const refField = fieldName + 'Ref'
      if (!Object.prototype.hasOwnProperty.call(this, fieldName) || !Object.prototype.hasOwnProperty.call(this, refField)) return
      this[fieldName] = this.normalizeNullableText(this[refField]).toString()
      this.persistPromptSectionDraftNow()
      if (!this.hasAnyPromptSectionDraft()) {
        this.clearPromptSectionDraftFromLocalStorage(this.siteSelected && this.siteSelected.LIC_KEY)
      }
    },
    cancelAllPromptSectionDrafts () {
      const fields = this.getPromptSectionFields()
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i]
        const refField = field + 'Ref'
        if (Object.prototype.hasOwnProperty.call(this, field) && Object.prototype.hasOwnProperty.call(this, refField)) {
          this[field] = this.normalizeNullableText(this[refField]).toString()
        }
      }
      this.clearPromptSectionDraftFromLocalStorage(this.siteSelected && this.siteSelected.LIC_KEY)
    },
    onPromptSectionChanged () {
      this.persistPromptSectionDraftDebounced()
    },
    refreshPromptSystemOpenPanels () {
      this.promptSystemOpenPanels = [
        this.hasPromptSectionContent(this.prompt_personality),
        this.hasPromptSectionContent(this.prompt_environment),
        this.hasPromptSectionContent(this.prompt_objectif),
        this.hasPromptSectionContent(this.prompt_communication),
        this.hasPromptSectionContent(this.prompt_questions),
        this.hasPromptSectionContent(this.prompt_rules),
        this.hasPromptSectionContent(this.prompt_tools),
        this.hasPromptSectionContent(this.prompt_custom)
      ]
    },
    refreshPromptResumeOpenPanels () {
      this.promptResumeOpenPanels = [
        this.hasPromptSectionContent(this.promptResume)
      ]
    },
    applyRouteFocusPanel () {
      const focus = this.$route && this.$route.query ? this.$route.query.focus : ''
      if (focus === 'csat') {
        this.mainOpenAIConfigPanel = 1
        this.promptCsatOpenPanels = [true, false, false, false]
        return
      }
      if (focus === 'prompt-system') {
        this.mainOpenAIConfigPanel = 0
      }
    },
    refreshPromptCriteriaOpenPanels () {
      this.promptCriteriaOpenPanels = [
        (Array.isArray(this.liveCriteriaList) && this.liveCriteriaList.length > 0) ||
        this.hasPromptSectionContent(this.liveTestUrl)
      ]
    },
    normalizeFunctionCallOnOff (value) {
      let normalized = value

      if (typeof normalized === 'string') {
        try {
          normalized = JSON.parse(normalized)
        } catch (e) {
          normalized = []
        }
      }

      if (!Array.isArray(normalized)) {
        normalized = []
      }

      return normalized.map(item => {
        if (typeof item === 'string') {
          return item === 'true' || item === '1'
        }
        return !!item
      })
    },
    toggleFunctionTool (item) {
      const idx = this.selectedFunctionTools.indexOf(item.value)
      if (idx > -1) {
        this.selectedFunctionTools.splice(idx, 1)
      } else {
        this.selectedFunctionTools.push(item.value)
      }
    },
    functionToolOptionsByGroup (group) {
      return this.functionToolOptions.filter(opt => opt.group === group)
    },
    functionToolLabel (value) {
      const item = this.functionToolOptions.find(opt => opt.value === value)
      return item ? item.text : value
    },
    functionToolIcon (value) {
      switch (value) {
        case 'transfer_number':
          return 'phone'
        case 'send_email':
          return 'mail_outline'
        case 'end_call':
          return 'call_end'
        case 'freshdesk':
        case 'freshservice':
          return 'settings'
        default:
          return 'extension'
      }
    },
    selectBot () {
      console.log('this.bot', this.bot)
      if (this.user.botSelected.length) {
        this.bot = this.user.botSelected
      } else {
        // par default c'est le premier de la list
        this.bot.splice(0, 1, this.user.bots[0])
      }
      this.botUserId = this.bot[0].USR_ID
      this.userJob = this.bot[0].USR_JOB
      this.userName = this.bot[0].USR_FIRST_NAME + ' ' + this.bot[0].USR_LAST_NAME

      // commenté le 05.03.26 car deux configs php sont ainsi chargées, or seule celle de updateSite suffit ->a tester en monobot et monosite
      // this.getPrompt(this.bot[0].USR_ID)
    },
    updateSite (site) {
      // console.log('updateSite : ', site)
      this.botUserId = JSON.parse(site.DSK_BOT_USER).user_id
      this.userJob = JSON.parse(site.DSK_BOT_USER).user_job
      this.userName = JSON.parse(site.DSK_BOT_USER).user_name

      this.getPrompt(JSON.parse(site.DSK_BOT_USER).user_id, site.LIC_KEY)
      this.getPromptCsat(JSON.parse(site.DSK_BOT_USER).user_id, site.LIC_KEY)

      if (
        this.$store.state._Sites.siteSelected.LIC_BOT_ACTIVATED !== '1'
      ) {
        this.alert = true
      } else {
        this.alert = false
      }
    },
    reInitBots () {
      // console.log('iniwatson', this.bot)
      // si on change de bot, il faut effacer l'id du repertoire de la base de connaissance
      this.$store.commit('_Sites/SET_BASE_CONNAISSANCE', '')
      this.bot = this.user.botSelected
      this.loading = false
      this.getPrompt(this.bot[0].USR_ID) // affiche le prompt du nouveau bot selectionné
      this.getPromptCsat(this.bot[0].USR_ID)
    },
    closeListe () {
      // console.log('close liste chatbot')
      this.openListeChatbot = false
    },
    changeMethod () {
      // console.log('change method')
    },
    changeModel () {
      // console.log('change model)
    },
    afficheDate (data) {
      return moment(data).format('YYYY[-]MM[-]DD[ ]HH[h]mm[:]ss')
    },
    toBooleanValue (value, fallback = true) {
      if (typeof value === 'boolean') {
        return value
      }
      if (typeof value === 'string') {
        const normalizedValue = value.trim().toLowerCase()
        if (normalizedValue === 'true' || normalizedValue === '1') {
          return true
        }
        if (normalizedValue === 'false' || normalizedValue === '0') {
          return false
        }
      }
      if (typeof value === 'number') {
        if (value === 1) {
          return true
        }
        if (value === 0) {
          return false
        }
      }
      return fallback
    },
    normalizeToggleObject (value, fallback = true) {
      if (value && typeof value === 'object') {
        return {
          active: this.toBooleanValue(value.active, fallback)
        }
      }
      return {
        active: this.toBooleanValue(value, fallback)
      }
    },

    /**
     * lance toutes les requêtes des stats
     */
    getAll () {
      this.getStatsOpenAI()
    },
    getStatsOpenAI () {
      this.loadingStatsToken = true
      // let parametres = '&dateStart=' + this.timestampStart
      // parametres += '&dateEnd=' + this.timestampEnd
      // parametres += '&licence=' + this.siteSelected.LIC_KEY
      let parametres = this.tokenParams + '&licence=' + this.siteSelected.LIC_KEY
      // console.log('getStatsOpenAI : ', parametres)
      // console.log('parametres', parametres)
      this.axios.get('get/statsTokensLicence.php?' + parametres)
      .then(response => {
        // console.log('getStatsOpenAI response', response)
        this.tokens = response.data
        this.loadingStatsToken = false
        this.stats = response.data
        this.updateSeries()
        // this.totalTempsAllChats = response.data.totalTempsAllChats // en secondes
        // this.tempsOccupationPartielle = response.data.tempsOccupationPartielle // en secondes
        // this.tempsOccupationBusy = response.data.tempsOccupationBusy // en secondes
        // this.moyenChatMax = response.data.moyenChatMax
        // this.moyenChatHeure = response.data.chatParHeure
      })
      .catch((error) => {
        console.log('error chargement des stats : ', error)
        this.loadingStatsToken = false
      })
    },
    // formatage des données stats pour aller dans les 'series'
    updateSeries () {
      // console.log('this.dateEndPicker', this.dateEndPicker)
      var tokensPrompt = 0
      var tokensCompletion = 0
      var days = []
      var addDay = moment.duration(1, 'd') // ajoute 1 jour pour coller à la date de fin
      let dateEnd = moment(this.dateEndPicker, 'YYYY[-]MM[-]DD').add(addDay).format('ddd D MMM YY')
      var period = {
        start: moment(this.dateStartPicker, 'YYYY[-]MM[-]DD'),
        end: moment(dateEnd, 'ddd D MMM YY')
      }
      var i = 0
      while (i < moment(period.end).diff(period.start, 'days')) {
        var date = moment(period.start).add(i, 'days').format('Y-M-D')
        var time = Number(moment(period.start).format('X')) // timestamp en seconde
        days.push(
          {
            time: time,
            tokens_prompt_chat: 0,
            tokens_completion_chat: 0,
            tokens_prompt_analyse: 0,
            tokens_completion_analyse: 0,
            tokens_prompt_tokenize: 0,
            tokens_completion_tokenize: 0,
            tokens_prompt_embedding: 0,
            tokens_completion_embedding: 0,
            date: date
          }
        )
        i++
      }
      // vide les tableau contenant les dates et les infos précédentes
      this.options.xAxis.categories = []
      this.options.series[0].data = []
      this.options.series[1].data = []
      this.options.series[2].data = []
      this.options.series[3].data = []
      this.options.series[4].data = []
      this.options.series[5].data = []
      this.options.series[6].data = []
      this.options.series[7].data = []
      // this.options.series[2].data = []
      // pour chaqies date du tableau
      // console.log('this.stats', this.stats)
      if (this.stats) {
        for (const stat of this.stats) {
          if (this.utilisation.value === 1) { // consommation de token
            // console.log('stat.tokens_prompt', stat.tokens_prompt)
            tokensPrompt += stat.tokens_prompt
            tokensCompletion += stat.tokens_completion
            // console.log(moment(stat.timestamp).format('Y-M-D'))
            for (const day of days) {
              if (moment(stat.timestamp).format('Y-M-D') === day.date) {
                // tokens utilisés pour le chat
                if (stat.description === 'completionChat' || stat.description === 'completion') {
                  day.tokens_prompt_chat += stat.tokens_prompt
                  day.tokens_completion_chat += stat.tokens_completion
                }
                // tokens utilisés pour l'analyse de chat
                if (stat.description === 'analyse chat') {
                  day.tokens_prompt_analyse += stat.tokens_prompt
                  day.tokens_completion_analyse += stat.tokens_completion
                }
                // tokens pour generation des mots clés
                if (stat.description === 'tokenize content') {
                  day.tokens_prompt_tokenize += stat.tokens_prompt
                  day.tokens_completion_tokenize += stat.tokens_completion
                }
                // tokens utilisés pour la génération d'un embedding
                if (stat.description === 'Embedding') {
                  day.tokens_prompt_embedding += stat.tokens_prompt
                  day.tokens_completion_embedding += stat.tokens_completion
                }
              }
            }
            // cout des tokens
          } else {
            // tokensPrompt += stat.tokens_prompt
            // tokensCompletion += stat.tokens_completion
            // console.log(moment(stat.timestamp).format('Y-M-D'))
            for (const day of days) {
              if (moment(stat.timestamp).format('Y-M-D') === day.date) {
                // tokens utilisés pour le chat
                // gpt-3.5-turbo-0613 prompt  = $0.0015 / 1k tokens
                // gpt-3.5-turbo-0613 completion = $0.002 / 1k tokens
                if (stat.description === 'completionChat') {
                  if (stat.model === 'gpt-3.5-turbo' || stat.model === 'gpt-3.5-turbo-0125' || stat.model === 'gpt-3.5-turbo-0613' || stat.model === 'gpt-3.5-turbo-1106') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.0005)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.0015)
                  } else if (stat.model === 'gpt-4-turbo' || stat.model === 'gpt-4-0613') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.01)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.03)
                  } else if (stat.model === 'gpt-4o') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.0025)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.010)
                  } else if (stat.model === 'gpt-4o-mini') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.00015)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.0006)
                  }
                }
                // text-davinci-003 prompt  = $0.0015 / 1k tokens
                // text-davinci-003 completion = $0.002 / 1k tokens
                if (stat.description === 'completion') {
                  if (stat.model === 'gpt-3.5-turbo' || stat.model === 'gpt-3.5-turbo-0125' || stat.model === 'text-davinci-003' || stat.model === 'gpt-3.5-turbo-0613' || stat.model === 'gpt-3.5-turbo-1106') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.0005)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.0015)
                  } else if (stat.model === 'gpt-4-turbo' || stat.model === 'gpt-4-0613') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.01)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.03)
                  } else if (stat.model === 'gpt-4o') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.0025)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.010)
                  } else if (stat.model === 'gpt-4o-mini') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.00015)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.0006)
                  }
                }
                // tokens utilisés pour l'analyse de chat
                // gpt-3.5-turbo-0613 prompt = $0.0015 / 1k tokens
                // gpt-3.5-turbo-0613 completion = $0.002 / 1k tokens
                if (stat.description === 'analyse chat') {
                  day.tokens_prompt_analyse += ((stat.tokens_prompt / 1000) * 0.0005)
                  day.tokens_completion_analyse += ((stat.tokens_completion / 1000) * 0.0015)
                }
                // tokens pour generation des mots clés
                // text-curie-001 prompt = $0.002 / 1k tokens
                // text-curie-001 completion = $0.002 / 1k tokens
                if (stat.description === 'tokenize content') {
                  day.tokens_prompt_tokenize += ((stat.tokens_prompt / 1000) * 0.0005)
                  day.tokens_completion_tokenize += ((stat.tokens_completion / 1000) * 0.0015)
                }
                // tokens utilisés pour la génération d'un embedding
                // text-embedding-ada-002-v2 prompt = $0.0001 / 1k tokens
                // text-embedding-ada-002-v2 completion = $0.0001 / 1k tokens
                if (stat.description === 'Embedding') {
                  day.tokens_prompt_embedding += ((stat.tokens_prompt / 1000) * 0.0001)
                  day.tokens_completion_embedding += ((stat.tokens_completion / 1000) * 0.0001)
                }
              }
            }
          }
        }
      }
      if (this.interval.value === 1) { // par jour
        this.options.series[0].type = 'area'
        this.options.series[1].type = 'area'
        this.options.series[2].type = 'area'
        this.options.series[3].type = 'area'
        this.options.series[4].type = 'area'
        this.options.series[5].type = 'area'
        this.options.series[6].type = 'area'
        this.options.series[7].type = 'area'
        _.forEach(days, day => {
          this.options.xAxis.categories.push(moment(day.date).format('ddd D MMM YY'))
          if (this.utilisation.value === 2) { // cout de token
            tokensPrompt += day.tokens_prompt_chat
            tokensPrompt += day.tokens_prompt_analyse
            tokensPrompt += day.tokens_prompt_tokenize
            tokensPrompt += day.tokens_prompt_embedding
            tokensCompletion += day.tokens_completion_chat
            tokensCompletion += day.tokens_completion_analyse
            tokensCompletion += day.tokens_completion_tokenize
            tokensCompletion += day.tokens_completion_embedding
            // console.log('day.tokens_prompt_chat', day.tokens_prompt_chat)
            // console.log('day.tokens_prompt_chat ::', day.tokens_prompt_chat.toFixed(3))
            this.options.series[0].data.push(Number(day.tokens_prompt_chat.toFixed(3)))
            this.options.series[1].data.push(Number(day.tokens_completion_chat.toFixed(3)))
            this.options.series[2].data.push(Number(day.tokens_prompt_analyse.toFixed(3)))
            this.options.series[3].data.push(Number(day.tokens_completion_analyse.toFixed(3)))
            this.options.series[4].data.push(Number(day.tokens_prompt_tokenize.toFixed(3)))
            this.options.series[5].data.push(Number(day.tokens_completion_tokenize.toFixed(3)))
            this.options.series[6].data.push(Number(day.tokens_prompt_embedding.toFixed(3)))
            this.options.series[7].data.push(Number(day.tokens_completion_embedding.toFixed(3)))
          } else {
            this.options.series[0].data.push(day.tokens_prompt_chat)
            this.options.series[1].data.push(day.tokens_completion_chat)
            this.options.series[2].data.push(day.tokens_prompt_analyse)
            this.options.series[3].data.push(day.tokens_completion_analyse)
            this.options.series[4].data.push(day.tokens_prompt_tokenize)
            this.options.series[5].data.push(day.tokens_completion_tokenize)
            this.options.series[6].data.push(day.tokens_prompt_embedding)
            this.options.series[7].data.push(day.tokens_completion_embedding)
          }
        })
      } else { // par mois
        this.options.series[0].type = 'column'
        this.options.series[1].type = 'column'
        this.options.series[2].type = 'column'
        this.options.series[3].type = 'column'
        this.options.series[4].type = 'column'
        this.options.series[5].type = 'column'
        this.options.series[6].type = 'column'
        this.options.series[7].type = 'column'
        _.forEach(days, day => {
          // vérifie que le mois du jour parcouru n'est pas déjà présent dans le tableau des x
          let found = -1
          for (var i = 0; i < this.options.xAxis.categories.length; i++) {
            if (this.options.xAxis.categories[i] === moment(day.date).format('MMMM YYYY')) {
              found = i
            }
          }
          if (found === -1) {
            // ajout du mois dans le tableau des x
            this.options.xAxis.categories.push(moment(day.date).format('MMMM YYYY'))
            this.options.series[0].data.push(day.tokens_prompt_chat)
            this.options.series[1].data.push(day.tokens_completion_chat)
            this.options.series[2].data.push(day.tokens_prompt_analyse)
            this.options.series[3].data.push(day.tokens_completion_analyse)
            this.options.series[4].data.push(day.tokens_prompt_tokenize)
            this.options.series[5].data.push(day.tokens_completion_tokenize)
            this.options.series[6].data.push(day.tokens_prompt_embedding)
            this.options.series[7].data.push(day.tokens_completion_embedding)
          }
          // ajout des valeurs dans le mois correspondant
          this.options.series[0].data[found] += day.tokens_prompt_chat
          this.options.series[1].data[found] += day.tokens_completion_chat
          this.options.series[2].data[found] += day.tokens_prompt_analyse
          this.options.series[3].data[found] += day.tokens_completion_analyse
          this.options.series[4].data[found] += day.tokens_prompt_tokenize
          this.options.series[5].data[found] += day.tokens_completion_tokenize
          this.options.series[6].data[found] += day.tokens_prompt_embedding
          this.options.series[7].data[found] += day.tokens_completion_embedding
          if (this.utilisation.value === 2) { // cout de token
            tokensPrompt += day.tokens_prompt_chat
            tokensPrompt += day.tokens_prompt_analyse
            tokensPrompt += day.tokens_prompt_tokenize
            tokensPrompt += day.tokens_prompt_embedding
            tokensCompletion += day.tokens_completion_chat
            tokensCompletion += day.tokens_completion_analyse
            tokensCompletion += day.tokens_completion_tokenize
            tokensCompletion += day.tokens_completion_embedding
          }
        })
        if (this.utilisation.value === 2) { // cout de token
          for (const serie of this.options.series) {
            for (const index in serie.data) {
              serie.data[index] = Number(serie.data[index].toFixed(3))
            }
          }
        }
      }
      // for (const index in this.options.series[0].data) {
      //   this.options.series[0].data[index] = this.options.series[0].data[index].toFixed(3)
      // }
      // console.log(' this.options.series[0].data', this.options.series[0].data)
      // calcule le total des tokens utilisés
      this.responseToken[0].tokensPrompt = tokensPrompt
      this.responseToken[1].tokensCompletion = tokensCompletion
      this.responseToken[2].tokensTotal = tokensPrompt + tokensCompletion
      // type de graphique en fonction du nombre de jour de l'intervalle
      if (this.$parent.nbDays === 1 || this.interval.value !== 1) {
        this.options.series[0].type = 'column'
        this.options.series[1].type = 'column'
      } else {
        this.options.series[0].type = 'area'
        this.options.series[1].type = 'area'
      }
      this.timestampStartPicker
      // console.log('days', days)
    },
    initPeriod () {
      // periode // 0 = personnalisée, 1 = hier, 2 = Cette semaine etc.
      this.period = _.isNil(this.$store.state._Stats.period) ? 1 : this.$store.state._Stats.period
      this.initDates()
    },
    initDates () {
      // récupère les dates qui sont dans le store si la période n'est pas personnalisée
      let periodPerso = (this.period === 0)
      if (periodPerso) {
        // date de fin
        // par défaut la date de fin est la date du jour
        this.dateEndPicker = _.isEmpty(this.$store.state._Stats.dateEnd)
        ? new Date(moment().startOf('day'))
        : new Date(this.$store.state._Stats.dateEnd)
        // date de début
        // par défaut la date de début est une semaine avant la date du jour
        this.dateStartPicker = _.isEmpty(this.$store.state._Stats.dateEnd)
        ? new Date(moment().subtract(1, 'week'))
        : new Date(this.$store.state._Stats.dateStart)
      } else {
        this.dateEndPicker = new Date(moment())
        switch (this.period) {
          case 1: // Hier
            this.dateStartPicker = new Date(moment().subtract(1, 'day'))
            this.dateEndPicker = new Date(moment().subtract(1, 'day'))
            break
          case 2: // Cette semaine
            this.dateStartPicker = new Date(moment().startOf('week'))
            this.dateEndPicker = new Date(moment().subtract(0, 'day'))
            break
          case 3: // Ce mois-ci
            this.dateStartPicker = new Date(moment().startOf('month'))
            this.dateEndPicker = new Date(moment().subtract(0, 'day'))
            break
          case 4: // 7 derniers jours
            this.dateStartPicker = new Date(moment().subtract(7, 'day'))
            this.dateEndPicker = new Date(moment().subtract(1, 'day'))
            break
          case 5: // 30 derniers jours
            this.dateStartPicker = new Date(moment().subtract(30, 'day'))
            this.dateEndPicker = new Date(moment().subtract(1, 'day'))
            break
          case 6: // la semaine dernière
            this.dateStartPicker = new Date(moment().startOf('week').subtract(1, 'week'))
            this.dateEndPicker = new Date(moment().startOf('week').subtract(1, 'day'))
            break
          default:
            this.initPeriod()
        }
      }
      // Formatage et Parsing des dates
      this.dateStartDisplayed = this.formatDate(this.dateStartPicker)
      this.dateStartPicker = this.parseDate(this.dateStartDisplayed)
      this.timestampStart = this.formatTimestampDate(this.dateStartPicker)
      this.dateEndDisplayed = this.formatDate(this.dateEndPicker)
      this.dateEndPicker = this.parseDate(this.dateEndDisplayed)
      this.timestampEnd = this.formatTimestampDate(this.dateEndPicker)
    },
    formatTimestampDate (date) {
      // console.log('date', date)
      return !date
        ? 'Aucune date'
        : moment(date, 'YYYY[-]MM[-]DD').valueOf()
    },
    formatDate (date) {
      return !date
        ? 'Aucune date'
        : moment(date, 'YYYY[-]MM[-]DD').format('ddd LL')
    },
    parseDate (date) {
      let formatOfDate = moment(date, 'ddd LL').format('ddd LL') === date
        ? 'ddd LL'
        : 'YYYY[-]MM[-]DD'
      return !date || !moment(date, formatOfDate).isValid()
        ? null
        : moment(date, formatOfDate).format('YYYY[-]MM[-]DD')
    },

    // charge le prompt du bot
    getPrompt (userid, licKey) {
      let licencekey = this.$store.state._Sites.siteSelected.LIC_KEY
      if (licKey) {
        licencekey = licKey
      }
      this.isHydratingPromptSections = true
      if (this.promptSectionDraftSaveTimer) {
        clearTimeout(this.promptSectionDraftSaveTimer)
        this.promptSectionDraftSaveTimer = null
      }
      this.loadingPrompt = true
      this.axios.get('get/openAI_prompt.php?userID=' + userid + '&sitekey=' + licencekey)
      .then(response => {
        this.analyseChat = response.data.analyseChat ? JSON.parse(response.data.analyseChat) : this.analyseChat
        this.analyseChatRef = response.data.analyseChat ? JSON.parse(response.data.analyseChat) : this.analyseChat
        this.sliderSearchResponse = response.data.sliderSearchResponse ? response.data.sliderSearchResponse : this.sliderSearchResponse
        this.sliderSearchResponseRef = response.data.sliderSearchResponse ? response.data.sliderSearchResponse : this.sliderSearchResponse
        this.sliderTemp = response.data.sliderTemp ? response.data.sliderTemp : this.sliderTemp
        this.sliderTempRef = response.data.sliderTemp ? response.data.sliderTemp : this.sliderTemp
        this.sliderTokenResponse = response.data.sliderTokenResponse ? response.data.sliderTokenResponse : this.sliderTokenResponse
        this.sliderTokenResponseRef = response.data.sliderTokenResponse ? response.data.sliderTokenResponse : this.sliderTokenResponse
        this.prompt = response.data.prompt ? response.data.prompt : this.prompt
        this.prompt_personality = response.data.prompt_personality ? response.data.prompt_personality : this.prompt_personality
        this.prompt_environment = response.data.prompt_environment ? response.data.prompt_environment : this.prompt_environment
        this.prompt_objectif = response.data.prompt_objectif ? response.data.prompt_objectif : this.prompt_objectif
        this.prompt_communication = response.data.prompt_communication ? response.data.prompt_communication : this.prompt_communication
        this.prompt_questions = response.data.prompt_questions ? response.data.prompt_questions : this.prompt_questions
        this.prompt_rules = response.data.prompt_rules ? response.data.prompt_rules : this.prompt_rules
        this.prompt_tools = response.data.prompt_tools ? response.data.prompt_tools : this.prompt_tools
        this.prompt_custom = response.data.prompt_custom ? response.data.prompt_custom : this.prompt_custom
        this.prompt_name = typeof response.data.prompt_name === 'string' ? response.data.prompt_name : this.prompt_name
        this.prompt_comment = typeof response.data.prompt_comment === 'string' ? response.data.prompt_comment : this.prompt_comment
        this.promptRef = response.data.prompt ? response.data.prompt : this.prompt
        this.prompt_personalityRef = response.data.prompt_personality ? response.data.prompt_personality : this.prompt_personality
        this.prompt_environmentRef = response.data.prompt_environment ? response.data.prompt_environment : this.prompt_environment
        this.prompt_objectifRef = response.data.prompt_objectif ? response.data.prompt_objectif : this.prompt_objectif
        this.prompt_communicationRef = response.data.prompt_communication ? response.data.prompt_communication : this.prompt_communication
        this.prompt_questionsRef = response.data.prompt_questions ? response.data.prompt_questions : this.prompt_questions
        this.prompt_rulesRef = response.data.prompt_rules ? response.data.prompt_rules : this.prompt_rules
        this.prompt_toolsRef = response.data.prompt_tools ? response.data.prompt_tools : this.prompt_tools
        this.prompt_customRef = response.data.prompt_custom ? response.data.prompt_custom : this.prompt_custom
        this.prompt_nameRef = typeof response.data.prompt_name === 'string' ? response.data.prompt_name : this.prompt_nameRef
        this.prompt_commentRef = typeof response.data.prompt_comment === 'string' ? response.data.prompt_comment : this.prompt_commentRef
        this.promptSearch = response.data.promptSearch ? response.data.promptSearch : this.promptSearch
        this.promptSearchRef = response.data.promptSearch ? response.data.promptSearch : this.promptSearch
        this.productSelectAuto = response.data.productSelectAuto
        this.productSelectAutoRef = response.data.productSelectAuto

        if (this.prompt !== '' && this.prompt_personality === '' && this.prompt_environment === '' && this.prompt_objectif === '' && this.prompt_communication === '' && this.prompt_questions === '' && this.prompt_rules === '' && this.prompt_tools === '' && this.prompt_custom === '') {
          this.prompt_custom = this.prompt
        }
        if (response.data.productSelectAuto === 'true') {
          this.productSelectAuto = true
          this.productSelectAutoRef = true
        } else {
          this.productSelectAuto = false
          this.productSelectAutoRef = false
        }

        this.promptResume = response.data.promptResume ? response.data.promptResume : this.promptResume
        this.promptResumeRef = response.data.promptResume ? response.data.promptResume : this.promptResume
        this.functionCall = response.data.functionCall ? response.data.functionCall : this.functionCall
        this.functionCallOnOff = this.normalizeFunctionCallOnOff(response.data.functionCallOnOff ? response.data.functionCallOnOff : this.functionCallOnOff)
        this.functionCallOnOffRef = _.cloneDeep(this.functionCallOnOff)
        // this.functionCallRef = response.data.functionCall ? response.data.functionCall : this.functionCall
        this.parsingSelectif = JSON.parse(response.data.parsingSelectif).length ? JSON.parse(response.data.parsingSelectif) : this.parsingSelectif
        this.parsingSelectifRef = _.cloneDeep(response.data.parsingSelectif.length ? JSON.parse(response.data.parsingSelectif) : this.parsingSelectif)
        this.dialog = response.data.dialog
        this.dialogRef = response.data.dialog
        // this.parseElement = response.data.parseElement
        // this.parseElementRef = response.data.parseElement
        this.messageAccueil = this.normalizeNullableText(response.data.messageAccueil)
        this.messageAccueilRef = this.messageAccueil
        this.questionAuto1 = this.normalizeNullableText(response.data.questionAuto1)
        this.questionAuto2 = this.normalizeNullableText(response.data.questionAuto2)
        this.questionAuto3 = this.normalizeNullableText(response.data.questionAuto3)
        this.questionAuto4 = this.normalizeNullableText(response.data.questionAuto4)
        this.comportment = response.data.comportment
        this.showEx = response.data.showEx
        this.questionAuto1Ref = this.questionAuto1
        this.questionAuto2Ref = this.questionAuto2
        this.questionAuto3Ref = this.questionAuto3
        this.questionAuto4Ref = this.questionAuto4
        this.parseUrl = response.data.parseUrl
        this.parseUrlRef = response.data.parseUrl
        // this.methodSelect = response.data.methodSelect
        // this.methodSelectRef = response.data.methodSelect
        this.APISelect = {name: response.data.APISelect}
        this.APISelectRef = {name: response.data.APISelect}
        this.modelSelect = {name: response.data.modelSelect, tokens: response.data.modelTokens}
        this.modelSelectRef = {name: response.data.modelSelect, tokens: response.data.modelTokens}
        this.botStream = response.data.botStream
        this.botStreamRef = response.data.botStream
        this.pageScanne = response.data.pageScanne
        this.pageScanneRef = response.data.pageScanne
        this.timeSelected = response.data.timeSelected
        this.timeSelectedRef = response.data.timeSelected
        if (response.data.botStream === 'true') {
          this.botStream = true
          this.botStreamRef = true
        } else {
          this.botStream = false
          this.botStreamRef = false
        }
        if (response.data.majCronTab === 'true') {
          this.majCronTab = true
          this.majCronTabRef = true
        } else {
          this.majCronTab = false
          this.majCronTabRef = false
        }
        if (response.data.majUrlAuto === 'true') {
          this.majUrlAuto = true
          this.majUrlAutoRef = true
        } else {
          this.majUrlAuto = false
          this.majUrlAutoRef = false
        }
        // if (response.data.majCronTabPage === 'true') {
        //   this.majCronTabPage = true
        //   this.majCronTabPageRef = true
        // } else {
        //   this.majCronTabPage = false
        //   this.majCronTabPageRef = false
        // }
        // if (response.data.majUrlAutoPage === 'true') {
          // this.majUrlAutoPage = true
          // this.majUrlAutoPageRef = true
        // } else {
          // this.majUrlAutoPage = false
          // this.majUrlAutoPageRef = false
        // }
        this.loadPromptVersionCount(licencekey)
        this.applyPromptSectionDraftFromLocalStorage(licencekey)
      })
      .catch(_ => {})
      .then(_ => {
        this.isHydratingPromptSections = false
        this.loadingPrompt = false
      })
    },
    getPromptCsat (userid, licKey) {
      let licencekey = this.$store.state._Sites.siteSelected.LIC_KEY
      if (licKey) {
        licencekey = licKey
      }
      this.loadingPromptCsat = true
      this.axios.get('get/openAI_prompt_csat.php?userID=' + userid + '&sitekey=' + licencekey)
      .then(response => {
        this.prompt_csat_personality = response.data.prompt_csat_personality ? response.data.prompt_csat_personality : ''
        this.prompt_csat_mission = response.data.prompt_csat_mission ? response.data.prompt_csat_mission : ''
        this.prompt_csat_rules = response.data.prompt_csat_rules ? response.data.prompt_csat_rules : ''
        this.prompt_csat_block4 = response.data.prompt_csat_block4 ? response.data.prompt_csat_block4 : ''
        this.prompt_csat_name = typeof response.data.prompt_name === 'string' ? response.data.prompt_name : ''
        this.prompt_csat_comment = typeof response.data.prompt_comment === 'string' ? response.data.prompt_comment : ''

        this.prompt_csat_personalityRef = this.prompt_csat_personality
        this.prompt_csat_missionRef = this.prompt_csat_mission
        this.prompt_csat_rulesRef = this.prompt_csat_rules
        this.prompt_csat_block4Ref = this.prompt_csat_block4
        this.prompt_csat_nameRef = this.prompt_csat_name
        this.prompt_csat_commentRef = this.prompt_csat_comment

        this.loadPromptCsatVersionCount(licencekey)
      })
      .catch(() => {})
      .then(() => {
        this.loadingPromptCsat = false
      })
    },
    loadPromptCsatVersionCount (licKey) {
      const sitekey = licKey || (this.siteSelected ? this.siteSelected.LIC_KEY : '')
      if (!sitekey) return
      this.axios.get('get/prompt_csat_version.php?sitekey=' + sitekey)
        .then(response => {
          const list = Array.isArray(response.data) ? response.data : []
          this.promptCsatVersionCount = list.length
        })
        .catch(() => {
          this.promptCsatVersionCount = 0
        })
    },
    savePromptCsat () {
      if (!this.siteSelected || !this.siteSelected.LIC_KEY) return
      const dataToPost = new window.FormData()
      dataToPost.append('LIC_KEY', this.siteSelected.LIC_KEY)
      dataToPost.append('userID', this.botUserId)
      dataToPost.append('userJob', this.userJob)
      dataToPost.append('userName', this.userName)
      dataToPost.append('prompt_csat_personality', this.prompt_csat_personality)
      dataToPost.append('prompt_csat_mission', this.prompt_csat_mission)
      dataToPost.append('prompt_csat_rules', this.prompt_csat_rules)
      dataToPost.append('prompt_csat_block4', this.prompt_csat_block4)
      dataToPost.append('prompt_name', this.prompt_csat_name)
      dataToPost.append('prompt_comment', this.prompt_csat_comment)
      dataToPost.append('prompt_who', (this.user && this.user.mail) ? this.user.mail : '')
      dataToPost.append('scenario_id', 'manual')
      dataToPost.append('scenario_label', 'Prompt CSAT')

      this.loadingPromptCsat = true
      return this.axios.post('post/openAI_prompt_csat.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .then(() => {
          this.prompt_csat_personalityRef = this.prompt_csat_personality
          this.prompt_csat_missionRef = this.prompt_csat_mission
          this.prompt_csat_rulesRef = this.prompt_csat_rules
          this.prompt_csat_block4Ref = this.prompt_csat_block4
          this.prompt_csat_nameRef = this.prompt_csat_name
          this.prompt_csat_commentRef = this.prompt_csat_comment
          this.loadPromptCsatVersionCount(this.siteSelected.LIC_KEY)
        })
        .catch(() => {})
        .then(() => {
          this.loadingPromptCsat = false
        })
    },
    buildPromptCsatPreview () {
      const parts = [
        'Personality :\n' + (this.prompt_csat_personality || ''),
        'Mission :\n' + (this.prompt_csat_mission || ''),
        'Regles :\n' + (this.prompt_csat_rules || ''),
        'Bloc 4 :\n' + (this.prompt_csat_block4 || '')
      ]
      return parts.join('\n\n').trim()
    },

    // ajoute une tache cron
    async addMAJ () {
      console.log('sauvegarde MAJ auto :')
      // calcule le temps en seconde
      if (this.timeSelected === 3) {
        // annuel
        this.MajTTL = 31536000
      } else if (this.timeSelected === 2) {
        // mensuel
        this.MajTTL = 2592000
      } else if (this.timeSelected === 1) {
        // hebdomadaire
        this.MajTTL = 604800
      } else {
        // quotidien
        this.MajTTL = 86400
      }
      // si il y a une page alors page de scane sitemap.xml
      if (this.pageScanne) {
        this.MajSitemap = false
      } else {
        this.MajSitemap = true
      }
      return new Promise(async (resolve, reject) => {
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.site = this.parseUrl
        dataToPost.parsingSelectif = this.parsingSelectif
        dataToPost.auto = this.majUrlAuto
        dataToPost.promptResume = this.promptResume
        dataToPost.page = this.pageScanne
        dataToPost.ttl = this.MajTTL
        dataToPost.id = Date.now()
        dataToPost.sitemap = this.MajSitemap
        const response = await this.axios.post(this.serveurAI + 'addMAJ',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // console.log('getLicenceUrls retour', response.data)
        if (response.data.retour) {
          resolve({'retour': 1, 'info': response.data.info})
          console.log('Création de la tache cron : ', response.data.info)
        } else {
          reject({'retour': 0, 'info': 'erreur maj'})
          console.log('Erreur de création de la tache cron : ')
        }
      })
    },

    // efface une tache cron
    async delMAJ () {
      console.log('delMAJ ')
      return new Promise(async (resolve, reject) => {
        console.log('delMAJ resolve', resolve)
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        const response = await this.axios.post(this.serveurAI + 'delMAJ',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        console.log('delMAJ response.data', response)
        if (response.data.retour) {
          resolve({'retour': 1, 'info': response.data.info})
          console.log('Suppression de la tache cron : ', response.data.info)
        } else {
          reject({'retour': 0, 'info': 'erreur maj'})
          console.log('Erreur de création de la tache cron : ')
        }
      })
    },

    // // ajoute une tache cron
    // async addCron (callback) {
    //   this.promptResume = String(this.promptResume)
    //   console.log('this.promptResume  : ', this.promptResume)
    //   const phrases = this.promptResume.split(/[\r\n]+/)
    //   // console.log('phrases  : ', phrases[0])
    //   var newParseElements = this.parseElement
    //   var newResumePrompt = phrases.join(' ')
    //   // console.log('newResumePrompt 1 : ', newResumePrompt)
    //   // var newResumePrompt = this.promptResume.replaceAll(exReg, 'toto')
    //   // var newResumePrompt = this.promptResume.replace(reg, ' ')
    //   // console.log('parseElement 2 : ', newParseElements)
    //   // il faut retirer les saut de ligne dans le promptResume sinon cela provoque une erreur da requete
    //   // console.log('add cron resumePrompt : ', newResumePrompt)
    //   let dataToPost = {}
    //   dataToPost.licence = this.siteSelected.LIC_KEY
    //   dataToPost.site = this.parseUrl
    //   dataToPost.method = this.methodSelect
    //   dataToPost.parse = newParseElements
    //   dataToPost.majAuto = this.majUrlAuto
    //   dataToPost.promptResume = newResumePrompt
    //   const response = await this.axios.post(this.serveurAI + 'addCronJob',
    //   dataToPost,
    //     {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    //   )
    //   // console.log('getLicenceUrls retour', response.data)
    //   if (response.data.retour) {
    //     callback({'retour': 1, 'info': response.data.info})
    //     // console.log('Création de la tache cron : ', response.data.info)
    //   } else {
    //     callback({'retour': 0, 'info': response.data.info})
    //     // console.log('Erreur de création de la tache cron : ', response.data.info)
    //   }
    // },
    // efface une tache cron
    // async delCron (callback) {
    //   let dataToPost = {}
    //   dataToPost.licence = this.siteSelected.LIC_KEY
    //   const response = await this.axios.post(this.serveurAI + 'deleteCronJob',
    //   dataToPost,
    //     {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    //   )
    //   // console.log('getLicenceUrls retour', response.data)
    //   if (response.data.retour) {
    //     this.infoCron = response.data.info
    //     callback({'retour': 1, 'info': response.data.info})
    //     // console.log('Suppression de la tache cron : ', response.data.info)
    //   } else {
    //     this.infoCron = response.data.info
    //     callback({'retour': 0, 'info': response.data.info})
    //     // console.log('Erreur de suppression de la tache cron : ', response.data.info)
    //   }
    // },

    // // ajoute une tache cron scanne page
    // async addCronPage (callback) {
    //   // console.log('addCronPage')
    //   this.promptResume = String(this.promptResume)
    //   // console.log('this.promptResume  : ', this.promptResume)
    //   const phrases = this.promptResume.split(/[\r\n]+/)
    //   // console.log('phrases  : ', phrases[0])
    //   var newParseElements = this.parseElement
    //   var newResumePrompt = phrases.join(' ')
    //   // console.log('newResumePrompt 1 : ', newResumePrompt)
    //   // var newResumePrompt = this.promptResume.replaceAll(exReg, 'toto')
    //   // var newResumePrompt = this.promptResume.replace(reg, ' ')
    //   newResumePrompt = newResumePrompt.replaceAll('#', '::43::') // le caractere # ne passe pas en wget
    //   // newResumePrompt = newResumePrompt.replaceAll(',', '%2C')
    //   // newResumePrompt = newResumePrompt.replaceAll(' ', '%20')
    //   // console.log('parseElement 2 : ', newParseElements)
    //   newParseElements = newParseElements.replaceAll('#', '::43::') // le caractere # ne passe pas en wget
    //   // newParseElements = newParseElements.replaceAll(',', '%2C')
    //   // newParseElements = newParseElements.replaceAll(' ', '%20')
    //   // il faut retirer les saut de ligne dans le promptResume sinon cela provoque une erreur da requete
    //   // console.log('add cron resumePrompt : ', newResumePrompt)
    //   let dataToPost = {}
    //   dataToPost.page = this.pageScanne
    //   dataToPost.licence = this.siteSelected.LIC_KEY
    //   dataToPost.site = this.parseUrl
    //   dataToPost.method = this.methodSelect
    //   dataToPost.parse = newParseElements
    //   dataToPost.majAuto = this.majUrlAutoPage
    //   dataToPost.promptResume = newResumePrompt
    //   const response = await this.axios.post(this.serveurAI + 'addCronJob',
    //   dataToPost,
    //     {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    //   )
    //   // console.log('getLicenceUrls retour', response.data)
    //   if (response.data.retour) {
    //     callback({'retour': 1, 'info': response.data.info})
    //     // console.log('Création de la tache cron : ', response.data.info)
    //   } else {
    //     callback({'retour': 0, 'info': response.data.info})
    //     // console.log('Erreur de création de la tache cron : ', response.data.info)
    //   }
    // },
    // efface une tache cron scanne page
    // async delCronPage (callback) {
    //   // console.log('delCronPage')
    //   let dataToPost = {}
    //   dataToPost.page = true
    //   dataToPost.licence = this.siteSelected.LIC_KEY
    //   const response = await this.axios.post(this.serveurAI + 'deleteCronJob',
    //   dataToPost,
    //     {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    //   )
    //   // console.log('getLicenceUrls retour', response.data)
    //   if (response.data.retour) {
    //     this.infoCron = response.data.info
    //     callback({'retour': 1, 'info': response.data.info})
    //     // console.log('Suppression de la tache cron : ', response.data.info)
    //   } else {
    //     this.infoCron = response.data.info
    //     callback({'retour': 0, 'info': response.data.info})
    //     // console.log('Erreur de suppression de la tache cron : ', response.data.info)
    //   }
    // },

    // teste le prompte de resumé sur la premiere url de la liste
    async testPromptResume () {
      // console.log('test prompt resume : ', this.selectedUrl)
      this.loadingResumePrompt = true
      var nameReq = 'test-resume'
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeUrls = [{url: this.selectedUrl}]
      dataToPost.parsingSelectif = this.parsingSelectif
      dataToPost.method = this.methodSelect
      dataToPost.parse = this.parseElement
      dataToPost.promptResume = this.promptResume
      // dataToPost.prefix = prefix
      const response = await this.axios.post(this.serveurAI + nameReq,
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // console.log('test-resume response : ', response)
      if (response.data.retour) {
        this.contentResume = response.data.data
        this.contentResumeKeys = JSON.stringify(response.data.keys, null, '\t')
        this.loadingResumePrompt = false
      } else {
        this.contentResume = response.data.info
        this.contentResumeKeys = ''
        this.loadingResumePrompt = false
      }
    },

    // teste le prompte de resumé sur des produits api
    async testPromptResumeAPI () {
      this.loadingResumePromptAPI = true
      var nameReq = 'test-resume-api'
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeUrls = [{url: this.selectedProduct}]
      dataToPost.parsingSelectif = this.parsingSelectif
      dataToPost.method = this.methodSelect
      dataToPost.parse = this.parseElement
      dataToPost.promptResume = this.promptResume
      const response = await this.axios.post(this.serveurAI + nameReq,
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // console.log('test-resume response : ', response)
      if (response.data.retour) {
        this.contentResume = response.data.data
        this.contentResumeKeys = JSON.stringify(response.data.keys, null, '\t')
        this.loadingResumePromptAPI = false
      } else {
        this.contentResume = response.data.info
        this.contentResumeKeys = ''
        this.loadingResumePromptAPI = false
      }
    },

    // enregidstrer le prompt du bot
    async savePrompt () {
      // console.log('this.function3', this.function3)
      // preparation des fonctionCall
      var newFunctionCall = []
      // console.log('function0', this.function0)
      if (this.function0 !== '') {
        newFunctionCall.push(JSON.parse(this.function0))
      }
      if (this.function1 !== '') {
        newFunctionCall.push(JSON.parse(this.function1))
      }
      if (this.function2 !== '') {
        newFunctionCall.push(JSON.parse(this.function2))
      }
      if (this.function3 !== '') {
        newFunctionCall.push(JSON.parse(this.function3))
      }
      if (this.function4 !== '') {
        newFunctionCall.push(JSON.parse(this.function4))
      }
      if (this.function5 !== '') {
        newFunctionCall.push(JSON.parse(this.function5))
      }
      if (this.function6 !== '') {
        newFunctionCall.push(JSON.parse(this.function6))
      }
      if (this.function7 !== '') {
        newFunctionCall.push(JSON.parse(this.function7))
      }
      if (this.function8 !== '') {
        newFunctionCall.push(JSON.parse(this.function8))
      }

      // const reg = /(\r\n|\t|\n|\r)/gm // efface les tabulation et retour à la ligne
      // newFunctionCall = JSON.stringify(newFunctionCall)
      // newFunctionCall = String(newFunctionCall.replace(reg, '  '))
      // console.log('newFunctionCall 1 : ', newFunctionCall)

      // console.log('newFunctionCall : ', newFunctionCall)
      if (!newFunctionCall) {
        newFunctionCall = []
      }
      this.functionCall = JSON.stringify(newFunctionCall)
      // console.log('this.Parsings : ', JSON.stringify(this.Parsings))
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('LIC_ID', this.siteSelected.LIC_ID)
      dataToPost.append('LIC_KEY', this.siteSelected.LIC_KEY)
      dataToPost.append('ENT_ID', this.user.entId)
      dataToPost.append('userID', this.botUserId)
      dataToPost.append('userJob', this.userJob)
      dataToPost.append('userName', this.userName)
      dataToPost.append('prompt', this.prompt)
      dataToPost.append('prompt_personality', this.prompt_personality)
      dataToPost.append('prompt_environment', this.prompt_environment)
      dataToPost.append('prompt_objectif', this.prompt_objectif)
      dataToPost.append('prompt_communication', this.prompt_communication)
      dataToPost.append('prompt_questions', this.prompt_questions)
      dataToPost.append('prompt_rules', this.prompt_rules)
      dataToPost.append('prompt_tools', this.prompt_tools)
      dataToPost.append('prompt_custom', this.prompt_custom)
      dataToPost.append('prompt_name', this.prompt_name)
      dataToPost.append('prompt_comment', this.prompt_comment)
      dataToPost.append('prompt_who', (this.user && this.user.mail) ? this.user.mail : '')
      dataToPost.append('promptSearch', this.promptSearch)
      dataToPost.append('productSelectAuto', this.productSelectAuto)
      dataToPost.append('promptResume', this.promptResume)
      dataToPost.append('functionCall', this.functionCall)
      dataToPost.append('functionCallOnOff', JSON.stringify(this.functionCallOnOff))
      dataToPost.append('parsingSelectif', JSON.stringify(this.parsingSelectif))
      dataToPost.append('dialog', this.dialog)
      dataToPost.append('parseUrl', this.parseUrl)
      dataToPost.append('messageAccueil', this.normalizeNullableText(this.messageAccueil))
      dataToPost.append('questionAuto1', this.normalizeNullableText(this.questionAuto1))
      dataToPost.append('questionAuto2', this.normalizeNullableText(this.questionAuto2))
      dataToPost.append('questionAuto3', this.normalizeNullableText(this.questionAuto3))
      dataToPost.append('questionAuto4', this.normalizeNullableText(this.questionAuto4))
      dataToPost.append('comportment', this.comportment ? 1 : 0)
      dataToPost.append('showEx', this.showEx ? 1 : 0)
      dataToPost.append('parseElement', this.parseElement)
      dataToPost.append('methodSelect', this.methodSelect)
      dataToPost.append('APISelect', this.APISelect.name)
      dataToPost.append('modelSelect', this.modelSelect.name)
      dataToPost.append('modelTokens', this.modelSelect.tokens)
      dataToPost.append('sliderSearchResponse', this.sliderSearchResponse)
      dataToPost.append('sliderTokenResponse', this.sliderTokenResponse)
      dataToPost.append('sliderTemp', this.sliderTemp)
      dataToPost.append('analyseChat', JSON.stringify(this.analyseChat))
      dataToPost.append('botStream', this.botStream)
      dataToPost.append('pageScanne', this.pageScanne)
      dataToPost.append('majCronTab', this.majCronTab)
      dataToPost.append('majUrlAuto', this.majUrlAuto)
      // dataToPost.append('majCronTabPage', this.majCronTabPage)
      // dataToPost.append('majUrlAutoPage', this.majUrlAutoPage)
      dataToPost.append('whoDidThis', this.$store.state._User.id)
      dataToPost.append('timeSelected', this.timeSelected)

      this.loadingSavePrompt = true
      this.axios.post('post/openAI_prompt.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(async (response) => {
        // console.log('response : ', response.data)
        // changement de crontab sitemap.xml
        // if (this.majCronTabRef !== this.majCronTab) {
        if (this.majCronTab) {
          // enregistrer dsans redis tourtes les données de sauvegarde auto
          await this.addMAJ()
          .then(async (result) => {
            if (result.retour) {
              console.log('addMAJ result :', result.retour)
              this.statusSaveCron = result.retour
              this.infoCron = 'Création de la crontab'
              // console.log('création de la crontab')
              this.majCronTabRef = this.majCronTab
              this.majUrlAutoRef = this.majUrlAuto
              this.timeSelectedRef = this.timeSelected
              this.functionCallOnOffRef = _.cloneDeep(this.functionCallOnOff)
              // this.parseElementRef = this.parseElement
              this.parseUrlRef = this.parseUrl
            } else {
              this.statusSaveCron = result.retour
              this.infoCron = 'Probleme de création de la tache cron : ' + result.info
              // console.log('Probleme de création de la tache cron : ', response.info)
            }
          })
          .catch((reject) => {
            console.log('addMAJ reject :', reject)
            console.log('Plus de sauvegarde MAJ auto :', reject)
          })
        } else {
          // efface de redis les infos de mise à jour auto
          console.log('Plus de sauvegarde MAJ auto :')
          await this.delMAJ()
          .then(async (result) => {
            if (result.retour) {
              console.log('delMAJ result :', result.retour)
              this.statusSaveCron = result.retour
              this.infoCron = 'suppression de la crontab'
              // console.log('création de la crontab')
              this.majCronTabRef = this.majCronTab
              this.majUrlAutoRef = this.majUrlAuto
              this.timeSelectedRef = this.timeSelected
              this.functionCallOnOffRef = _.cloneDeep(this.functionCallOnOff)
              // this.methodSelectRef = this.methodSelect
              // this.parseElementRef = this.parseElement
              this.parseUrlRef = this.parseUrl
            } else {
              this.statusSaveCron = result.retour
              this.infoCron = 'Probleme de suppression de la tache cron : ' + result.info
              // console.log('Probleme de création de la tache cron : ', response.info)
            }
          })
          .catch((reject) => {
            console.log('delMAJ reject :', reject)
            console.log('Plus de sauvegarde MAJ auto :', reject)
          })
        }
        // pas de changement
        // } else {
          // // mais changement de la mise à jour automatique
          // // ou changement dans la method de parsage du site
          // if (
          //   this.majUrlAutoRef !== this.majUrlAuto ||
          //   // this.methodSelectRef !== this.methodSelect ||
          //   // this.parseElementRef !== this.parseElement ||
          //   this.parseUrlRef !== this.parseUrl ||
          //   this.promptResumeRef !== this.promptResume
          // ) {
          //   // si il y a une crontab enregistrée
          //   if (this.majCronTab) {
          //     this.addCron(async (response) => {
          //       this.afficheStatusCron = true
          //       // console.log('response', response)
          //       if (response.retour) {
          //         this.statusSaveCron = response.retour
          //         this.infoCron = 'Modification de la crontab'
          //         // console.log('création de la crontab')
          //         this.majCronTabRef = this.majCronTab
          //         this.majUrlAutoRef = this.majUrlAuto
          //         // this.methodSelectRef = this.methodSelect
          //         // this.parseElementRef = this.parseElement
          //         this.parseUrlRef = this.parseUrl
          //       } else {
          //         this.statusSaveCron = response.retour
          //         this.infoCron = 'Probleme de création de la tache cron : ' + response.info
          //         // console.log('Probleme de création de la tache cron : ', response.info)
          //       }
          //     })
          //   }
          // }
        // }

        // changement de crontab scanne page
        // if (this.majCronTabPageRef !== this.majCronTabPage) {
        //   if (this.majCronTabPage) {
        //     this.addCronPage(async (response) => {
        //       this.afficheStatusCronPage = true
        //       // console.log('response', response)
        //       if (response.retour) {
        //         this.statusSaveCronPage = response.retour
        //         this.infoCronPage = 'Création de la crontab scanne page'
        //         // console.log('création de la crontab')
        //         this.majCronTabPageRef = this.majCronTabPage
        //         this.majUrlAutoPageRef = this.majUrlAutoPage
        //         // this.methodSelectRef = this.methodSelect
        //         // this.parseElementRef = this.parseElement
        //         this.parseUrlRef = this.parseUrl
        //       } else {
        //         this.statusSaveCronPage = response.retour
        //         this.infoCronPage = 'Probleme de création de la tache cron scanne page : ' + response.info
        //         // console.log('Probleme de création de la tache cron : ', response.info)
        //       }
        //     })
        //   } else {
        //     this.delCronPage(async (response) => {
        //       this.afficheStatusCronPage = true
        //       // console.log('response', response)
        //       if (response.retour) {
        //         this.statusSaveCronPage = response.retour
        //         this.infoCronPage = 'Suppression de la crontab scanne page'
        //         // console.log('suppression de la crontab')
        //         this.majCronTabPageRef = this.majCronTabPage
        //         this.majUrlAutoPageRef = this.majUrlAutoPage
        //         // this.methodSelectRef = this.methodSelect
        //         // this.parseElementRef = this.parseElement
        //         this.parseUrlRef = this.parseUrl
        //       } else {
        //         this.statusSaveCronPage = response.retour
        //         this.infoCronPage = 'Probleme de suppression de la tache cron scanne page : ' + response.info
        //         // console.log('Probleme de suppression de la tache cron : ', response.info)
        //       }
        //     })
        //   }
        // // pas de changement
        // } else {
        //   // mais changement de la mise à jour automatique
        //   // ou changement dans la method de parsage du site
        //   if (
        //     this.majUrlAutoPageRef !== this.majUrlAutoPage ||
        //     // this.methodSelectRef !== this.methodSelect ||
        //     // this.parseElementRef !== this.parseElement ||
        //     this.parseUrlRef !== this.parseUrl ||
        //     this.promptResumeRef !== this.promptResume
        //   ) {
        //     // si il y a une crontab enregistrée
        //     if (this.majCronTabPage) {
        //       this.addCronPage(async (response) => {
        //         this.afficheStatusCronPage = true
        //         // console.log('response', response)
        //         if (response.retour) {
        //           this.statusSaveCronPage = response.retour
        //           this.infoCronPage = 'Modification de la crontab scanne page'
        //           // console.log('création de la crontab')
        //           this.majCronTabPageRef = this.majCronTabPage
        //           this.majUrlAutoPageRef = this.majUrlAutoPage
        //           // this.methodSelectRef = this.methodSelect
        //           // this.parseElementRef = this.parseElement
        //           this.parseUrlRef = this.parseUrl
        //         } else {
        //           this.statusSaveCronPage = response.retour
        //           this.infoCronPage = 'Probleme de création de la tache cron scanne page : ' + response.info
        //           // console.log('Probleme de création de la tache cron : ', response.info)
        //         }
        //       })
        //     }
        //   }
        // }

        try {
          await this.savePromptCsat()
        } catch (e) {}

        this.loadingSavePrompt = false
        if (this.loadingModifAnalyseChat) {
          this.loadingModifAnalyseChat = false
          this.showDialogDeleteAnalyseChat = false
        }
        // mise a jour des données de reference
        this.promptRef = this.prompt
        this.prompt_personalityRef = this.prompt_personality
        this.prompt_environmentRef = this.prompt_environment
        this.prompt_objectifRef = this.prompt_objectif
        this.prompt_communicationRef = this.prompt_communication
        this.prompt_questionsRef = this.prompt_questions
        this.prompt_rulesRef = this.prompt_rules
        this.prompt_toolsRef = this.prompt_tools
        this.prompt_customRef = this.prompt_custom
        this.prompt_nameRef = this.prompt_name
        this.prompt_commentRef = this.prompt_comment
        this.clearPromptSectionDraftFromLocalStorage(this.siteSelected.LIC_KEY)

        this.promptSearchRef = this.promptSearch
        this.productSelectAutoRef = this.productSelectAuto
        this.promptResumeRef = this.promptResume
        this.loadPromptVersionCount(this.siteSelected.LIC_KEY)
        // this.functionCallRef = this.functionCall
        this.messageAccueilRef = this.messageAccueil
        this.questionAuto1Ref = this.questionAuto1
        this.questionAuto2Ref = this.questionAuto2
        this.questionAuto3Ref = this.questionAuto3
        this.questionAuto4Ref = this.questionAuto4
        this.sliderSearchResponseRef = this.sliderSearchResponse
        this.sliderTokenResponseRef = this.sliderTokenResponse
        this.sliderTempRef = this.sliderTemp
        this.sliderTempRef = this.sliderTemp
        this.botStreamRef = this.botStream
        this.pageScanneRef = this.pageScanne
        this.analyseChatRef = this.analyseChat
      })
      .catch((error) => {
        console.log('error enregistrement : ', error)
        this.loadingSavePrompt = false
        if (this.loadingModifAnalyseChat) {
          this.loadingModifAnalyseChat = false
          this.showDialogDeleteAnalyseChat = false
        }
      })
    },
    loadPromptVersionCount (licKey) {
      const sitekey = licKey || this.$store.state._Sites.siteSelected.LIC_KEY
      if (!sitekey) return
      this.axios.get('get/prompt_version.php?sitekey=' + sitekey)
      .then(response => {
        let list = response.data
        if (typeof list === 'string') {
          try {
            list = JSON.parse(list)
          } catch (_) {
            list = []
          }
        }
        if (!Array.isArray(list) && list && Array.isArray(list.data)) {
          list = list.data
        }
        if (!Array.isArray(list)) {
          list = []
        }
        this.promptVersionCount = list.length
      })
      .catch(() => {})
    },

    // affiche la dialogBox import PDF
    importFile () {
      // console.log('import file')
      this.showDialogImportPDF = true
    },
    // ouvre le dialogue pour voir les segments du fichier
    async openDialogChunkFile (data) {
      // console.log('open dialog chunk file ', data)
      this.showDialogChunkPDF = true
      this.selectedFileChunk = data
    },

    // ouvre le dialogue pour voir le résumé du fichier
    async openDialogFile (data) {
      // console.log('open dialog chunk file ', data)
      this.showDialogResume = true
      this.selectedFileChunk = data
    },

    // ajoute le nouveau fichier PDF dans la liste
    addFile (value) {
      console.log('add file', value)
      // this.files.push(value)
      // recupère la liste des documents du client dans redis
      this.loadFilesClient(this.siteSelected.LIC_KEY)
    },

    // chargement des url du client
    async loadFilesClient (licKey) {
      // console.info('loadFilesClient')
      this.loadingDataFiles = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = licKey
      const response = await this.axios.post(this.serveurAI + 'getLicenceFiles',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response && response.data.retour) {
        this.loadingDataFiles = false
        // const returnListURL = JSON.parse(response.data.data) // pase le retour
        const listeFile = Object.values(response.data.data) // rend iterable le json
        // for (const index in listeUrl) {
          // this.files.push({'url': listeUrl[index].url})
        // }
        this.files = listeFile
      } else {
        this.loadingDataFiles = false
        // si aucun retour, on vide le tableau des files
        this.files = []
      }
      // this.files.push(response.data.data)
    },

    // chargement des url du client (urls utilisées ou urls supprimées)
    // status des urls est soit "actif" ou "inactif"
    async loadUrlsClient (status) {
      // console.log('licKey', this.siteSelected.LIC_KEY)
      localStorage.setItem('startListUrl', this.rangeSliderUrl[0])
      localStorage.setItem('endListUrl', this.rangeSliderUrl[1])
      // this.rangeSliderUrl[0] = this.startListUrl
      // this.rangeSliderUrl[1] = this.endListUrl
      let licKey = this.siteSelected.LIC_KEY
      if (status === 'inactif') {
        licKey = licKey + '-' + status
      } else if (status.isTrusted) {
        console.log('trusted')
      }
      this.loadingData = true
      this.loadingDataInactif = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = licKey // la licence client
      dataToPost.status = status // le status des urls
      dataToPost.start = this.rangeSliderUrl[0] // debut de la liste demandée
      dataToPost.end = this.rangeSliderUrl[1] // fin de la liste demandée
      const response = await this.axios.post(this.serveurAI + 'getLicenceUrls',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response.data.retour) {
        // const returnListURL = JSON.parse(response.data.data) // pase le retour
        const listeUrl = Object.values(response.data.data) // rend iterable le json
        // il faut convertire les timestamps en date
        for (const index in listeUrl) {
          if (listeUrl[index].timestamp) {
            listeUrl[index].timestamp = moment(listeUrl[index].timestamp).format('lll')
          }
        }
        if ((response.data.statsus && response.data.status === 'inactif') || status === 'inactif') {
          this.urlsSupp = listeUrl
        } else {
          this.totalUrl = response.data.totalUrl
          this.urls = listeUrl
        }
        this.loadingDataInactif = false
        this.loadingData = false
      } else {
        // si aucun retour, on vide le tableau d'urls
        if (status === 'inactif') {
          this.urlsSupp = []
        } else {
          this.urls = []
        }
        this.loadingDataInactif = false
        this.loadingData = false
      }
    },

    // chargement des API produits du client (produits utilisées ou produits supprimées)
    // status des produits est soit "actif" ou "inactif"
    async loadProductsClient (status) {
      // console.log('licKey', this.siteSelected.LIC_KEY)
      localStorage.setItem('startListProduct', this.rangeSliderProduct[0])
      localStorage.setItem('endListProduct', this.rangeSliderProduct[1])
      let licKey = this.siteSelected.LIC_KEY
      if (status === 'inactif') {
        licKey = licKey + '-' + status
      }
      this.loadingData = true
      this.loadingDataInactif = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = licKey // la licence client
      dataToPost.status = status // le status des urls
      dataToPost.start = this.rangeSliderProduct[0] // debut de la liste demandée
      dataToPost.end = this.rangeSliderProduct[1] // fin de la liste demandée
      const response = await this.axios.post(this.serveurAI + 'getLicenceProducts',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response.data.retour) {
        console.log('getLicenceProducts-' + status)
        console.log('response.data : ', response.data)
        console.log('response.status : ', response.data.status)
        // const returnListURL = JSON.parse(response.data.data) // pase le retour
        const listeProduct = Object.values(response.data.data) // rend iterable le json
        // il faut convertire les timestamps en date
        for (const index in listeProduct) {
          if (listeProduct[index].timestamp) {
            listeProduct[index].timestamp = moment(listeProduct[index].timestamp).format('lll')
          }
        }
        if ((response.data.statsus && response.data.status === 'inactif') || status === 'inactif') {
          this.totalProductInactif = response.data.totalProduct
          this.productsSupp = listeProduct
        } else {
          this.totalProduct = response.data.totalProduct
          this.products = listeProduct
        }
        this.loadingDataInactif = false
        this.loadingData = false
      } else {
        // si aucun retour, on vide le tableau d'urls
        if (status === 'inactif') {
          this.productsSupp = []
        } else {
          this.products = []
        }
        this.loadingDataInactif = false
        this.loadingData = false
      }
    },

    // chargement des URL produits du client (produits utilisées ou produits supprimées)
    // status des produits est soit "actif" ou "inactif"
    async loadURLProductsClient (status) {
      // console.log('licKey', this.siteSelected.LIC_KEY)
      localStorage.setItem('startListURLProduct', this.rangeSliderURLProduct[0])
      localStorage.setItem('endListURLProduct', this.rangeSliderURLProduct[1])
      let licKey = this.siteSelected.LIC_KEY
      if (status === 'inactif') {
        licKey = licKey + '-' + status
      }
      this.loadingData = true
      this.loadingDataInactif = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = licKey // la licence client
      dataToPost.status = status // le status des urls
      dataToPost.start = this.rangeSliderURLProduct[0] // debut de la liste demandée
      dataToPost.end = this.rangeSliderURLProduct[1] // fin de la liste demandée
      const response = await this.axios.post(this.serveurAI + 'getLicenceURLProducts',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response.data.retour) {
        console.log('getLicenceURLProducts-' + status)
        console.log('response.data : ', response.data)
        console.log('response.status : ', response.data.status)
        // const returnListURL = JSON.parse(response.data.data) // pase le retour
        const listeURLProduct = Object.values(response.data.data) // rend iterable le json
        // il faut convertire les timestamps en date
        for (const index in listeURLProduct) {
          if (listeURLProduct[index].timestamp) {
            listeURLProduct[index].timestamp = moment(listeURLProduct[index].timestamp).format('lll')
          }
        }
        if ((response.data.statsus && response.data.status === 'inactif') || status === 'inactif') {
          this.totalURLProductInactif = response.data.totalProduct
          this.URLProductsSupp = listeURLProduct
        } else {
          this.totalURLProduct = response.data.totalProduct
          this.URLProducts = listeURLProduct
        }
        this.loadingDataInactif = false
        this.loadingData = false
      } else {
        // si aucun retour, on vide le tableau d'urls
        if (status === 'inactif') {
          this.URLProductsSupp = []
        } else {
          this.URLProducts = []
        }
        this.loadingDataInactif = false
        this.loadingData = false
      }
      // console.log('load URLProducts', this.URLProducts)
    },

    // chargement des faqs du client
    async loadFaqsClient () {
      // console.log('loadFaqsClient')
      this.loadingData = true
      this.loadingDataInactif = true
      this.faqs = [] // remise à zéro du tableau des faq
      // Données modifiées et à renvoyer
      let req = {}
      req.licence = this.siteSelected.LIC_KEY// le fichier dédié au prompt scripté
      let dataToPost = {}
      dataToPost.data = req

      const response = await this.axios.post(this.serveurAI + 'getLicenceFaqs',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )

      /* let fakereponse = {
        'retour': 1,
        'data': [
          {
            'name': '948580a42a7ace75df2befcdf0ec8a81_faq.faq-0',
            'content': 'Question : exemple en dur\r\nRéponse : réponse en dur aussi\r\n',
            'extrait': 'Question : toto\r\nRéponse : titi\r\n'
          }, {
            'name': '948580a42a7ace75df2befcdf0ec8a81_faq.faq-1',
            'content': 'Question : exemple 2\r\nRéponse : réponse 2\r\n',
            'extrait': 'Question : toto2\r\nRéponse : titi2\r\n'
          }
        ]
      } */

      if (response.data.retour) {
        const listeFaq = Object.values(response.data.data) // rend iterable le json
        // console.log('getLicenceFaqs dataToPost : ', dataToPost)
        for (const idx in listeFaq) {
          let faq = {}
          faq.name = listeFaq[idx].name
          let phrase = listeFaq[idx].content
          let indexDebutQuestion = phrase.indexOf('Question :')
          // Trouver l'index de fin de la question
          let indexFinQuestion = phrase.indexOf('\r\n', indexDebutQuestion + 'Question :'.length)
          // Extraire la partie de la question
          let question = phrase.substring(indexDebutQuestion, indexFinQuestion).trim()
          faq.question = question.replace(/Question :/g, '')
          // Trouver l'index du début de la réponse
          let indexDebutReponse = phrase.indexOf('Réponse :')
          // Trouver l'index de fin de la réponse
          let indexFinReponse = phrase.indexOf('\r\n', indexDebutReponse + 'Réponse :'.length)
          // Extraire la partie de la réponse
          let reponse = phrase.substring(indexDebutReponse, indexFinReponse).trim()
          faq.reponse = reponse.replace(/Réponse :/g, '')
          faq.index = idx
          this.faqs.push(faq)
        }
        this.numFAQ = listeFaq.length
        this.loadingDataInactif = false
        // this.chunks = response.data.data
        // this.loadingData = false
        setTimeout(() => {
          this.loadingData = false
        }, 500)
      }
    },
    // --------------------------------------------------
    // fonction pour checker les nouvelles urls
    // --------------------------------------------------
    async checkUrls () {
      this.showDialogAddUrls = true
    },
    async newFAQ () {
      // console.log('newFAQ')
      this.showDialogModifFAQ = true
      this.addFAQ = true
    },

    /**
     * recupere la liste des url en scannant
     * soit le sitemap.xml ou en parssant la totalité du site web
     * @param {String} methode .crawler-sitemap / crawler-allurl
     */
    async submitCheckUrls (methode, majAuto, page) {
      this.loadingSearchUrl = true
      // console.log('check sitemap site', this.parseUrl)
      let url = this.parseUrl
      // pour tester uniquement ---------------------
      // let url = 'https://immobilier.cushmanwakefield.fr/'
      // --------------------------------------------
      this.loadingCheckSitemap = true
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      if (page) {
        dataToPost.page = page
      }
      dataToPost.site = url
      // console.log('url', url)
      const response = await this.axios.post(this.serveurAI + methode,
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      console.log('methode', this.serveurAI + methode)
      console.log('response', response)
      // si retour true, alors toutes les urls modifées doivent passé en update false
      if (response.status !== 404) {
        if (response.data.retour) {
          // console.log('crawler sitemap fin', response.data.data.newUrl)
          const listeNewUrls = Object.values(response.data.data.newUrl) // rend iterable le json
          // le retour est une liste de nouvelle urls trouvées dans le site map
          // donc pas de mot clés pas encore de embeding
          // pour chaque nouvelle url
          for (const newUrl of listeNewUrls) {
            let i = this.urls.findIndex((element) => element.url === newUrl)
            if (i === -1) {
              this.urls.push({
                'url': newUrl,
                'new': true,
                'update': false
              })
            }
          }
          // pour chaque url supprimé
          const listeDelUrls = Object.values(response.data.data.suppUrl) // rend iterable le json
          for (const delUrl of listeDelUrls) {
            let i = this.urls.findIndex((element) => element.url === delUrl)
            if (i !== -1) {
              // console.log('index : ', i)
              this.urls.splice(i, 1)
            }
          }

          // console.log('crawler sitemap fin this.urls', this.urls)
          this.messageResDialog = '<h3>' + this.$t('Résultats de la recherche de nouvelles urls :') + '</h3>'
          this.messageResDialog += '<p>'
          this.messageResDialog += 'Nouvelles urls trouvées : <strong>' + listeNewUrls.length + '</strong><br>'
          this.messageResDialog += 'Urls verrouillées du sitemap: <strong>' + response.data.data.lockUrl.length + '</strong><br>'
          this.messageResDialog += 'Urls actives supprimées du sitemap: <strong>' + response.data.data.suppUrl.length + '</strong><br>'
          this.messageResDialog += '</p>'
          // si il y a une mise à jour automatique des données des nouvelles urls trouvées
          if (majAuto) {
            // console.log('majAuto activée')
            let totalTraitementUrls = 0
            this.messageResDialog += '<div>Traitement des nouvelles urls :<ol>'
            if (listeNewUrls.length) {
              for (const newUrl of listeNewUrls) {
                let dataToPost = {}
                dataToPost.licence = this.siteSelected.LIC_KEY
                dataToPost.listeUrls = [{url: newUrl}]
                dataToPost.method = this.methodSelect
                dataToPost.parsingSelectif = this.parsingSelectif
                dataToPost.model = this.methodSelect
                dataToPost.parse = this.parseElement
                dataToPost.promptResume = this.promptResume
                const response = await this.axios.post(this.serveurAI + 'tokenize-listeUrls',
                dataToPost,
                  {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
                )
                if (response.data.update) {
                  totalTraitementUrls++
                  // si pas d'erreur
                  if (response.data.status) {
                    let i = this.urls.findIndex((element) => element.url === response.data.url)
                    if (i !== -1) {
                      // indicateur de modif ou d'ajout de mots clés pour cette url
                      this.urls[i].updated = true
                      // indicateur que ce n'est plus une nouvelles url car elle a été traitée
                      this.urls[i].new = false
                      // indicateur qu'il n'y a plus d'erreur sur cette url
                      this.urls[i].error = false
                    }
                    this.messageResDialog += '<li class="font-weight-bold font-italic green--text darken-4"> ' + newUrl + '</li>'
                  // si il y a une erreur
                  } else {
                    let i = this.urls.findIndex((element) => element.url === response.data.url)
                    if (i !== -1) {
                      // indicateur d'erreur sur cette url
                      this.urls[i].error = true
                    }
                    this.messageResDialog += '<li class="font-weight-bold font-italic red--text darken-4"> ' + newUrl + '</li>'
                  }
                }
              }
              this.messageResDialog += '</ol></div>'
              // quand le traitement est pas fini
              if (totalTraitementUrls < listeNewUrls.length) {
                this.messageResDialog += '<divtraitement en cours...</div>'
              } else {
                // quand le traitement est terminé il faut lancer le embedding des urls "updated"
                this.messageResDialog += '<div>Enregistrement des nouvelles connaissances</div>'
                // avec un timer pour avoir une transition claire
                setTimeout(() => {
                  this.submitEmbeddingConfirm(async (res) => {
                    if (res.retour) {
                      // fin du traitement, affiche le boutton fermer
                      this.closeDialogUniquement = true
                    }
                  })
                }, '4000')
              }
            }
          } else {
            // fin de la mise à jour de urls, affiche le boutton fermer
            this.closeDialogUniquement = true
            if (listeNewUrls.length) {
              this.messageResDialog += '<div>Liste des nouvelles urls :<ol>'
              for (const newUrl of listeNewUrls) {
                this.messageResDialog += '<li class="font-weight-bold font-italic">' + newUrl + '</li>'
              }
              this.messageResDialog += '</ol></div>'
            }
          }
        } else {
          // console.log('crawler erreur', response.data.info)
          this.messageResDialog = '<h3>' + this.$t('Erreur de recherche :') + '</h3>'
          this.messageResDialog += '<p>'
          this.messageResDialog += 'erreur : <strong>' + response.data.info + '</strong><br>'
          this.messageResDialog += '</p>'
        }
        this.loadingCheckSitemap = false
        this.loadingSearchUrl = false
      } else {
        // console.log('impossible de check le sitemap (404)')
        this.loadingCheckSitemap = false
        this.loadingSearchUrl = false
        this.messageResDialog = '<h3>' + this.$t('Impossible de trouver le sitemap :') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += 'erreur : <strong>' + response.data.info + '</strong><br>'
        this.messageResDialog += '</p>'
      }
    },

    // ferme la femetre de versioning du prompt
    submitEnhancePrompt () {
      this.showDialogEnhancePrompt = false
    },
    applyEnhancedPromptSection (field, value) {
      switch (field) {
        case 'personality':
          this.prompt_personality = value
          break
        case 'environment':
          this.prompt_environment = value
          break
        case 'objectif':
          this.prompt_objectif = value
          break
        case 'communication':
          this.prompt_communication = value
          break
        case 'questions':
          this.prompt_questions = value
          break
        case 'rules':
          this.prompt_rules = value
          break
        case 'tools':
          this.prompt_tools = value
          break
        case 'custom':
          this.prompt_custom = value
          break
        default:
          break
      }
      this.persistPromptSectionDraftNow()
    },
    applyEnhancedPromptSectionCsat (field, value) {
      switch (field) {
        case 'personality':
          this.prompt_csat_personality = value
          break
        case 'environment':
          this.prompt_csat_mission = value
          break
        case 'objectif':
          this.prompt_csat_rules = value
          break
        case 'communication':
          this.prompt_csat_block4 = value
          break
        default:
          break
      }
    },
    // ferme la femetre de versioning du prompt
    submitVersionPrompt () {
      this.showDialogVersionPrompt = false
    },
    restorePromptSectionFromHistory (field, value) {
      switch (field) {
        case 'personality':
          this.prompt_personality = value
          break
        case 'environment':
          this.prompt_environment = value
          break
        case 'objectif':
          this.prompt_objectif = value
          break
        case 'communication':
          this.prompt_communication = value
          break
        case 'questions':
          this.prompt_questions = value
          break
        case 'rules':
          this.prompt_rules = value
          break
        case 'tools':
          this.prompt_tools = value
          break
        case 'custom':
          this.prompt_custom = value
          break
        default:
          break
      }
      this.persistPromptSectionDraftNow()
    },
    restorePromptCsatSectionFromHistory (field, value) {
      this.applyEnhancedPromptSectionCsat(field, value)
    },
    restoreAllPromptSectionsFromHistory (sections) {
      const data = sections || {}
      this.prompt_personality = data.personality || ''
      this.prompt_environment = data.environment || ''
      this.prompt_objectif = data.objectif || ''
      this.prompt_communication = data.communication || ''
      this.prompt_questions = data.questions || ''
      this.prompt_rules = data.rules || ''
      this.prompt_tools = data.tools || ''
      this.prompt_custom = data.custom || ''
      this.persistPromptSectionDraftNow()
    },
    restoreAllPromptCsatSectionsFromHistory (sections) {
      const data = sections || {}
      this.prompt_csat_personality = data.personality || ''
      this.prompt_csat_mission = data.environment || ''
      this.prompt_csat_rules = data.objectif || ''
      this.prompt_csat_block4 = data.communication || ''
    },

    // start l'embedding des uls
    startEmbedding (userid) {
      this.showDialogEmbedding = true
    },

    // start l'embedding des produits
    startEmbeddingAPI (userid) {
      this.showDialogEmbeddingAPI = true
    },
    // start l'embedding des urls produits
    startEmbeddingURLProduct (userid) {
      this.showDialogEmbeddingURLProduct = true
    },
    // lance le embedding des url qui ont "updated" à true
    async submitEmbeddingConfirm (callback) {
      this.loadingEmbeddingUrl = true
      this.loadingRes = true
      this.startLoading = 0
      var totalTraitementUrls = 0
      var totalTraitementOK = 0
      var totalTraitementKO = 0
      var errorListUrls = []
      var newListeEmbedding = []
      // console.log(' this.urls', this.urls)
      // recupere uniquement les url qui on eu les mot clés updatées
      for (const index in this.urls) {
        if (this.urls[index].updated) {
          newListeEmbedding.push(this.urls[index].url)
        }
      }
      this.endLoading = newListeEmbedding.length
      // puiq pour chaque url upadated on execute un demande d'enregistrement embedding en base
      for (const url of newListeEmbedding) {
        console.log(' url ', url)
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.url = [url]
        const response = await this.axios.post(this.serveurAI + 'embedding-url',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // si retour true, alors toutes les urls modifées doivent passé en update false
        if (response.data.retour) {
          this.startLoading++
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.url) {
            totalTraitementOK++
            // recherche dans les url pour mettre en updated false si elle existe
            let i = this.urls.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.urls[i].updated = false
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.urls[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.urls[i].error = false
            }
          }
        } else {
          if (response.data.url) {
            totalTraitementKO++
            errorListUrls.push(response.data.url) // push l'url
            let i = this.urls.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.urls[i].error = true
            }
          // si il y a une erreur
          }
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AISaveProc') + ' ' + totalTraitementUrls + '/' + this.endLoading + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResData') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResDataOK') + ' <strong>' + totalTraitementOK + '/' + this.endLoading + '</strong><br>'
        this.messageResDialog += this.$t('AIResDataKO') + ' <strong>' + totalTraitementKO + '/' + this.endLoading + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const url of errorListUrls) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + url + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des urls en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedUrls = this.selectedUrls
          dataMAJ.errorListUrls = errorListUrls
          this.majErrorListeUrls(dataMAJ)
          callback({retour: 1})
        }
      }
    },

    // lance le embedding des url produits qui ont "updated" à true
    async submitEmbeddingURLProductConfirm (callback) {
      this.loadingEmbeddingUrl = true
      this.loadingRes = true
      this.startLoading = 0
      var totalTraitementUrls = 0
      var totalTraitementOK = 0
      var totalTraitementKO = 0
      var errorListUrls = []
      var newListeEmbedding = []
      // console.log(' this.urls', this.urls)
      // recupere uniquement les url qui on eu les mot clés updatées
      for (const index in this.URLProducts) {
        if (this.URLProducts[index].updated) {
          newListeEmbedding.push(this.URLProducts[index].url)
        }
      }
      this.endLoading = newListeEmbedding.length
      // puiq pour chaque url upadated on execute un demande d'enregistrement embedding en base
      for (const url of newListeEmbedding) {
        console.log(' url product ', url)
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.url = [url]
        const response = await this.axios.post(this.serveurAI + 'embedding-url',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // si retour true, alors toutes les urls modifées doivent passé en update false
        if (response.data.retour) {
          this.startLoading++
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.url) {
            totalTraitementOK++
            // recherche dans les url pour mettre en updated false si elle existe
            let i = this.URLProducts.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.URLProducts[i].updated = false
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.URLProducts[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.URLProducts[i].error = false
            }
          }
        } else {
          if (response.data.url) {
            totalTraitementKO++
            errorListUrls.push(response.data.url) // push l'url
            let i = this.URLProducts.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.URLProducts[i].error = true
            }
          // si il y a une erreur
          }
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AISaveProc') + ' ' + totalTraitementUrls + '/' + this.endLoading + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResData') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResDataOK') + ' <strong>' + totalTraitementOK + '/' + this.endLoading + '</strong><br>'
        this.messageResDialog += this.$t('AIResDataKO') + ' <strong>' + totalTraitementKO + '/' + this.endLoading + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const url of errorListUrls) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + url + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des urls en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedUrls = this.selectedURLProducts
          dataMAJ.errorListUrls = errorListUrls
          this.majErrorListeUrls(dataMAJ)
          callback({retour: 1})
        }
      }
    },

    // lance le embedding des produits qui ont "updated" à true
    async submitEmbeddingAPIConfirm (callback) {
      this.loadingEmbeddingUrl = true
      this.loadingRes = true
      this.startLoading = 0
      var totalTraitementUrls = 0
      var totalTraitementOK = 0
      var totalTraitementKO = 0
      var errorListProducts = []
      var newListeEmbedding = []
      console.log(' this.products', this.products)
      // recupere uniquement les produits qui on eu les mot clés updatées
      for (const index in this.products) {
        if (this.products[index].updated) {
          newListeEmbedding.push(this.products[index].product)
        }
      }
      this.endLoading = newListeEmbedding.length
      // puiq pour chaque url upadated on execute un demande d'enregistrement embedding en base
      for (const product of newListeEmbedding) {
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.product = [product]
        const response = await this.axios.post(this.serveurAI + 'embedding-api',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // si retour true, alors toutes les urls modifées doivent passé en update false
        if (response.data.retour) {
          this.startLoading++
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.product) {
            totalTraitementOK++
            // recherche dans les url pour mettre en updated false si elle existe
            let i = this.products.findIndex((element) => element.product === response.data.product)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.products[i].updated = false
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.products[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.products[i].error = false
            }
          }
        } else {
          if (response.data.product) {
            totalTraitementKO++
            errorListProducts.push(response.data.product) // push l'url
            let i = this.products.findIndex((element) => element.product === response.data.product)
            if (i !== -1) {
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.products[i].error = true
            }
          // si il y a une erreur
          }
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AISaveProc') + ' ' + totalTraitementUrls + '/' + this.endLoading + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResData') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResDataOK') + ' <strong>' + totalTraitementOK + '/' + this.endLoading + '</strong><br>'
        this.messageResDialog += this.$t('AIResDataKO') + ' <strong>' + totalTraitementKO + '/' + this.endLoading + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const prod of errorListProducts) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + prod + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des urls en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedProducts = this.selectedProducts
          dataMAJ.errorListProducts = errorListProducts
          this.majErrorListeUrls(dataMAJ)
          callback({retour: 1})
        }
      }
    },

    // selection de l'action dans le menu déroulant pour les documents
    actionsFile () {
      if (this.selectActionFile === 'sup') {
        this.showDialogDeleteFile = true
      } else {
      }
    },

    // selection de l'action dans le menu déroulant pour les url
    actionsUrl () {
      if (this.selectActionUrl === 'sup') {
        this.showDialogDelete = true
      } else if (this.selectActionUrl === 'keywords') {
        this.showDialogAddKeyword = true
      } else if (this.selectActionUrl === 'lock') {
        this.showDialogLock = true
      } else {
      }
    },

    // selection de l'action dans le menu déroulant pour les urls produit
    actionsURLProduct () {
      if (this.selectActionURLProduct === 'sup') {
        this.showDialogDeleteURLProduct = true
      } else if (this.selectActionURLProduct === 'keywords') {
        this.showDialogAddKeywordURLProduct = true
      } else if (this.selectActionURLProduct === 'lock') {
        this.showDialogLockURLProduct = true
      } else {
      }
    },

    // selection de l'action dans le menu déroulant pour les api produit
    actionsProduct () {
      if (this.selectActionProduct === 'sup') {
        this.showDialogDeleteProduct = true
      } else if (this.selectActionProduct === 'keywords') {
        this.showDialogAddKeywordProduct = true
      } else if (this.selectActionProduct === 'lock') {
        this.showDialogLockProduct = true
      } else {
      }
    },

    // selection de l'action dans le menu déroulant pour les url
    actionsFAQ () {
      if (this.selectActionFAQ === 'sup') {
        this.showDialogDeletesFAQ = true
      } else {
      }
    },
    // selection de l'action dans le menu déroulant pour les url supprimmées
    actionsSuppUrl () {
      if (this.selectActionSuppUrl === 'sup') {
        this.showDialogDeleteSupp = true
      } else {
      }
    },

    justCloseDialogAddUrls () {
      this.showDialogAddUrls = false
      this.showDialogDelete = false
      this.showDialogProduct = false
      this.selectActionUrl = null
      this.selectActionProduct = null
      this.selectActionURLProduct = null
      this.selectedUrls = []
      this.selectedURLProducts = []
      this.selectedFaqs = []
      this.selectedFiles = []
      this.selectedProducts = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogAddFAQ () {
      this.showDialogAddUrls = false
      this.showDialogDelete = false
      this.showDialogProduct = false
      this.selectActionUrl = null
      this.selectActionProduct = null
      this.selectActionURLProduct = null
      this.selectedUrls = []
      this.selectedURLProducts = []
      this.selectedFaqs = []
      this.selectedFiles = []
      this.selectedProducts = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogEmdedding () {
      this.showDialogEmbedding = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogEmdeddingAPI () {
      this.showDialogEmbeddingAPI = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogEmdeddingURLProduct () {
      this.showDialogEmbeddingURLProduct = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogEnhancePrompt () {
      this.showDialogEnhancePrompt = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogEnhancePromptCsat () {
      this.showDialogEnhancePromptCsat = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogVersionPrompt () {
      this.showDialogVersionPrompt = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogVersionPromptCsat () {
      this.showDialogVersionPromptCsat = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogLock () {
      this.showDialogAddKeyword = false
      this.showDialogAddKeywordProduct = false
      this.showDialogAddKeywordURLProduct = false
      this.showDialogLock = false
      this.showDialogLockURLProduct = false
      this.showDialogLockProduct = false
      this.selectActionUrl = null
      this.selectActionProduct = null
      this.selectActionURLProduct = null
      this.selectedUrls = []
      this.selectedURLProducts = []
      this.selectedFaqs = []
      this.selectedFiles = []
      this.selectedProducts = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogConfirm () {
      this.showDialogAddKeyword = false
      this.showDialogAddKeywordProduct = false
      this.showDialogAddKeywordURLProduct = false
      this.showDialogDelete = false
      this.showDialogDeleteProduct = false
      this.showDialogDeleteURLProduct = false
      this.showDialogProduct = false
      this.selectActionUrl = null
      this.selectActionProduct = null
      this.selectActionURLProduct = null
      this.selectedUrls = []
      this.selectedURLProducts = []
      this.selectedFaqs = []
      this.selectedFiles = []
      this.selectedProducts = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogConfirmSupp () {
      this.showDialogDeleteSupp = false
      this.selectActionSuppUrl = null
      this.selectedSuppUrls = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogConfirmFile () {
      this.showDialogDeleteFile = false
      this.selectActionFile = null
      this.selectedFiles = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogConfirmFAQ () {
      this.showDialogDeletesFAQ = false
      this.selectActionFAQ = null
      this.selectedFaqs = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },

    // ------------------------- analyse chat ---------------------------
    saveAnalyseChat (data) {
      this.analyseChat.push(data)
      this.savePrompt()
      this.showDialogAddAnalyseChat = false
    },
    modifAnalyseChat (data) {
      for (const index in this.analyseChat) {
        if (this.analyseChat[index].q === data.old.q) {
          this.analyseChat[index].q = data.new.q
          this.analyseChat[index].a = data.new.a
        }
      }
      // this.analyseChat.push(data)
      this.savePrompt()
      this.showDialogAddAnalyseChat = false
    },
    // selection de l'action dans le menu déroulant pour les analyse de chat
    actionsAnalyseChat () {
      if (this.selectActionAnalyseChat === 'sup') {
        this.showDialogDeleteAnalyseChat = true
      } else {
      }
    },
    justCloseDialogAnalyseChat () {
      this.showDialogAddAnalyseChat = false
      this.selectedModifAnalyseChat = {}
    },
    justCloseDialogConfirmAnalyseChat () {
      this.showDialogDeleteAnalyseChat = false
      this.selectActionAnalyseChat = null
      this.selectedAnalyseChat = []
    },
    submitDeleteAnalyseChatConfirm () {
      this.loadingModifAnalyseChat = true
      // suppression live des analyse de chat
      let newListeAnalyseChat = this.analyseChat
      for (const selectedAnalyse of this.selectedAnalyseChat) {
        this.analyseChat.forEach(function (q, index) {
          if (selectedAnalyse === q) {
            newListeAnalyseChat.splice(index, 1)
          }
        })
      }
      this.analyseChat = newListeAnalyseChat
      this.savePrompt()
      this.selectedModifAnalyseChat = {}
    },
    // ouvre le dialogue pour modifier les parametres d'analyse de chat
    async openDialogModifAnalyseChat (data) {
      this.showDialogAddAnalyseChat = true
      this.selectedModifAnalyseChat = data
      this.modifDialog = true
      this.titleAnalyseChat = this.$t('modifAnalyseChat')
    },
    // affiche la dialogBox ajout analyse
    addAnalyseChat () {
      this.showDialogAddAnalyseChat = true
      this.modifDialog = false
      this.titleAnalyseChat = this.$t('addAnalyseChat')
    },
    // -------------------------------------------------------------------

    majData (data) {
      for (const index in this.urls) {
        if (this.urls[index].url === data.url) {
          this.urls[index].updated = true
          this.urls[index].error = false
          this.urls[index].new = false
          this.urls[index].locked = data.locked
        }
      }
    },

    majDataURLProduct (data) {
      for (const index in this.URLProducts) {
        if (this.URLProducts[index].url === data.url) {
          this.URLProducts[index].updated = true
          this.URLProducts[index].error = false
          this.URLProducts[index].new = false
          this.URLProducts[index].locked = data.locked
        }
      }
    },

    majDataProduct (data) {
      for (const index in this.products) {
        if (this.products[index].product === data.product) {
          this.products[index].updated = true
          this.products[index].error = false
          this.products[index].new = false
          this.products[index].locked = data.locked
        }
      }
    },

    // -------------------------------------------------------------------
    // update ou ajoute une FAQ à la liste
    // -------------------------------------------------------------------
    majFAQ (data) {
      // console.log('maj faq', data)
      if (data.addFAQ) {
        let faq = {}
        faq.name = data.nameChunk
        faq.question = data.question
        faq.reponse = data.reponse
        faq.index = data.numFAQ
        this.faqs.push(faq)
      } else {
        for (const index in this.faqs) {
          if (this.faqs[index].name === data.nameChunk) {
            this.faqs[index].question = data.question
            this.faqs[index].reponse = data.reponse
          }
        }
      }
      this.numFAQ = this.faqs.length
    },

    // -------------------------------------------------------------------
    // Mise à jour de la liste apres suppression d'une FAQ
    // -------------------------------------------------------------------
    majSuppFAQ (data) {
      // console.log('maj supp  faq', data)
      let newListe = []
      let index = 0
      for (const name of data) {
        let idx = this.faqs.findIndex((element) => element.name === name.oldKey)
        if (idx !== -1) {
          // console.log('il faut changer le nom de cette cles : ', name.oldKey)
          this.faqs[idx].name = name.newKey
          this.faqs[idx].index = index
          newListe.push(this.faqs[idx])
          index++
        } else {
          // console.log('pas dans la liste des faqs')
        }
      }
      // console.log('newliste faqs : ', newListe)
      this.faqs = newListe
      this.numFAQ = this.faqs.length
    },

    // -------------------------------------------------------------------
    // suppression d'une licence et de tous ses elements rattachés
    // -------------------------------------------------------------------
    async submitDeleteLicenceConfirm () {
      // Données modifiées et à renvoyer
      let dataToPost = {}
      // dataToPost.licence = this.siteSelected.LIC_KEY // la licence selectionnée
      dataToPost.licence = '948580a42a7ace75df2befcdf0ec8a81'
      const response = await this.axios.post(this.serveurAI + 'delLicence',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        // suppression live des urls du tablrau urls de vue
        console.log('submitDeleteLicenceConfirm res : ', response.data)
      } else {
        console.log('submitDeleteLicenceConfirm res error : ', response.data)
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des url actives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirm () {
      this.loadingModifUrl = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeDeleteUrls = this.selectedUrls
      const response = await this.axios.post(this.serveurAI + 'delLicenceUrls',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        // suppression live des urls du tablrau urls de vue
        let listDel = this.urlsSupp
        let newListeUrls = this.urls
        for (const selectedUrl of this.selectedUrls) {
          // mise à jour de la liste des urls
          let i = this.urls.findIndex((element) => element.url === selectedUrl.url)
          if (i !== -1) {
            // retire de la luste si il existe
            newListeUrls.splice(i, 1)
          }
          // mise à jour de la liste des urls supprimées
          let a = this.urlsSupp.findIndex((element) => element.url === selectedUrl.url)
          if (a === -1) {
            // ajoute dans la liste si il n'est pas present
            listDel.push({url: selectedUrl.url})
          }
        }
        this.urlsSupp = listDel
        this.urls = newListeUrls
        this.messageResDialog = '<h3>' + this.$t('AIRepResDell') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des produits actives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirmProduct () {
      console.log('selectedProducts', this.selectedProducts)
      this.loadingModifUrl = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeDeleteProducts = this.selectedProducts
      const response = await this.axios.post(this.serveurAI + 'delLicenceProducts',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        // suppression live des urls du tablrau urls de vue
        let listDel = this.productsSupp
        let newListeProducts = this.products
        for (const selectedProduct of this.selectedProducts) {
          // mise à jour de la liste des urls
          let i = this.products.findIndex((element) => element.product === selectedProduct.product)
          if (i !== -1) {
            // retire de la luste si il existe
            newListeProducts.splice(i, 1)
          }
          // mise à jour de la liste des urls supprimées
          let a = this.productsSupp.findIndex((element) => element.product === selectedProduct.product)
          if (a === -1) {
            // ajoute dans la liste si il n'est pas present
            listDel.push({product: selectedProduct.product})
          }
        }
        this.productsSupp = listDel
        this.products = newListeProducts
        this.messageResDialog = '<h3>' + this.$t('AIRepResDell') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des urls produits actives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirmURLProduct () {
      console.log('submitDeleteConfirmURLProduct selectedURLProducts', this.selectedURLProducts)
      this.loadingModifUrl = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeDeleteUrls = this.selectedURLProducts
      const response = await this.axios.post(this.serveurAI + 'delLicenceURLProducts',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        // suppression live des urls du tablrau urls de vue
        console.log('submitDeleteConfirmURLProduct this.URLProductsSupp', this.URLProductsSupp)
        let listDel = this.URLProductsSupp
        let newListeProducts = this.URLProducts
        for (const selectedURLProduct of this.selectedURLProducts) {
          // mise à jour de la liste des urls
          let i = this.URLProducts.findIndex((element) => element.url === selectedURLProduct.url)
          if (i !== -1) {
            // retire de la luste si il existe
            newListeProducts.splice(i, 1)
          }
          // mise à jour de la liste des urls supprimées
          let a = this.URLProductsSupp.findIndex((element) => element.url === selectedURLProduct.url)
          if (a === -1) {
            // ajoute dans la liste si il n'est pas present
            listDel.push({url: selectedURLProduct.url})
          }
        }
        this.URLProductsSupp = listDel
        this.URLProducts = newListeProducts
        this.messageResDialog = '<h3>' + this.$t('AIRepResDell') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des url inactives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirmFAQ () {
      // console.log('this.selectedFaqs', this.selectedFaqs)
      this.loadingModifSuppFAQ = true
      // Données modifiées et à renvoyer
      let req = {}
      req.licence = this.siteSelected.LIC_KEY// le fichier dédié au prompt scripté
      req.listeDeleteFAQ = this.selectedFaqs
      let dataToPost = {}
      dataToPost.data = req
      const response = await this.axios.post(this.serveurAI + 'delChunkFile',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        this.messageResDialog = '<h3>' + this.$t('AIRepResDellFAQ') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifSuppFAQ = false
        this.majSuppFAQ(response.data.data)
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifSuppFAQ = false
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des url inactives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirmSupp () {
      this.loadingModifSuppUrl = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.type = 'suupUrlInactif' // indique qu'il faut vider les url inactives
      dataToPost.licence = this.siteSelected.LIC_KEY + '-inactif'
      dataToPost.listeDeleteUrls = this.selectedSuppUrls
      const response = await this.axios.post(this.serveurAI + 'delLicenceUrlsSupp',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )

      // si la suppression dans redis est OK
      if (response.data.retour) {
        // pour les urls
        let listDel = this.urlsSupp
        // pour les urls produit
        let listDelURLProduct = this.URLProductsSupp
        // suppression live des urls du tableau urls de vue et aussi de URLProducts à finir
        for (const selectedUrl of this.selectedSuppUrls) {
          // pour les urls
          this.urlsSupp.forEach(function (url, index) {
            if (selectedUrl === url) {
              listDel.splice(index, 1)
            }
          })
          // pour les urls produit
          this.URLProductsSupp.forEach(function (url, index) {
            if (selectedUrl === url) {
              listDelURLProduct.splice(index, 1)
            }
          })
        }
        this.urlsSupp = listDel
        this.URLProductsSupp = listDelURLProduct

        this.messageResDialog = '<h3>' + this.$t('AIRepResDell') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifSuppUrl = false
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifSuppUrl = false
      }
    },

    // -------------------------------------------------------------------
    // ajoute des mots clès aux urls selectionnées
    // -------------------------------------------------------------------
    async submitAddKeywords () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedUrls.length
      this.startLoading = 0
      let totalSelectedUrls = this.selectedUrls.length
      let totalTraitementUrls = 0
      let totalTraitementOK = 0
      let totalTraitementKO = 0
      let errorListUrls = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedUrls
      var nameReq = 'tokenize-listeUrls'
      // let prefix = ''
      // uniquement pour le dev
      // ou salaun
      // if (
      //   this.siteSelected.LIC_KEY === '948580a42a7ace75df2befcdf0ec8a81' || this.siteSelected.LIC_KEY === 'b3b0ec8748446e2f486bcc415315ccb7'
      // ) {
      //   nameReq = 'tokenize-listeUrls-api'
      //   // prefix = 'salaun_'
      // }
      console.log('ajout des mots clés', this.selectedUrls)
      for (const selected of this.selectedUrls) {
        console.log('slected url : ', selected)
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeUrls = [selected]
        dataToPost.parsingSelectif = this.parsingSelectif
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        // dataToPost.prefix = prefix
        const response = await this.axios.post(this.serveurAI + nameReq,
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        console.log('tokenize-listeUrls : ', response.data)
        if (response.data.update) {
          this.startLoading++
          // console.log('startLoading', this.startLoading)
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.status) {
            totalTraitementOK++
            let i = this.urls.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.urls[i].updated = true
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.urls[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.urls[i].error = false
              // date de la mise à jour
              this.urls[i].timestamp = moment(Date.now()).format('lll')
            }
          // si il y a une erreur
          } else {
            totalTraitementKO++
            errorListUrls.push(response.data.url) // push l'url
            let i = this.urls.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur d'erreur sur cette url
              this.urls[i].error = true
            }
          }
          console.log('this.urls : ', this.urls)
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedUrls + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResKnow') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResKnowOK') + ' <strong>' + totalTraitementOK + '/' + totalSelectedUrls + '</strong><br>'
        this.messageResDialog += this.$t('AIResKnowKO') + ' <strong>' + totalTraitementKO + '/' + totalSelectedUrls + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const url of errorListUrls) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + url + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        console.log(totalTraitementUrls + ' === ' + this.endLoading)
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des urls en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedUrls = this.selectedUrls
          dataMAJ.errorListUrls = errorListUrls
          // console.log('majErrorListeUrls')
          this.majErrorListeUrls(dataMAJ)
        }
      }
    },

    // -------------------------------------------------------------------
    // ajoute des mots clès aux produits selectionnées
    // -------------------------------------------------------------------
    async submitAddKeywordsProducts () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedProducts.length
      this.startLoading = 0
      let totalSelectedProducts = this.selectedProducts.length
      let totalTraitementProducts = 0
      let totalTraitementOK = 0
      let totalTraitementKO = 0
      let errorListProducts = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts
      var nameReq = 'tokenize-listeProducts-api'
      // let prefix = ''
      // uniquement pour le dev
      // ou salaun
      if (
        this.siteSelected.LIC_KEY === '948580a42a7ace75df2befcdf0ec8a81' || this.siteSelected.LIC_KEY === 'b3b0ec8748446e2f486bcc415315ccb7'
      ) {
        nameReq = 'tokenize-listeProducts-api'
        // prefix = 'salaun_'
      }
      // console.log('ajout des mots clés', this.selectedProducts)
      for (const selected of this.selectedProducts) {
        // console.log('slected url : ', selected)
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeProducts = [selected]
        dataToPost.parsingSelectif = this.parsingSelectif
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        // dataToPost.prefix = prefix
        const response = await this.axios.post(this.serveurAI + nameReq,
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // console.log('tokenize-listeUrls : ', response.data)
        if (response.data.update) {
          this.startLoading++
          // console.log('startLoading', this.startLoading)
          totalTraitementProducts++
          // si pas d'erreur
          if (response.data.status) {
            totalTraitementOK++
            let i = this.products.findIndex((element) => element.product === response.data.product)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.products[i].updated = true
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.products[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.products[i].error = false
              // date de la mise à jour
              this.products[i].timestamp = moment(Date.now()).format('lll')
            }
          // si il y a une erreur
          } else {
            totalTraitementKO++
            errorListProducts.push(response.data.product) // push l'url
            let i = this.products.findIndex((element) => element.product === response.data.product)
            if (i !== -1) {
              // indicateur d'erreur sur cette url
              this.products[i].error = true
            }
          }
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIKnowProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResKnow') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResKnowOK') + ' <strong>' + totalTraitementOK + '/' + totalSelectedProducts + '</strong><br>'
        this.messageResDialog += this.$t('AIResKnowKO') + ' <strong>' + totalTraitementKO + '/' + totalSelectedProducts + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const product of errorListProducts) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + product + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        // console.log(totalTraitementProducts + ' === ' + this.endLoading)
        if (totalTraitementProducts === this.endLoading) {
          // Mise à jour de la liste des produits en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedProducts = this.selectedProducts
          dataMAJ.errorListProducts = errorListProducts
          // this.majErrorListeProducts(dataMAJ)
        }
      }
    },

    // -------------------------------------------------------------------
    // ajoute des mots clès aux urls produits selectionnées
    // -------------------------------------------------------------------
    async submitAddKeywordsURLProducts () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedURLProducts.length
      this.startLoading = 0
      let totalSelectedProducts = this.selectedURLProducts.length
      let totalTraitementUrls = 0
      let totalTraitementOK = 0
      let totalTraitementKO = 0
      let errorListProducts = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedProducts
      var nameReq = 'tokenize-listeUrls'
      console.log('ajout des mots clés', this.selectedURLProducts)
      for (const selected of this.selectedURLProducts) {
        console.log('slected url : ', selected)
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeUrls = [selected]
        dataToPost.parsingSelectif = this.parsingSelectif
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        // dataToPost.prefix = prefix
        const response = await this.axios.post(this.serveurAI + nameReq,
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        console.log('tokenize-listeUrls : ', response.data)
        if (response.data.update) {
          this.startLoading++
          // console.log('startLoading', this.startLoading)
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.status) {
            totalTraitementOK++
            let i = this.URLProducts.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.URLProducts[i].updated = true
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.URLProducts[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.URLProducts[i].error = false
              // date de la mise à jour
              this.URLProducts[i].timestamp = moment(Date.now()).format('lll')
            }
          // si il y a une erreur
          } else {
            totalTraitementKO++
            errorListProducts.push(response.data.url) // push l'url
            let i = this.URLProducts.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur d'erreur sur cette url
              this.URLProducts[i].error = true
            }
          }
          console.log('this.URLProducts : ', this.URLProducts)
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedProducts + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResKnow') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResKnowOK') + ' <strong>' + totalTraitementOK + '/' + totalSelectedProducts + '</strong><br>'
        this.messageResDialog += this.$t('AIResKnowKO') + ' <strong>' + totalTraitementKO + '/' + totalSelectedProducts + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const product of errorListProducts) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + product + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        // console.log(totalTraitementUrls + ' === ' + this.endLoading)
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des produits en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedProducts = this.selectedURLProducts
          dataMAJ.errorListProducts = errorListProducts
          this.majErrorListeUrls(dataMAJ)
        }
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste de fichiers selectionnés
    // -------------------------------------------------------------------
    async majErrorListeUrls (data) {
      let dataToPost = data
      // dataToPost.licence = this.siteSelected.LIC_KEY
      // dataToPost.listeUrls = [selected]
      // dataToPost.method = this.methodSelect
      // dataToPost.parse = this.parseElement
      const response = await this.axios.post(this.serveurAI + 'MajListeErrorUrls',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      console.log('MajListeErrorUrls : ', response.data)
    },

    // -------------------------------------------------------------------
    // verrouille les urls selectionnées
    // -------------------------------------------------------------------
    async submitLockConfirm () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedUrls.length
      this.startLoading = 0
      let totalSelectedUrls = this.selectedUrls.length
      let totalTraitementUrls = 0
      // let totalTraitementOK = 0
      // let totalTraitementKO = 0
      // let errorListUrls = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedUrls
      for (const selected of this.selectedUrls) {
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeUrls = [selected]
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        const response = await this.axios.post(this.serveurAI + 'locked-listeUrls',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        if (response.data.retour) {
          totalTraitementUrls++
          this.startLoading++
          let i = this.urls.findIndex((element) => element.url === response.data.url)
          if (i !== -1) {
            // indicateur d'erreur sur cette url
            this.urls[i].locked = true
          }
        }
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIURLProc') + ' ' + totalTraitementUrls + '/' + totalSelectedUrls + '</p>'
        if (totalTraitementUrls === this.endLoading) {
          this.messageResDialog += '<h3>' + this.$t('AIProcEnd') + ' ' + totalTraitementUrls + '</h3>'
          this.loadingModifUrl = false
        }
      }
    },

    // -------------------------------------------------------------------
    // verrouille les produits selectionnées
    // -------------------------------------------------------------------
    async submitLockConfirmProduct () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedProducts.length
      this.startLoading = 0
      let totalSelectedProducts = this.selectedProducts.length
      let totalTraitementProducts = 0
      // let totalTraitementOK = 0
      // let totalTraitementKO = 0
      // let errorListUrls = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts
      for (const selected of this.selectedProducts) {
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeProducts = [selected]
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        const response = await this.axios.post(this.serveurAI + 'locked-listeProducts',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        if (response.data.retour) {
          totalTraitementProducts++
          this.startLoading++
          let i = this.products.findIndex((element) => element.product === response.data.product)
          if (i !== -1) {
            // indicateur d'erreur sur cette url
            this.products[i].locked = true
          }
        }
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIURLProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts + '</p>'
        if (totalTraitementProducts === this.endLoading) {
          this.messageResDialog += '<h3>' + this.$t('AIProcEnd') + ' ' + totalTraitementProducts + '</h3>'
          this.loadingModifUrl = false
        }
      }
    },

    // -------------------------------------------------------------------
    // verrouille les urls produits selectionnées
    // -------------------------------------------------------------------
    async submitLockConfirmURLProduct () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedURLProducts.length
      this.startLoading = 0
      let totalSelectedProducts = this.selectedURLProducts.length
      let totalTraitementProducts = 0
      // let totalTraitementOK = 0
      // let totalTraitementKO = 0
      // let errorListUrls = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts
      for (const selected of this.selectedURLProducts) {
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeUrls = [selected]
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        const response = await this.axios.post(this.serveurAI + 'locked-listeUrls',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        if (response.data.retour) {
          totalTraitementProducts++
          this.startLoading++
          let i = this.URLProducts.findIndex((element) => element.product === response.data.product)
          if (i !== -1) {
            // indicateur d'erreur sur cette url
            this.URLProducts[i].locked = true
          }
        }
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIURLProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts + '</p>'
        if (totalTraitementProducts === this.endLoading) {
          this.messageResDialog += '<h3>' + this.$t('AIProcEnd') + ' ' + totalTraitementProducts + '</h3>'
          this.loadingModifUrl = false
        }
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste de fichiers selectionnés
    // -------------------------------------------------------------------
    async submitDeleteFileConfirm () {
      this.loadingModifFile = true
      // suppression live des fichiers du tablrau files de vue
      let newListeFiles = this.files
      for (const selectedFile of this.selectedFiles) {
        // console.log('selectedFile', selectedFile)
        this.files.forEach(function (file, index) {
          // console.log('%d: %s', i, url)
          if (selectedFile === file) {
            // console.log('ca match file', index)
            newListeFiles.splice(index, 1)
          }
        })
      }
      this.files = newListeFiles
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeDeleteFiles = this.selectedFiles
      this.axios.post(this.serveurAI + 'delLicenceFiles',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // efface la dialogBox
      this.showDialogDeleteFile = false
      this.selectActionFile = null
      this.loadingModifFile = false
    },

    // ouvre le dialogue de modification les mots clés de la page
    async openDialogUpdateKeyword (data) {
      this.showDialogModifKeyword = true
      this.keywordUrl = data.url
    },
    // ouvre le dialogue de modification les mots clés de l'url du produit
    async openDialogUpdateKeywordURLProduct (data) {
      this.showDialogModifKeywordURLProduct = true
      this.keywordUrl = data.url
    },
    // ouvre le dialogue de modification les mots clés du produit
    async openDialogUpdateKeywordProduct (data) {
      console.log('openDialogUpdateKeywordProduct ', data)
      this.showDialogModifKeywordProduct = true
      this.keywordProduct = data.product
    },
    async openDialogUpdateFAQ (data) {
      this.showDialogModifFAQ = true
      this.questAnsw = data
      this.addFAQ = false
    },
    justCloseDialogKeyword () {
      this.showDialogModifKeyword = false
    },
    justCloseDialogKeywordURLProduct () {
      this.showDialogModifKeywordURLProduct = false
    },
    justCloseDialogKeywordProduct () {
      this.showDialogModifKeywordProduct = false
    },
    justCloseDialogFAQ () {
      this.showDialogModifFAQ = false
    },
    justCloseDialogImportPDF () {
      this.showDialogImportPDF = false
      // il faut rechercher la liste des fichier
    },
    justCloseDialogChunkPDF () {
      this.showDialogChunkPDF = false
    },
    justCloseDialogResume () {
      this.showDialogResume = false
    },
    // ajoute une fonction
    addFunction () {
      if (this.fonctionsNum < 9) {
        this.addFonctionsNum++
      }
    },
    // ajoute une fonction
    addParsing () {
      this.parsingSelectif.push({name: '', methode: '', elements: '', default: false})
    },
    // ouvre le dialogue de modification les FAQ
    async getChunkFiles (data) {
      this.loadingData = true
      let dataToPost = {}
      dataToPost.data = data
      // console.log('getChunkFiles dataToPost : ', dataToPost)
      const response = await this.axios.post(this.serveurAI + 'getChunkFiles',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response.data.retour) {
        // console.log('response : ', response.data.data)

        this.chunks = response.data.data
        // this.loadingData = false
        setTimeout(() => {
          this.loadingData = false
        }, 500)
      }
    },
    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
    },
    delParsing (e) {
      console.log('delete parsing ', e)
      this.SelectedParsingSupp = e
      this.showDialogDeleteParsing = true
    },
    justCloseDialogConfirmParsing () {
      this.showDialogDeleteParsing = false
      this.selectActionParsing = null
      this.SelectedParsingSupp = {}
    },
    submitDeleteParsing () {
      console.log('del pars', this.SelectedParsingSupp)
      if (this.SelectedParsingSupp.name) {
        for (const index in this.parsingSelectif) {
          if (this.parsingSelectif[index] === this.SelectedParsingSupp) {
            console.log('il y a bien un parsing à supprimer', this.parsingSelectif[index].name + ' - ' + index)
            this.parsingSelectif.splice(index, 1)
          }
        }
      }
      this.justCloseDialogConfirmParsing()
    },
    switchComportment () {
      this.comportment ? this.comportment = true : this.comportment = false
    },
    switchExemple () {
      this.showEx ? this.showEx = true : this.showEx = false
    },
    enhance (section) {
      this.selectedEnhanceSection = (typeof section === 'string' && section.length) ? section : 'personality'
      this.showDialogEnhancePrompt = true
    },
    enhanceCsat (section) {
      this.selectedEnhanceCsatSection = (typeof section === 'string' && section.length) ? section : 'personality'
      this.showDialogEnhancePromptCsat = true
    },
    version (section) {
      this.showDialogVersionPrompt = true
    },
    versionCsat () {
      this.showDialogVersionPromptCsat = true
    }
  },
  watch: {
    '$route.query.focus': function () {
      this.$nextTick(() => {
        this.applyRouteFocusPanel()
      })
    },
    '$store.state._Sites.siteSelected': function (val, oldVal) {
      // recupère la liste des urls du client dans redis
      this.loadUrlsClient('actif')
      // recupère la liste des produits du client dans redis
      this.loadProductsClient('actif')
      // recupère la liste des urls produits du client dans redis
      this.loadURLProductsClient('actif')
      // recupère la liste des documents du client dans redis
      this.loadFilesClient(this.siteSelected.LIC_KEY)
      // recupère la liste des FAQ du client dans redis
      this.loadFaqsClient()
      if (this.botUserId) {
        this.getPromptCsat(this.botUserId, this.siteSelected.LIC_KEY)
      }
    },
    dateStartPicker (val, oldVal) {
      // update de la date de début à 00:00:00
      this.$store.commit('_Stats/SET_DATE_START', moment(val, 'YYYY-MM-DD').hours(0).minutes(0).seconds(0).format())
    },
    dateEndPicker (val, oldVal) {
      // update de la date de fin à 23:59:59
      this.$store.commit('_Stats/SET_DATE_END', moment(val, 'YYYY-MM-DD').hours(23).minutes(59).seconds(59).format())
    },
    tokenParams (v) {
      this.getAll()
    },
    period (val, oldVal) {
      // update des dates affichées
      this.initDates()
      // update de la période date dans le store
      this.$store.commit('_Stats/SET_PERIOD', val)
    },
    // au changement d'intervalle, il faut actualiser les series du graphique
    interval: function (val, oldVal) {
      this.updateSeries()
    },
    // au changement d'intervalle, il faut actualiser les series du graphique
    utilisation: function (val, oldVal) {
      // console.log('utilisation interval :', val)
      this.updateSeries()
    },
    loadingPrompt: function (val, oldVal) {
      if (val === false) {
        this.$nextTick(() => {
          this.refreshPromptSystemOpenPanels()
          this.refreshPromptResumeOpenPanels()
          this.refreshPromptCriteriaOpenPanels()
        })
      }
    },
    prompt_personality: function () {
      this.onPromptSectionChanged()
    },
    prompt_environment: function () {
      this.onPromptSectionChanged()
    },
    prompt_objectif: function () {
      this.onPromptSectionChanged()
    },
    prompt_communication: function () {
      this.onPromptSectionChanged()
    },
    prompt_questions: function () {
      this.onPromptSectionChanged()
    },
    prompt_rules: function () {
      this.onPromptSectionChanged()
    },
    prompt_tools: function () {
      this.onPromptSectionChanged()
    },
    prompt_custom: function () {
      this.onPromptSectionChanged()
    }
  }
}
</script>

<style scoped>
  .layout > .flex {
    padding-left: 8px;
    padding-right: 8px;
  }
  .hidden {
    display: none;
  }
  .prompt-system-title {
    text-align: left;
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-size: 17px;
    font-weight: 600;
    color: #0f172a;
  }
  .prompt-section-title {
    text-align: left;
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-size: 17px;
    font-weight: 600;
    color: #0f172a;
  }
  .prompt-llm-title {
    margin-top: 10px;
  }
  .prompt-llm-block {
    margin-top: 24px;
    padding-top: 8px;
  }
  .prompt-system-section h3 {
    text-align: left;
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-weight: 600;
    color: #111827;
  }
  .prompt-system-section /deep/ .v-input .v-label {
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    color: #64748b;
  }
  .prompt-subpanel-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 40px;
    padding: 2px 0 0;
  }
  .prompt-subpanel-title {
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: #111827;
    line-height: 1.3;
  }
  .prompt-subpanel-check {
    display: inline-block;
    margin-left: 8px;
    color: rgb(34, 197, 94);
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    vertical-align: middle;
  }
  .prompt-subpanel-subtitle {
    margin-top: 2px;
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: #64748b;
    line-height: 1.35;
    white-space: normal;
  }
  .prompt-inner-title {
    margin-bottom: 2px;
    font-size: 14px;
  }
  .prompt-inner-subtitle {
    margin-bottom: 8px;
  }
  .prompt-criteria-body {
    padding-top: 10px !important;
  }
  .prompt-criteria-grid {
    align-items: stretch;
  }
  .prompt-criteria-col--left {
    padding-right: 18px;
  }
  .prompt-criteria-col--right {
    padding-left: 18px;
  }
  .prompt-criteria-input-row,
  .prompt-live-input-row {
    margin-top: 8px;
    align-items: stretch;
  }
  .prompt-criteria-live-card {
    height: 100%;
    padding: 18px 18px 14px;
    border: 1px solid #dde5ef;
    border-radius: 12px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  }
  .prompt-live-title {
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }
  .prompt-criteria-chip-list {
    margin-top: 8px;
  }
  .prompt-criteria-chip {
    border: 1px solid #dbe4ef;
    background: #f8fafc !important;
    color: #334155 !important;
  }
  .prompt-criteria-add-btn {
    min-width: 52px !important;
    height: 40px !important;
    margin: 0;
    border: 1px solid #d9e2ec !important;
    border-radius: 12px !important;
    background: #ffffff !important;
    box-shadow: none !important;
    color: #111827 !important;
    font-size: 28px;
    font-weight: 300;
    line-height: 1;
  }
  .prompt-live-test-btn {
    width: 100%;
    height: 40px !important;
    margin: 0;
    border-radius: 12px !important;
    background: linear-gradient(180deg, #a3afc2 0%, #94a3b8 100%) !important;
    box-shadow: none !important;
    color: #ffffff !important;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 600;
  }
  .prompt-live-test-btn /deep/ .v-icon {
    color: #ffffff !important;
  }
  .prompt-top-action-btn {
    height: 36px !important;
    margin-left: 8px;
    border-radius: 10px !important;
    background: linear-gradient(180deg, #a3afc2 0%, #94a3b8 100%) !important;
    box-shadow: none !important;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 600;
  }
  .prompt-top-action-btn /deep/ .v-icon {
    color: #ffffff !important;
  }
  .prompt-top-icon-btn {
    margin-left: 6px;
    width: 30px !important;
    height: 30px !important;
    min-width: 30px !important;
    border-radius: 8px !important;
    background: #f8fafc !important;
    border: 1px solid #d9e2ec !important;
    box-shadow: none !important;
    overflow: hidden;
  }
  .prompt-top-icon-btn::before {
    display: none !important;
  }
  .prompt-top-icon-btn /deep/ .v-icon {
    color: #64748b !important;
    font-size: 16px !important;
  }
  .prompt-top-icon-btn:hover {
    background: #eef2f7 !important;
  }
  .prompt-system-section /deep/ .prompt-criteria-input .v-input__slot,
  .prompt-system-section /deep/ .prompt-live-input .v-input__slot {
    min-height: 40px !important;
    height: 40px !important;
    border: 1px solid #d9e2ec !important;
    border-radius: 12px !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }
  .prompt-system-section /deep/ .prompt-criteria-input.v-text-field,
  .prompt-system-section /deep/ .prompt-live-input.v-text-field {
    margin-top: 0;
    padding-top: 0;
  }
  .prompt-system-section /deep/ .prompt-criteria-input .v-input__control,
  .prompt-system-section /deep/ .prompt-live-input .v-input__control {
    min-height: 40px !important;
  }
  .prompt-system-section /deep/ .prompt-criteria-input .v-text-field__slot,
  .prompt-system-section /deep/ .prompt-live-input .v-text-field__slot {
    display: flex;
    align-items: center;
  }
  .prompt-system-section /deep/ .prompt-criteria-input input,
  .prompt-system-section /deep/ .prompt-live-input input {
    color: #475569;
    font-size: 14px;
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  }
  .prompt-panel-body-tight {
    padding-top: 0 !important;
  }
  .prompt-system-section /deep/ .v-textarea textarea {
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-size: 15px;
    line-height: 1.45;
    color: #111827;
  }
  .prompt-system-section /deep/ .prompt-custom-textarea textarea {
    resize: vertical !important;
    overflow: auto !important;
  }
  .prompt-system-section /deep/ .prompt-subpanels .v-card__text {
    padding-top: 2px;
    padding-bottom: 10px;
  }
  .prompt-system-section /deep/ .prompt-subpanels .v-expansion-panel__container {
    margin: 0;
  }
  .prompt-system-section /deep/ .prompt-subpanels .v-expansion-panel__header {
    padding-top: 6px;
    padding-bottom: 4px;
    min-height: 44px;
  }
  .prompt-system-section /deep/ .prompt-subpanels .v-input {
    margin-top: 0;
    padding-top: 0;
  }
  .prompt-system-section /deep/ .v-textarea .v-input__slot {
    border: 1px solid #d7e0ea !important;
    border-radius: 8px !important;
    background: #ffffff;
  }
  .prompt-system-section /deep/ .v-input__append-outer .v-icon {
    font-size: 16px !important;
    color: #94a3b8 !important;
  }
  .prompt-token-hint {
    margin-top: -4px;
    font-size: 11px;
    color: #94a3b8;
    text-align: left;
  }
  .prompt-subpanel-check-icon {
    font-size: 14px !important;
    margin-left: 6px;
    color: rgb(34, 197, 94) !important;
    vertical-align: middle;
  }
  .prompt-subpanel-draft-inline {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: 6px;
    vertical-align: middle;
  }
  .prompt-subpanel-draft-icon {
    font-size: 12px !important;
    color: #94a3b8 !important;
  }
  .prompt-subpanel-draft-text {
    font-size: 10px;
    line-height: 1;
    color: #94a3b8;
    text-transform: lowercase;
  }
  .prompt-subpanel-draft-cancel {
    border: none;
    background: transparent;
    padding: 0;
    margin: 0 0 0 2px;
    font-size: 10px;
    line-height: 1;
    color: #94a3b8;
    text-decoration: underline;
    cursor: pointer;
  }
  .prompt-subpanel-draft-cancel:hover {
    color: #64748b;
  }
  .prompt-block-spaced {
    margin-top: 24px;
  }
  .prompt-block-spaced-lg {
    margin-top: 36px;
  }
  .prompt-block-spaced-xl {
    margin-top: 72px;
    padding-top: 16px;
  }
  .prompt-version-meta-block {
    margin-top: 56px;
    padding-top: 12px;
  }
  .prompt-tools-block {
    margin-top: 72px;
    padding-top: 14px;
  }
  .prompt-tool-add-btn {
    margin-top: 8px;
    margin-left: 0;
    min-width: 0;
    border: 1px dashed #c7d2fe !important;
    border-radius: 999px !important;
    background: #ffffff !important;
    box-shadow: none !important;
    color: #4f46e5 !important;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 500;
  }
  .prompt-tool-add-btn:hover {
    background: #f8faff !important;
  }
  .prompt-tool-picker {
    margin-top: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 14px !important;
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
    overflow: hidden;
  }
  .prompt-tool-picker__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px 8px;
  }
  .prompt-tool-picker__title {
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: #334155;
  }
  .prompt-tool-picker__close {
    margin: 0 !important;
    color: #98a2b3 !important;
  }
  .prompt-tool-picker__body {
    max-height: 360px;
    overflow-y: auto;
    padding-bottom: 8px;
  }
  .prompt-tool-picker__section-title {
    padding: 8px 14px;
    background: #f8fafc;
    border-top: 1px solid #eef2f7;
    border-bottom: 1px solid #eef2f7;
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #94a3b8;
    text-transform: uppercase;
  }
  .prompt-tool-picker__list {
    background: #ffffff;
  }
  .prompt-tool-picker__item {
    min-height: 46px;
    padding-left: 4px;
    padding-right: 8px;
    transition: background-color 0.15s ease;
  }
  .prompt-tool-picker__item:hover {
    background: #fafbff;
  }
  .prompt-tool-picker__item-icon {
    min-width: 36px;
  }
  .prompt-tool-picker /deep/ .v-list__tile__title {
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-size: 15px;
    color: #1e293b;
  }
  .prompt-slider-label {
    min-height: 20px;
    padding-top: 0;
    padding-bottom: 2px;
    margin-bottom: -6px;
  }
  .prompt-subheader-tight {
    min-height: 20px;
    padding-top: 0;
    padding-bottom: 0;
    margin-bottom: -10px;
  }
  .prompt-system-section /deep/ .prompt-slider-tight {
    margin-top: 0;
    padding-top: 0;
  }
  .save-prompt-actions {
    margin-top: 24px;
  }
  .save-prompt-btn {
    width: 100%;
    margin: 0;
    border: 1px solid #d1d5db !important;
    box-shadow: none !important;
    color: #111827 !important;
    text-transform: none;
    letter-spacing: 0;
  }
  .save-prompt-btn /deep/ .v-btn__content {
    justify-content: center;
  }
  .save-prompt-btn--ready {
    background: rgb(249, 250, 251) !important;
  }
  .save-prompt-btn--idle {
    background: rgb(243, 244, 246) !important;
    color: #9ca3af !important;
    border-color: #e5e7eb !important;
  }
  .knowledge-nested-panels {
    margin-top: 8px;
    padding: 6px 10px 10px 14px;
    background: #f8fafc;
    border-left: 2px solid #dbe4ef;
    border-radius: 10px;
  }
  .knowledge-nested-panels /deep/ .v-expansion-panel__container {
    margin-bottom: 10px;
    border: 1px solid #e6edf5;
    border-radius: 10px !important;
    background: #ffffff;
    overflow: hidden;
    box-shadow: none;
  }
  .knowledge-nested-panels /deep/ .v-expansion-panel__container:last-child {
    margin-bottom: 0;
  }
  .knowledge-nested-panels /deep/ .v-expansion-panel__header {
    min-height: 48px;
    padding: 10px 16px;
    background: #fcfdff;
  }
  .knowledge-nested-panels /deep/ .v-expansion-panel__header > div {
    font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #334155;
  }
  .tool-option-selected {
    background: #f8faff;
  }
</style>



// WEBPACK FOOTER //
// src/components/botbuilder/openAIConfig.vue